import React, { useEffect, useState } from 'react';
import i18next from 'i18next';
import ApiUrls from '../../services/apiUrls';
// import SnackbarProvider from 'react-simple-snackbar';

const regions = {
  ARICA_AND_PARINACOTA_REGION: {
    en: 'Arica and Parinacota Region',
    es: 'Región de Arica y Parinacota',
  },
  TARAPACA_REGION: {
    en: 'Tarapacá Region',
    es: 'Región de Tarapacá',
  },
  ANTOFAGASTA_REGION: {
    en: 'Antofagasta Region',
    es: 'Región de Antofagasta',
  },
  ATACAMA_REGION: {
    en: 'Atacama Region',
    es: 'Región de Atacama',
  },
  COQUIMBO_REGION: {
    en: 'Coquimbo Region',
    es: 'Región de Coquimbo',
  },
  SANTIAGO_METROPOLITAN_REGION: {
    en: 'Santiago Metropolitan Region',
    es: 'Región Metropolitana de Santiago',
  },
  O_HIGGINS_REGION: {
    en: "O'Higgins Region",
    es: "Región de O'Higgins",
  },
  MAULE_REGION: {
    en: 'Maule Region',
    es: 'Región del Maule',
  },
  //   MAULE_REGION: {
  //     en: 'Ñuble Region',
  //     es: 'Región de Ñuble',
  //   },
  VALPARAISO_REGION: {
    en: 'Valparaíso Region',
    es: 'Región de Valparaíso',
  },
  SANTIAGO_METROPOLITAN: {
    en: 'Santiago Metropolitan Region',
    es: 'Región Metropolitana de Santiago',
  },
  NUBLE_REGION: {
    en: 'Ñuble Region',
    es: 'Región del Ñuble',
  },
  BIOBIO_REGION: {
    en: 'Biobío Region',
    es: 'Región del Biobío',
  },
  ARAUCANIA_REGION: {
    en: 'Araucanía Region',
    es: 'Región de la Araucanía',
  },
  LOS_RIOS_REGION: {
    en: 'Los Ríos Region',
    es: 'Región de Los Ríos',
  },
  LOS_LAGOS_REGION: {
    en: 'Los Lagos Region',
    es: 'Región de Los Lagos',
  },
  AYSEN_REGION: {
    en: 'Aysén Region',
    es: 'Región de Aysén',
  },
  MAGALLANES_REGION: {
    en: 'Magallanes Region',
    es: 'Región de Magallanes',
  },
};
const SvgMap = ({ apiCall, setAgenciesArr, setLoading }) => {
  const [selectedRegion, setSelectedRegion] = useState('ARICA_AND_PARINACOTA_REGION');

  useEffect(() => {
    onMapClick('ARICA_AND_PARINACOTA_REGION');
    //     setSelectedRegion['LOS_LAGOS_REGION'];
  }, []);

  const onMapClick = region => {
    setLoading(true);
    apiCall({
      url: ApiUrls.getAcencies(regions[region][i18next.language], i18next.language),
      method: 'GET',
    })
      .then(res => {
        setLoading(false);
        setAgenciesArr(res.data);
      })
      .catch(err => {
        setLoading(false);
        setAgenciesArr([]);
      });
  };

  return (
    <div className="common-svg-map">
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="280px"
        height="550px"
        viewBox="0 0 350 870"
        style={{ enableBackground: 'new 0 0 350 870' }}
      >
        <path class="st0" d="M136.2,555.1C136.3,555.1,136.2,555,136.2,555.1L136.2,555.1z" />
        <path class="st0" d="M136.2,555.1L136.2,555.1L136.2,555.1L136.2,555.1z" />
        <path
          class="st0"
          d="M137.6,660.6c-0.3,0-0.5,0.1-0.7,0c-0.8-0.1-1.4-0.3-2.3-0.1c-0.6,0.1-1.1,0.4-1.7,0.5
	c-1.3,0.5-2.6,1.4-3.5,2.4c-0.6,0.6-1,1.4-1.7,2c-0.5,0.4-2.3,1.5-2.9,1.1c-1-0.6,1.1-2.1,1.6-2.4c0.9-0.5,1.9-0.9,2.7-1.5
	c0.7-0.5,1.2-1.1,1.9-1.6C132.5,660.3,137.5,657.6,137.6,660.6z"
        />
        <g className="a1 region">
          <polygon class="st1" points="133.7,530.2 133.7,530.2 133.6,530.2 133.6,530.2 	" />
          <path
            class={`st1 ${selectedRegion === 'LOS_LAGOS_REGION' && 'selected-region'}`}
            onClick={() => {
              setSelectedRegion('LOS_LAGOS_REGION');
              onMapClick('LOS_LAGOS_REGION');
            }}
            d="M133.7,531c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.1,0.2-0.2,0.2c-0.3,0.4-0.7,1-1.2,1.3
		c-0.8,0.5-1.7,0.7-2.8,0.7h-0.4c-0.3,0-0.6,0-0.9,0c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.4c-0.8,1-1.6,2-3.1,2.6
		c-1.2,0.4-2,0.2-2.8,0.1l-0.5-0.1c-0.3-0.1-0.7,0-1.1,0.1c-0.5,0.1-1,0.2-1.6,0.1c-0.8-0.1-1.3-0.4-1.6-0.7
		c-0.4-0.3-0.7-0.5-1.1-0.7c-1.7-1-3.3-1.4-4.6-1.4c-0.6,0-1.3,0.2-1.8,0.4c-0.2,0.1-0.3,0.2-0.5,0.3c-0.3,0.2-0.5,0.3-0.8,0.4
		c-0.9,0.4-1.9,0.4-2.7,0.5c-0.4,0-0.8,0-1.2,0.1c-0.7,0.1-1.4,0.1-2.1,0.1c-0.5,0-1,0-1.4,0c-0.2,0-0.5,0-0.7,0.1
		c-0.4,0-1,0.1-1.4,0.2c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.2,0.1,0.3,0.2,0.5c0.4,0.8,0.6,1.7,0.7,2.5v0.1
		v0.1c-0.1,0.3-0.1,0.6,0,1c0,0.2,0.3,0.5,0.4,0.7c0.3,0.5,0.6,0.8,1,1.1s0.7,0.7,1,1.1c0.7,1,1.3,2.1,1.6,3.1
		c0.1,0.3,0.1,0.6,0.2,0.9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.2,0.5,0.3,0.8c0.1,0.3,0.3,0.6,0.3,0.9c0.2,0.9,0.1,1.6,0,2.3l-0.1,0.4
		c0,0.1,0,0.3,0,0.4c-0.1,0.7-0.2,1.4-0.8,2c-0.8,0.8-2.2,0.7-3.1,0.2c-0.7-0.3-1.2-0.9-1.6-1.4l0,0l-0.2-0.3l0,0l0.4-0.2l-0.4,0.1
		c0-0.1-0.3-0.7-0.4-0.8h-0.1c-0.1,0.2-0.1,0.6,0,1c0.2,1,0.2,2,0.2,3c0,0.9,0,1.8,0,2.7c0,0.7-0.1,1.4-0.2,2
		c-0.1,0.7-0.2,1.3-0.1,1.9c0,0.8-0.1,1.6-0.1,2.4c-0.1,0.6-0.1,1.2-0.1,1.8c0,0.4,0,0.9-0.1,1.3c-0.1,0.9-0.1,1.7,0,2.6
		c0.2,1.3,0.1,2.7,0,3.7c0,0.4-0.1,0.7-0.1,1.1c-0.1,1-0.1,2-0.4,2.9c-0.2,0.9-0.7,1.5-1.2,2.1c-0.1,0.2-0.3,0.4-0.4,0.6
		c-0.4,0.6-0.8,1.3-1.1,2.1c-0.4,0.9-0.4,1.5-0.1,2c0,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.1,0.2,0.2,0.4
		c0.1,0.1,0.1,0.3,0.2,0.3c0.3,0.2,0.8,0.2,1.3,0.2c0.6,0,1.2,0,1.7,0.3c0.6,0.3,1,0.8,1.3,1.3c0.2,0.3,0.4,0.6,0.7,0.8
		c0.3,0.3,0.7,0.5,1,0.7c0.2,0.1,0.5,0.3,0.7,0.4c0.9,0.6,1.9,1.1,3.1,1c0.7-0.1,1.8-0.7,1.8-1.5c0-0.4-0.2-1-1.1-2.1
		c-1.3-1.6-2.7-4.7-1-6.8c0.4-0.5,1.1-0.8,1.8-1.2c1.3-0.6,1.9-1,1.7-1.7c-0.1-0.3-0.3-0.5-0.5-0.7s-0.5-0.5-0.6-0.9
		c-0.1-0.3-0.2-0.6-0.3-0.8c-0.1-0.3-0.2-0.6-0.4-0.9c-0.1-0.1-0.3-0.3-0.4-0.5c-0.6-0.6-1.4-1.5-0.9-2.5c0.2-0.5,0.9-0.8,1.4-1
		c0.2-0.1,0.4-0.2,0.5-0.2c0.3-0.2,0.4-0.3,0.4-0.3s-0.1-0.1-0.2-0.3c-0.2-0.3-0.5-0.5-0.8-0.8c-0.5-0.4-1-0.8-1.1-1.4
		c-0.2-1.1,0.4-1.9,0.9-2.4c0.3-0.3,0.4-0.5,0.6-0.9c0.1-0.2,0.3-0.5,0.4-0.7c0.3-0.4,0.7-0.6,1-0.8c0.2-0.1,0.4-0.2,0.6-0.4
		c0.5-0.5,0.8-2,0.8-2.8c-0.1-0.6-0.3-1-0.8-1.5c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3-0.2-0.6-0.3-0.8-0.6c-0.2-0.3-0.6-1.4-0.6-2.1l0,0
		c-0.3-1.6-0.3-3.4,1.4-4.9l0.4-0.3l0.3,0.4c0.3,0.3,1.2,0.2,1.9,0c0.4-0.1,0.8-0.2,1.1-0.2c1,0,1.9-0.1,2.4-0.8
		c0.3-0.4,0.3-1,0.3-1.7c0-0.5,0-0.9,0.1-1.4c0.2-0.6,0.4-1.2,0.7-1.7c0.1-0.6,0.4-1.1,0.9-1.4l0.2-0.1c0.8-0.2,1.4,0.4,1.8,0.9
		c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.2,0.4,0.3,0.7,0.4c0.3,0.2,0.6,0.3,0.9,0.6c0.2,0.2,2.1,1.8,2.4,3.1c0.2,0.6-0.1,1.9-0.3,2.4
		c-0.1,0.3-0.3,0.5-0.5,0.7c-0.1,0.1-0.2,0.2-0.3,0.4c-0.2,0.3-0.2,0.6-0.3,1v0.3c0,0.2-0.1,0.4-0.1,0.6c-0.1,0.5-0.3,1.2-0.2,1.6
		c0.1,0.2,0.2,0.4,0.3,0.4c0.3,0.1,0.9-0.2,1.4-0.4s0.9-0.4,1.3-0.5h0.3l0.2,0.2c0.3,0.6,0.2,1.1,0,1.5c-0.1,0.2-0.1,0.3-0.1,0.5
		c0,0.3,0,0.6,0,0.9c0,0.2,0,0.4,0,0.5c0,0.3,0,0.6,0,1c0.1,0.9,0.1,1.7-0.1,2.5l-0.1,0.2l-0.2,0.1c-0.6,0.3-1.1-0.2-1.4-0.4
		c-0.1-0.1-0.1-0.1-0.2-0.2c-0.3-0.2-0.5-0.3-0.9-0.6s-0.7-0.4-0.8-0.4c-0.1,0-0.3,0.2-0.3,0.6c-0.2,0.8-0.2,1.6-0.1,2.5
		c0,0.3,0,0.7,0,1c0,0.2,0,0.5,0,0.8c0.1,0.8,0.1,1.7-0.1,2.4l-0.1,0.3l-0.3,0.1c-0.3,0.1-0.5,0-0.7,0s-0.4,0-0.5,0
		c-0.3,0.1-0.4,0.6-0.5,1l-0.1,0.2c-0.4,1.3-0.6,3.2,0,4.7c0.1,0.4,0.3,0.8,0.5,0.8s0.4,0,0.6,0c0.3,0,0.6,0,0.9,0
		c0.6,0.1,1.7,0.6,2.1,1.5c0.3,0.9-0.3,1.6-0.7,2l-0.2,0.2c-0.2,0.3-0.5,0.6-0.8,0.9l-0.2,0.1c-0.4,0.2-0.8,0.2-1.3,0.1
		c-0.1,0.1-0.4,0.3-0.6,0.9c-0.2,0.6-0.1,1.3,0,2c0.1,0.6,0.2,1.3,0.1,2c-0.2,1.2-0.8,1.5-1.4,1.9c-0.2,0.1-0.4,0.2-0.6,0.4
		c-0.3,0.2-0.8,1-1,1.5c-0.4,0.8,0.5,3.3,1,4.7c0.2-0.2,0.5-0.3,0.8-0.3c0.2,0,0.6-0.1,1-0.2c0.6-0.1,1.3-0.3,2.2-0.2l0.4,0.1
		c0.3,0,0.5,0.1,0.7,0.1h0.2c0.3,0,0.7-0.1,1.1,0.1c0.9,0.3,1.2,1.1,1.4,1.5c0,0.1,0.1,0.2,0.1,0.3c0.4,0.5,0.9,0.8,1,0.7
		s0.3-0.2,0.4-0.3c0.4-0.3,0.7-0.6,1.2-0.8c0.3-0.1,0.8-0.2,1.2-0.2c0.7,0,1.5,0.2,2,0.7c0.5,0.4,0.7,1,0.8,1.4
		c0.1,0.2,0.1,0.3,0.2,0.5c0.3,0.5,0.6,0.9,1,1.4l0.4,0.5c0.2,0.3,0.4,0.4,0.8,0.6l0.2,0.1c0.2,0.1,0.4,0.3,0.6,0.5
		c0.2,0.2,0.4,0.3,0.5,0.3c0.7,0.1,1.3,0.4,1.9,0.6l0.3,0.1c0.5,0.2,0.9,0.6,1.1,0.8c0.1,0.1,0.2,0.2,0.3,0.2
		c0.1,0.1,0.2,0.1,0.5,0.1c-0.1-0.3-0.2-0.7-0.3-1c-0.2-0.5-0.3-0.9-0.4-1.5c-0.1-0.5,0.1-1.2,0.2-1.7c0-0.1,0.1-0.3,0.1-0.4
		c0.1-0.7,0.2-1.2,0.2-1.9c0-0.1,0-0.3,0-0.4c0-0.4,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.5-0.4-0.7c-0.1-0.2-0.2-0.4-0.3-0.6
		c-0.1-0.1-0.1-0.3-0.2-0.5c-0.1-0.2-0.2-0.5-0.3-0.6s-0.2-0.2-0.4-0.2c-0.3-0.2-0.6-0.3-0.8-0.6c-0.3-0.4-0.2-1.9-0.1-2.2
		c0.1-0.3,0.3-0.5,0.5-0.7c0.1-0.1,0.1-0.1,0.2-0.2c1-1.1,1.4-2.4,1.2-3.7c0-0.1-0.1-0.3-0.1-0.6c-0.1-0.5-0.2-1.9-0.6-2.1
		c0,0,0,0-0.1,0c-0.2,0.1-0.5,0.4-0.7,0.8c-0.5,0.7-1.1,1.5-2.1,1.3c-1.3-0.2-1.7-1.8-1.7-2.7c-0.1-1.3-0.4-2.7-1.1-4.3l-0.1-0.3
		c-0.3-0.7-0.8-1.7-0.4-2.7c0.2-0.4,0.5-0.6,0.7-0.8c0.2-0.1,0.3-0.3,0.4-0.4c0.1-0.2,0.1-0.5,0.1-0.8s0-0.5,0.1-0.7
		c0.2-0.7,0.3-1.4,0.3-1.9c0.2-1.6,0.1-3.2-0.4-4.8c-0.1-0.5-0.3-0.9-0.5-1.3c0-0.1-0.2-0.2-0.3-0.4c-0.2-0.3-0.5-0.5-0.5-0.8
		c-0.1-0.5,0.1-1.1,0.2-1.5c0.2-0.5,0.4-0.8,0.8-0.9c0.5-0.2,1,0.1,1.5,0.3c0.2,0.1,0.4,0.2,0.5,0.3c0.8,0.3,2.3,0.4,2.8-0.2
		c0.6-0.7,0.1-2.1-0.3-3.2c-0.2-0.4-0.3-0.9-0.4-1.2c-0.1-0.6-0.1-1,0.2-1.3c0,0,0.1-0.1,0.2-0.1c-0.1-0.7-0.3-1.4-0.5-2.1
		c-0.4-1.3-0.7-2.7-0.8-4.2c-0.1-0.9,0.1-1.7,0.2-2.5c0-0.3,0.1-0.5,0.1-0.8c0.1-0.6,0.1-1.2,0-1.9c0-0.3,0-0.6,0-0.9
		c0-1-0.1-2-0.3-3c-0.1-0.7-0.2-1.4-0.3-2.2c0-0.4-0.1-0.9-0.1-1.3c0-0.7-0.1-1.5-0.2-2.2c-0.1-0.6-0.1-1.3,0-1.9
		C133.7,531.4,133.7,531.2,133.7,531z"
          />
        </g>
        <path
          onClick={() => {
            setSelectedRegion('ANTOFAGASTA_REGION');
            onMapClick('ANTOFAGASTA_REGION');
          }}
          class={`st1 a2 region ${selectedRegion === 'ANTOFAGASTA_REGION' && 'selected-region'}`}
          d="M202.1,83.9c-0.2,0.2-0.4,0.5-0.6,0.7c-0.1,0.2-0.3,0.5-0.7,0.8c-0.1,0.1-0.3,0.1-0.4,0.2
	c-0.1,0.1-0.2,0.3-0.3,0.4c-0.3,0.2-0.6,0.5-0.9,0.7l-0.6,0.4c-0.6,0.4-1.3,0.9-2,1.3c-0.5,0.3-0.9,0.5-1.4,0.7
	c-0.4,0.2-0.7,0.3-1.1,0.5c-0.4,0.2-0.8,0.4-1.2,0.5c-0.2,0.1-0.5,0.1-0.7,0.2s-0.4,0.2-0.6,0.3c-0.4,0.3-0.9,0.5-1.4,0.7
	c-1.2,0.4-2.1,0.6-3,0.9c-0.4,0.1-0.9,0.2-1.4,0.2c-0.5,0.1-1,0.1-1.4,0.3c-0.3,0.1-0.5,0.4-0.8,0.8c-0.9,1.1-1.8,2.2-2.9,2.9
	c-0.5,0.3-1,0.3-1.4,0.2c-0.8-0.2-1.1-0.9-1.3-1.3l-0.2-0.3l0,0c-0.1,0-0.2-0.1-0.3-0.2c-0.2-0.2-0.5-0.4-0.7-0.6
	c-0.1-0.1-0.3-0.3-0.3-0.3c-0.1,0-0.2-0.1-0.4-0.1c-0.3-0.1-0.7-0.2-1.1-0.5c-0.3-0.2-0.6-0.5-0.7-0.7l-0.1-0.2
	c-0.3-0.4-0.5-0.4-1.1-0.6c-0.3-0.1-0.6-0.2-0.9-0.3c-1.2-0.5-2-0.8-2.9-0.8c0,0.1,0,0.1,0,0.2c-0.1,0.5-0.1,1-0.1,1.5s0,1-0.1,1.5
	c-0.2,1.4-0.2,2.7-0.2,4c0,0.4,0,0.6,0.1,0.7c0.1,0.3,0.1,0.5-0.1,1.2c-0.2,1.1-0.5,2.1-0.8,3.2c-0.2,0.7-0.4,1.4-0.6,2.1
	c-0.2,0.9-0.3,1.9-0.5,2.9l-0.1,0.8c-0.2,1.6-0.5,3.7-0.8,5.5c-0.1,0.4-0.2,0.8-0.2,1.2c-0.2,0.8-0.4,1.7-0.5,2.5
	c-0.2,1.1-0.2,2.3-0.2,3.5c0,0.8,0,1.6-0.1,2.4c-0.1,1-0.1,1.9-0.6,2.8c-1,2-2.4,1.4-3.5,0.9c-0.1,0-0.2-0.1-0.3-0.1
	c-0.2,0.2-0.4,0.3-0.5,0.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.3-0.6,1.3-0.7,2c-0.1,1.3-0.2,2.6-0.3,3.9c0,0.8,0.1,1.4,0.4,1.7
	c0.1,0.1,0.1,0.1,0.4,0.1c0.2,0,0.4,0,0.7,0c1.3,0.2,1.2,1.3,1.2,2c0,0.1,0,0.3,0,0.4c0,0.6-0.2,1.1-0.3,1.6
	c-0.1,0.4-0.2,0.8-0.3,1.2c0,0.3-0.1,0.7-0.1,1c-0.1,0.4-0.1,0.8-0.1,1.2c-0.1,1,0,2,0,3c0,0.4,0,0.8,0,1.2c0,1-0.1,2.1-0.2,3.1
	c0,0.3-0.1,0.6-0.1,0.9c0,0.5-0.1,1-0.1,1.5c0,0.9-0.1,1.7-0.2,2.6c-0.1,0.6-0.2,1.2-0.4,1.8c-0.3,1.3-0.6,2.6-0.4,3.9
	c0.1,1,0.3,2,0.6,2.7c0.2,0.6,0.5,1.1,0.9,1.7c0.4,0.6,0.8,1.3,1,2.1c0.5,1.9,0,3.9-0.5,5.8c-0.4,1.7-0.8,3.3-0.6,4.7
	c0.1,1-0.2,1.9-0.6,2.6c-0.2,0.3-0.3,0.6-0.4,0.9c-0.3,0.6-0.6,1.2-1,1.8c-0.2,0.3-0.4,0.6-0.6,0.9c-0.2,0.4-0.4,0.7-0.7,1.1
	c-0.1,0.2-0.3,0.4-0.5,0.6c-0.4,0.4-0.8,0.9-1,1.3c-0.3,0.9,0,2.1,0.6,2.7c1.1,1.1,1.9,2.1,2.1,3.1c0.2,0,0.4,0,0.6,0
	c0.1,0,0.3,0,0.4,0c0.4-0.1,0.8-0.2,1.3-0.4c0.6-0.2,1.2-0.5,1.9-0.6c0.9-0.1,1.7-0.3,2.4-0.8l0.2-0.1c0.3-0.2,0.7-0.5,1.3-0.5
	c0.2,0,0.4,0,0.7,0.1c0.4,0.1,0.8,0.3,1.1,0.4c0.2,0.1,0.4,0.2,0.5,0.2c0.5,0.2,1,0.4,1.5,0.6c0.7,0.3,1.4,0.6,2.1,0.7
	c1.2,0.2,2.5,0.5,3.5,0.5c0.7,0,1.4-0.4,2.2-0.9c0.5-0.3,0.9-0.4,1.2-0.5c0.2,0,0.3-0.1,0.5-0.1c0.2-0.1,0.6-0.3,0.8-0.5
	c0.2-0.1,0.5-0.3,0.7-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0.4-0.2,0.8-0.5,1.2-0.7c0.6-0.2,1.1-0.2,1.5-0.2h0.3c1.4,0,1.9-0.2,2.5-0.8
	c0.4-0.5,0.7-1.1,1-1.8c0.1-0.3,0.3-0.7,0.4-1c0.2-0.5,0.4-1.5,0.4-2.2V184c0-0.9,0-1.9,0.6-2.8c0.9-1.4,2.4-2,4.2-1.8
	c0.4,0,0.8,0.2,1.1,0.3c0.2,0.1,0.4,0.1,0.5,0.1c0.5,0,1,0,1.5,0h0.5c0.4,0,0.7,0.1,1.1,0.1c0.2,0.1,0.4,0.1,0.5,0.1h0.1
	c0.1-0.4,0.2-0.7,0.3-1c0.1-0.2,0.2-0.5,0.3-0.8c0.2-0.5,0.3-1,0.5-1.4l0.3-0.5c0.2-0.4,0.4-0.7,0.6-1.1c0.3-0.5,0.7-0.9,1.1-1.3
	c0.3-0.2,0.5-0.5,0.8-0.8c0.6-0.8,1-1.5,1.1-2.3c0.2-0.9-0.1-1.2-0.9-2c-0.2-0.2-0.3-0.3-0.5-0.5c-0.5-0.4-1-0.9-1.3-1.6
	c-0.8-1.5-1-2.3-1-2.9c0.3-1.5,2-2.4,3.4-3c0.4-0.2,0.7-0.3,1-0.5c0.5-0.3,1.1-0.6,1.6-0.9c1.1-0.6,2.2-1.2,3.3-1.9
	c0.4-0.3,0.9-0.5,1.3-0.7c0.5-0.2,0.9-0.4,1.3-0.7c0.2-0.1,0.3-0.2,0.5-0.3c0.5-0.4,1-0.7,1.6-1c0.7-0.2,1.4-0.4,2.1-0.5
	c0.5-0.1,1-0.2,1.6-0.4c0.4-0.1,0.7-0.2,1.1-0.3c0.7-0.2,1.5-0.4,2.2-0.6c2.2-0.5,3.5-1.1,4.5-2.8c0.5-0.8,0.6-1.4,0.6-2.4
	c0-0.7,0.2-1.5,0.3-2.2c0.1-0.4,0.1-0.9,0.2-1.3v-0.2c0.2-1.8,0.5-3.6,1.1-5.3c0.6-1.5,1.5-3,2.8-4.7c0.3-0.3,0.5-0.6,0.8-1
	c0.4-0.5,0.8-0.9,1.1-1.4c0.2-0.2,0.4-0.5,0.5-0.7c0.2-0.2,0.4-0.5,0.5-0.7c0.4-0.6,0.7-1.9,0.5-2.5c-0.1-0.3-0.4-1-1.4-2.2
	c-1.1-1.2-2.8-1.4-4.3-1.4c-0.3,0-0.6,0-1,0s-0.7,0-1.1,0c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.5,0.1-0.8,0.1c-1,0.1-2.1,0.1-3.2,0
	c-0.9-0.1-1.7-0.1-2.6,0c-0.2,0-0.3,0-0.5,0.1c-0.6,0.1-1.3,0.2-1.9-0.4c-0.6-0.6-0.9-1.8-1-2.6c-0.2-1-0.1-1.9,0-2.9
	c0.1-1.1,0.1-2.2-0.2-3.3l-0.3-0.9c-0.3-1.2-0.7-2.4-1-3.6c0-0.2-0.5-0.6-0.7-0.8c-0.2-0.2-0.3-0.3-0.5-0.5l-0.2-0.2l0.1-0.2
	c0.1-0.4-0.1-0.7-0.3-1.1c-0.1-0.1-0.1-0.3-0.2-0.4c-0.3-0.6-0.5-1.2-0.6-1.9c-0.3-1.7-0.9-3.4-1.4-5.1l-0.2-0.6
	c-0.1-0.3-0.2-0.6-0.3-1c-0.4-1-0.7-2-0.9-3.1c-0.2-1.3-0.1-2.5,0-3.8c0-0.7,0.1-1.3,0.1-2c0-1.9-0.2-3.8-1.8-5.1
	c-0.2-0.1-0.3-0.2-0.5-0.4c-0.4-0.3-0.7-0.5-1.1-0.9c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.2-0.3-0.4-0.6-0.6c-0.2-0.1-0.5-0.2-0.8-0.3
	c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0.1-0.2,0.3-0.3,0.4l-0.1,0.1c-0.1,0.1-0.2,0.3-0.3,0.4l-0.1,0.1l1.8,0.2L202.1,83.9z"
        />
        <path
          class={`st1 a3 region ${selectedRegion === 'BIOBIO_REGION' && 'selected-region'}`}
          onClick={() => {
            setSelectedRegion('BIOBIO_REGION');
            onMapClick('BIOBIO_REGION');
          }}
          d="M101.2,448.5c0.1,0.4,0.2,0.7,0.2,1.1c0.1,0.5,0.2,0.9,0.3,1.3c0.4,1.1,0.7,2.7,0.1,3.8l-0.2,0.3
	c-0.2,0.3-0.3,0.5-0.4,1c-0.2,0.9-0.3,1.7-0.3,2.4c0,0.6,0,1.4,0.1,2.1c0,0.2,0.2,0.9,0.2,1s0.1,0.2,0.1,0.2s0.1,0.1,0.3,0.2
	c0.5,0.4,0.9,0.8,1.4,1.2c0.8,0.8,1,1.4,1.2,2.4l0.2,0.9c0.3,1.3,0.6,2.4,1,3.7c0.4,1.2,0.6,2.3,0,3.5c-0.1,0.2-0.2,0.3-0.3,0.5
	c-0.2,0.4-0.4,0.7-0.4,1.1c0.1,0,0.2,0,0.4,0c0.3,0,0.6,0,0.8,0c0.5,0,1,0.1,1.3-0.1c0-0.1,0-0.1,0.1-0.2c0.1-0.2,0.1-0.3,0.2-0.5
	c0.1-0.3,0.2-0.5,0.2-0.7c0.1-0.4,0.1-0.7,0.1-1.1c0-1.1,0.7-1.6,1.1-1.9c0.3-0.2,0.6-0.4,0.9-0.5c0.3-0.2,1-0.5,1.1-0.7
	c0-0.3,0-0.5-0.1-0.9s-0.1-0.7-0.1-1c0-0.1,0-0.3,0-0.4c-0.1-0.1-0.2-0.2-0.2-0.4c-0.2-0.5-0.2-0.9-0.2-1.1v-0.2
	c0-0.1,0-0.3-0.1-0.4c-0.1-0.4-0.1-0.9,0.1-1.7c0.1-0.4,0.2-0.8,0.4-1.1c0.3-0.8,0.5-1.5,0.6-2.2c0-0.1,0-0.2,0-0.2
	c0-0.2,0-0.4,0-0.6s0.1-0.3,0.1-0.5l0,0c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.3-0.6c-0.2-0.5-0.1-1.2,0.4-1.5
	c0.6-0.4,1.3-0.3,2-0.3c0.1,0,0.2,0,0.3,0h5c0.2,0,0.4,0,0.5,0c0.7,0,1.3-0.1,1.9,0.1c1.7,0.4,3.2,1.7,3.6,3.3
	c0.1,0.3,0.1,0.5,0.2,0.8c0.1,0.4,0.2,0.8,0.3,1.1c0.1,0.2,0.3,0.5,0.5,0.7c0.2,0.4,0.3,0.7,0.4,0.9c0.1,0,0.4,0.1,0.8,0.1
	c0.3,0,0.6,0.1,0.8,0.1l0.7,0.1c0.4,0.1,0.7,0.2,1.1,0.2h0.2c0.4,0.1,0.9,0.1,1.4,0.5c0.5,0.3,0.8,0.7,1,1.1
	c0.3,0.4,0.4,0.5,0.6,0.5c0.2,0,0.4,0.1,0.6,0c0.1,0,0.2,0,0.3-0.1c0.4-0.1,0.9-0.3,1.5-0.1c1.6,0.4,2.1,1.9,2.3,2.6
	c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.3,0.1,0.5,0.1,0.6c0.2-0.1,0.5-0.3,0.6-0.4l0.4-0.3c0.6-0.4,1.2-0.8,1.8-1.2c0,0,0.1-0.1,0.2-0.2
	c0.1-0.1,0.3-0.3,0.6-0.5c0.5-0.3,1.2-0.5,1.5-0.6c0.8-0.2,1.8-0.2,2.7-0.1h0.5c0.3,0,0.7,0.1,1,0.1c0.2,0,0.4,0.1,0.6,0.1h0.2
	c0.2,0,0.5,0,0.8,0.1c0.1,0,0.3,0.1,0.4,0.1c0-0.1,0-0.2,0-0.3c0-0.6,0-1.2,0-1.9c0-1.3,0.1-2.6,0-3.8c-0.1-1.1-0.5-2.3-0.9-3.4
	c-0.2-0.5-0.4-1-0.5-1.4c-0.3-1-0.2-2.1-0.1-3.1c0.1-0.5,0.1-1,0.1-1.5c0-2.1,0-4.1,0-6.2v-3c0-0.7,0-1.3-0.1-1.9l-0.1-0.4
	c-0.1-0.4-0.1-0.7-0.1-1.1c-0.3,0-0.6,0.1-0.8,0.1c-1,0.1-2,0.3-2.9,0.3h-0.7c-0.9,0-1.4,0-1.9,0.3c-0.4,0.3-0.7,0.5-1,0.7
	c-0.6,0.5-1.2,0.9-1.9,1.4c-0.5,0.3-0.9,0.7-1.3,1.2c-0.3,0.3-0.5,0.7-0.9,1c-1,1-2,1-2.7,1c-0.3,0-0.6,0-0.8,0c0,0-0.1,0.1-0.2,0.2
	c-0.2,0.2-0.5,0.5-0.9,0.6c-0.5,0.2-1,0.2-1.3,0.2c-0.1,0-0.2,0-0.3,0c-0.3,0-0.7,0.1-1,0.2c-0.9,0.2-2,0.4-3,0.2
	c-0.9-0.2-1.6-0.6-2.4-1c-0.3-0.2-0.5-0.3-0.7-0.4c-0.1-0.1-0.2-0.1-0.4-0.2l-0.1-0.1c-0.8-0.4-1.8-0.8-2.3-1.7
	c-0.4-0.7-0.6-1.7-0.8-2.5c-0.1-0.3-0.1-0.6-0.2-0.9c-0.5-1.6-1.1-3.1-1.7-4.6c-0.5-1.4-1.1-2.7-1.5-4.1c-0.1-0.3-0.2-0.6-0.3-1
	c-0.1-0.4-0.2-0.8-0.3-1.1c-0.3,1-0.6,1.9-0.9,2.8c-0.5,1.5-1.1,3-1.6,4.5l-0.7,1.9c-0.4,1-0.7,2.1-1,3.1c-0.5,1.7-1,3.5-1.8,5.1
	c-0.1,0.2-0.2,0.5-0.3,0.7c-0.3,0.7-0.6,1.4-1,2l-0.2,0.3c-0.4,0.6-0.9,1.4-1.6,1.7c-0.4,0.2-0.8,0.2-1.1,0
	c-0.5-0.3-0.7-0.9-0.8-1.4c-0.1-0.3-0.2-0.6-0.3-0.8c-0.2-0.2-0.6-0.4-0.9-0.5s-0.6-0.2-0.8-0.4l-0.2-0.1c-0.3-0.2-0.7-0.5-0.9-0.4
	c0,0.1,0.1,0.2,0.2,0.3C101,448.1,101.1,448.3,101.2,448.5z"
        />
        <path
          class={`st1 a4 region  ${selectedRegion === 'NUBLE_REGION' && 'selected-region'}`}
          onClick={() => {
            setSelectedRegion('NUBLE_REGION');
            onMapClick('NUBLE_REGION');
          }}
          d="M121,439.1c0.1,0.3,0.2,0.6,0.2,1c0.2,0.7,0.3,1.5,0.6,1.9c0.1,0.2,0.8,0.5,1.1,0.6c0.2,0.1,0.4,0.2,0.6,0.3
	c0.3,0.1,0.5,0.3,0.8,0.4c0.6,0.3,1.2,0.7,1.8,0.8c0.5,0.1,1,0,1.8-0.2c0.4-0.1,0.9-0.2,1.4-0.3c0.2,0,0.4,0,0.6,0
	c0.1,0,0.2,0,0.2,0l0,0c0,0,0-0.1,0.1-0.1c0.3-0.2,0.6-0.6,1.3-0.8c0.6-0.2,1.1-0.1,1.5-0.1c0.6,0,0.6,0,0.9-0.2
	c0.3-0.3,0.5-0.5,0.7-0.8c0.5-0.6,1-1.3,2-1.8c0.6-0.4,1.1-0.8,1.6-1.1c0.4-0.3,0.7-0.6,1.1-0.9c1.2-0.9,2.4-0.8,3.5-0.8h0.6
	c0.8,0,1.5-0.1,2.3-0.2h0.2c0.5-0.1,0.9-0.1,1.4-0.2c0-0.3,0.1-0.5,0.2-0.7c0.1-0.3,0.5-0.6,0.7-0.8c0.1-0.1,0.2-0.1,0.2-0.2
	c0.7-0.7,1.1-1.4,1.4-2.3c-0.1-0.4-0.1-0.7-0.1-1l0,0c-0.4,0-0.8,0.1-1.2,0.2c-0.5,0.1-0.9,0.2-1.4,0.3c-0.3,0-0.5,0-0.8,0
	c-0.6,0-0.9,0-1.2,0.2c-1.6,1.1-2.6,0.9-4,0.4c-0.4-0.1-0.8-0.2-1.2-0.3c-1-0.2-2.1-0.5-3-1.1l-0.2-0.1c-0.4-0.2-0.8-0.5-1.2-0.9
	c-0.6-0.7-0.7-1.5-0.8-2c0-0.2,0-0.3-0.1-0.5c0,0-0.1-0.1-0.6-0.1c-0.2,0-0.4,0-0.8,0c0,0,0,0-0.1,0.1s-0.3,0.3-0.5,0.4
	c-1.3,0.8-2.3,0-2.7-0.3l-0.3-0.3c-0.3-0.2-0.6-0.5-0.9-0.8l-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.2l0,0l-0.1,0.2c-0.2,0.3-0.6,1-1.6,1.1
	c-0.4,0.1-0.8-0.1-1.1-0.1l-0.5-0.1c-0.4-0.1-1-0.2-1.5-0.5c-0.6-0.4-0.9-0.9-1.1-1.3l-0.1-0.2c-0.3-0.5-0.4-0.6-1.1-0.9
	c-0.3-0.1-0.6-0.2-0.9-0.2c-0.4-0.1-0.8-0.1-1.2-0.3c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.3-0.2-0.4-0.2c-0.5-0.1-0.8-0.2-1.3-0.2
	c-0.1,0.6-0.2,1.2-0.4,1.8c-0.1,0.4-0.3,0.8-0.5,1.2c0.1,0.2,0.2,0.3,0.3,0.4c0.7,0.9,1,2,1.3,3c0.1,0.3,0.2,0.6,0.2,0.9
	c0.4,1.3,0.9,2.6,1.4,3.9l-0.4,0.3l0,0l0.5-0.2C119.9,435.8,120.5,437.5,121,439.1z"
        />
        <path
          class={`st1 a5 region ${selectedRegion === 'ARAUCANIA_REGION' && 'selected-region'} `}
          onClick={() => {
            setSelectedRegion('ARAUCANIA_REGION');
            onMapClick('ARAUCANIA_REGION');
          }}
          d="M151.8,478.7c-0.1-0.4-0.2-1-0.4-1.3c-0.1-0.2-0.3-0.3-0.5-0.5s-0.4-0.4-0.6-0.6c-1.2-1.4-1.2-3.2-1.2-4.8
	c0-0.6,0-1.3-0.1-1.9c-0.3-0.1-0.6-0.1-0.8-0.2c-0.1,0-0.3-0.1-0.4-0.1l0.1-0.5l-0.1,0.5h-0.1c-0.1,0-0.2,0-0.3,0
	c-0.3,0-0.7-0.1-1-0.1c-0.2,0-0.4-0.1-0.6-0.1h-0.5c-0.7,0-1.4-0.1-1.9,0c-0.4,0.1-0.7,0.2-0.8,0.3l-0.1,0.1
	c-0.2,0.2-0.4,0.4-0.7,0.6c-0.6,0.4-1.1,0.7-1.7,1.1l-0.4,0.2c-0.6,0.4-2.3,1.6-3.7,0.3c-0.6-0.6-0.7-1.4-0.8-2.1
	c0-0.2-0.1-0.3-0.1-0.5c-0.2-0.6-0.3-0.9-0.5-0.9c0,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.5,0.2-0.7,0.2c-0.4,0.1-1,0-1.4-0.1
	c-1.1-0.2-1.6-0.9-2-1.5c-0.2-0.2-0.3-0.4-0.4-0.5c-0.1,0-0.3-0.1-0.4-0.1h-0.2c-0.4-0.1-0.9-0.2-1.3-0.3l-0.6-0.1
	c-0.1,0-0.3,0-0.5-0.1c-0.9-0.1-2.3-0.2-2.8-1.4c0-0.1-0.1-0.2-0.1-0.4c0-0.2,0-0.3-0.1-0.4c-0.2-0.2-0.4-0.5-0.5-0.9
	c-0.3-0.6-0.4-1.2-0.5-1.6c-0.1-0.3-0.1-0.5-0.2-0.7c-0.2-0.8-1-1.4-1.8-1.6c-0.3-0.1-0.8,0-1.2,0c-0.3,0-0.5,0-0.7,0h-4.8
	c0,0.3-0.1,0.6-0.1,0.8v0.1c0,0.1,0,0.1,0,0.2c0,0.2,0,0.5-0.1,0.8c-0.2,0.9-0.5,1.7-0.7,2.5c-0.1,0.4-0.2,0.7-0.4,1.1
	c-0.1,0.2-0.1,0.3,0,0.6c0,0.2,0.1,0.4,0.1,0.7v0.2c0,0.1,0,0.1,0,0.2c0.1,0.2,0.3,0.4,0.4,0.7c0.1,0.4,0.1,0.8,0.1,1.1
	c0,0.2,0,0.4,0,0.5c0.2,0.7,0.2,1.2,0.1,1.8c-0.2,1.4-1.4,2-2.3,2.5c-0.2,0.1-0.4,0.2-0.6,0.4l-0.1,0.1c0,0.4,0,0.8-0.1,1.3
	c-0.1,0.4-0.2,0.8-0.3,1.1c-0.1,0.1-0.1,0.3-0.1,0.4v0.2c-0.1,0.3-0.2,0.8-0.9,1.3c-1,0.7-2.1,0.6-2.9,0.5c-0.3,0-0.7-0.1-1,0
	c0,0,0,0-0.1,0l0,0c0,0.6-0.1,1.3-0.2,2c0,0.1,0,0.2,0,0.2c0.6,0.5,1.1,1.7,1.3,2.2c0.1,0.4,0.1,0.7,0.1,0.9c0,0.2,0,0.3,0,0.4
	c0,0.2,0.1,0.4,0.2,0.6s0.1,0.3,0.1,0.5c0.1,0.4,0.2,0.8,0.2,1.2c0.1,0.6,0.2,1.2,0.4,1.8c0.1,0.2,0.1,0.3,0.2,0.4
	c0.1,0.3,0.3,0.7,0.4,1.1l0.1,0.3c0,0.3,0.1,0.6,0.2,0.9c0.2,0.8,0.6,1.4,1,2.1c0.3,0.6,0.6,1.1,0.9,1.8c0.5,1.2,0.4,2.2,0.3,3.1
	c0.1,0,0.1,0,0.2,0.1c0.7,0.3,1.4,0.4,1.7,0.3c0.2-0.1,0.4-0.8,0.5-1.1c0.1-0.2,0.1-0.4,0.2-0.6c0.3-0.8,0.8-1.3,1.3-1.6
	c0.7-0.6,1.2-0.9,1.9-0.9l0,0c0.5,0,1.7,0.3,1.6,2.1c0,0.1,0,0.1,0,0.2l0.2,1.3c0,0.1,0,0.2,0.1,0.3c0.1,0,0.3,0,0.5,0
	c0.4,0,0.8-0.1,1.2,0c0.2,0,0.4,0.1,0.6,0.1c0.1,0,0.2,0.1,0.3,0.1c0,0,0.2-0.1,0.3-0.1c0.2-0.1,0.5-0.2,0.7-0.2
	c0.6-0.1,1.1-0.2,1.6-0.3c0.6-0.1,1.4-0.2,2.1,0.2c0.4,0.2,0.6,0.4,0.8,0.6l-0.2,0.5l0.3-0.4c0.2,0.1,0.4,0.2,1,0.2
	c0.3,0,0.7,0,1.2,0.1c0.2,0,0.5,0.1,0.7,0.2c0.8,0.2,1.5,0.3,2.1,0.2c0.3-0.1,0.4-0.2,0.8-0.7c0.2-0.2,0.4-0.5,0.6-0.7
	c0.7-0.7,1.4-1,2.2-1c1.1,0,2.1,0.5,2.9,0.9c0.3,0.1,0.5,0.3,0.8,0.4l0.2,0.1c0.4,0.1,0.9,0.3,1.4,0.8c0.1,0.1,0.3,0.3,0.4,0.4
	c0.2,0.2,0.3,0.2,0.4,0.4c0.2,0.2,0.4,0.4,0.5,0.6s0.2,0.3,0.3,0.3l0.1,0.1c0.1,0,0.2,0.1,0.3,0.2c0.5-0.4,0.9-0.8,1.3-1.3
	c0.8-1.2,1-2.3,0.6-3.6c-0.2-0.7-0.4-1.6-0.8-2.4l-0.1-0.2c-0.4-0.9-0.9-1.8-0.7-3c0.2-1,0.7-2,1.1-2.9l0.2-0.5
	c0.6-1.2,2.4-2.7,3.9-2.7l0,0c0.3,0,0.7,0.1,1,0.2s0.5,0.2,0.7,0.1c0.2,0,0.4-0.1,0.5-0.1c0.2,0,0.3-0.1,0.4-0.1
	c0.5-0.1,0.6-0.2,0.9-0.6l0.2-0.2c0.9-0.9,1.2-1.3,1.6-2.3c0.1-0.4,0-0.9-0.2-1.4C151.9,479.1,151.8,478.9,151.8,478.7z"
        />
        <path
          class={`st1 a6 region ${selectedRegion === 'SANTIAGO_METROPOLITAN' && 'selected-region'}`}
          onClick={() => {
            setSelectedRegion('SANTIAGO_METROPOLITAN');
            onMapClick('SANTIAGO_METROPOLITAN');
          }}
          // R M REGION
          d="M165.6,356.6c-0.7,0.4-1.5,0.7-2.2,0.9l-0.5,0.2c-0.8,0.3-1.9,0.7-2.9,0.5c-1.2-0.2-2.2-0.9-3.1-1.5
	c-0.6-0.4-1-0.9-1.4-1.3c-0.2-0.3-0.5-0.6-0.7-0.8c-0.3-0.2-0.7-0.3-1.2-0.5c-0.9-0.3-1.2-0.2-1.8,0.4l-0.1,0.1
	c-0.6,0.6-1.1,1-2.2,1h-0.3c-0.1,0-0.2,0-0.2,0c0,0.1-0.1,0.2-0.2,0.4c-0.1,0.2-0.2,0.3-0.3,0.5l-0.2,0.3c-0.2,0.3-0.3,0.5-0.4,0.7
	c-0.2,0.8-0.4,1.8-0.5,2.7c-0.1,0.9-0.4,1.7-0.7,2.4c-0.2,0.5-0.4,0.9-0.5,1.4c-0.1,0.4-0.1,0.9-0.2,1.4v0.4c0,0.3,0,0.6,0,0.9
	c0,0.5,0,1-0.1,1.5c-0.1,0.6-0.4,1.5-0.7,2c-0.6,1-1.6,1.2-2.2,1.3l-0.4,0.1c-0.5,0.1-1.2,0.2-1.6,0.5c0,0-0.3,0.2-0.8,1.4
	c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0.1,0.3,0.1c0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.4,0.2,0.5,0.3
	c0.2,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2,0.1,0.3,0.1c0.5,0.2,1,0.3,1.5,0.8c0.7,0.6,1.5,1.4,2.4,1.8c0,0,0.1,0,0.1-0.1
	c0.2-0.1,0.4-0.1,0.7-0.2c0.4,0,0.7,0,0.9,0c0.1,0,0.3,0,0.4,0c0,0,0.1,0,0.1-0.1c0.1-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.4-0.1,0.6-0.1
	c0.1,0,0.2,0,0.3,0h0.1h0.1c0.7-0.2,1-0.3,1.1-0.3c0-0.1,0-0.2,0-0.2c0-0.5,0-1.5,1.1-2.2c0.6-0.4,1.2-0.3,1.6-0.3
	c0.1,0,0.2,0,0.2,0c0.2,0,0.3-0.1,0.7-0.4l0.2-0.2c0.6-0.5,1.2-1,1.9-1.3c0,0,3-1.3,4.4-0.4c0.2,0.1,0.3,0.2,0.4,0.4
	c0.1,0.1,0.1,0.1,0.2,0.2c0.4,0.3,0.5,0.8,0.5,1.4c0,0.3-0.1,0.6-0.1,0.8c0,0.2-0.1,0.3-0.1,0.4v0.3c0,0.5,0,0.7,0.1,0.8
	c0.1,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.4-0.2,0.7-0.3c0.2,0,0.4-0.1,0.6-0.1c0.9,0,1.5,0.6,1.9,1.7c0,0.1,0.1,0.2,0.1,0.3
	c0.2,0.5,0.5,1,0.8,1.5c0.1,0.1,0.2,0.3,0.3,0.5c0.2,0.3,0.4,0.6,0.6,0.7c0.2,0.2,0.9,0.5,1.1,0.5c0.4,0,0.6,0,0.8-0.1
	c0.1,0,0.1-0.1,0.2-0.1c0.3-0.1,0.6-0.3,0.9-0.4l0,0c0.1-0.3,0.2-0.6,0.3-0.9s0.3-0.6,0.4-0.8c0.6-1.2,1-2,0.4-3.3
	c-0.1-0.3-0.3-0.5-0.5-0.7c-0.4-0.4-0.8-0.9-0.8-1.8c0-0.4-0.1-0.8-0.2-1.1c0-0.2-0.1-0.5-0.1-0.7c-0.2-1.7,0.4-3.5,1-5.1
	c0.1-0.3,0.2-0.5,0.3-0.8c0.2-0.5,0.4-1,0.7-1.5c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.4-0.5,0.4-0.6c0.1-0.5,0.1-1.3,0-1.9
	c-0.3-1.1-1.1-2.9-2.1-3.1c-0.3-0.1-0.5-0.1-0.8-0.1c-0.4,0-1,0-1.5-0.2c-0.6-0.3-0.9-0.7-1.1-1.1c-0.1-0.1-0.1-0.2-0.2-0.4
	c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1l0,0l-0.3-0.4l0.3,0.4C166.2,356.1,165.9,356.4,165.6,356.6z"
        />
        <path
          class={`st1 a7 region ${selectedRegion === 'MAULE_REGION' && 'selected-region'}`}
          onClick={() => {
            setSelectedRegion('MAULE_REGION');
            onMapClick('MAULE_REGION');
          }}
          d="M161,399.6c-0.2,0-0.4,0-0.6,0h-0.3c-0.2,0-0.4,0-0.7,0.1l-0.4,0.1c-0.6,0.1-1.1,0.2-1.7,0.2H157
	c-1,0-1.5-0.6-2-1s-0.7-1-1-1.4c-0.1-0.2-0.2-0.4-0.3-0.5c-0.2-0.3-1.1-0.2-1.5-0.2s-0.5,0.1-0.9,0.3l-0.2,0.1
	c-0.5,0.3-1.3,0.7-2.3,0.4c-1-0.3-1.5-1.1-1.9-1.7c-0.1-0.2-0.3-0.4-0.4-0.6c-0.3-0.3-0.7-0.4-1.2-0.6c-0.2-0.1-0.3-0.1-0.5-0.2
	s-0.6-0.2-0.7-0.2c-0.1,0-0.2,0.2-0.5,0.8c-0.1,0.2-0.2,0.4-0.3,0.6c-0.6,1-1.5,0.9-1.9,0.9c-0.2,0-0.2,0-0.3,0s-0.4,0.2-0.5,0.3
	c-0.2,0.1-0.3,0.2-0.4,0.2c-0.6,0.3-1.2,0.5-1.7,0.6c-0.3,0.1-3.4,0.7-5.4-0.2c-0.9-0.4-1.3-1.1-1.7-1.7c-0.2-0.3-0.4-0.7-0.6-0.8
	l-0.4-0.3c-0.4-0.3-0.9-0.6-1.3-0.8c0,0-0.1,0-0.1-0.1c-0.1,0-0.1,0-0.2,0c-1,1.5-1.7,2.8-2.3,4c-0.2,0.4-0.3,0.9-0.5,1.4
	c-0.1,0.4-0.2,0.8-0.4,1.2c-0.2,0.6-0.5,1.1-0.8,1.6c-0.1,0.2-0.3,0.5-0.4,0.8c-0.3,0.6-0.8,1-1.2,1.4c-0.3,0.2-0.5,0.5-0.8,0.8
	c-0.7,0.9-1,2.1-1.2,3.3c-0.1,0.7-0.3,1.3-0.5,2c-0.2,0.5-0.3,1.1-0.5,1.6c-0.3,1.3-0.7,2.6-1.6,3.8c-0.2,0.2-0.3,0.5-0.5,0.8
	c-0.2,0.4-0.5,0.8-0.8,1.2c-0.1,0.1-0.3,0.3-0.4,0.4c-0.4,0.3-0.5,0.4-0.5,0.8s0.1,0.9,0.1,1.3c0,0.1,0,0.3,0,0.4l0,0
	c0.6,0,1.3,0.1,2,0.3c0.4,0.1,0.7,0.3,0.9,0.4c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.1,0.5,0.1,0.7,0.2c0.5,0.1,1,0.2,1.5,0.4
	c1,0.5,1.6,0.8,2.2,2l0.1,0.2c0.1,0.2,0.2,0.4,0.3,0.4c0.1,0.1,0.5,0.1,0.7,0.2l0.6,0.1h0.1V425c0.4-0.6,0.9-1.2,1.9-1.3
	c0.6-0.1,0.9,0,1.3,0.4l0.1,0.1c0.4,0.3,0.6,0.6,0.8,0.8l0.2,0.2c0.1,0.1,0.3,0.3,0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.3l0.1,0.1
	c0.3-0.3,0.7-0.6,1.4-0.7c0.3,0,0.7-0.1,1-0.1c1.8,0,2.8,0.6,3.1,1.9c0.1,0.3,0.1,0.5,0.1,0.8c0,0.4,0.1,0.6,0.2,0.7
	c0.1,0.1,0.4,0.3,0.6,0.4l0.3,0.2c0.6,0.4,1.4,0.6,2.3,0.8c0.5,0.1,1,0.2,1.4,0.4c1.1,0.3,1.2,0.3,1.9-0.1c0.9-0.6,1.7-0.6,2.4-0.6
	c0.2,0,0.4,0,0.6,0c0.3,0,0.7-0.1,1-0.2c0.8-0.2,1.5-0.3,2.3-0.3c0.2-1.3,1-2.2,1.7-2.9c1-1,1.9-1.2,2.9-1.4c0.3-0.1,0.7-0.2,1-0.3
	c1.4-0.4,3-1,3.9-2.4c0.5-0.7,0.4-1.2,0.2-2c0-0.2-0.1-0.4-0.1-0.7c-0.1-0.7,0.1-1.4,0.3-2.1c0.1-0.4,0.2-0.7,0.2-1
	c0.2-1.1,0.3-2.1,0.3-3.3c0-0.4,0.1-0.9,0.2-1.3c0.1-0.8,0.3-1.5,0-1.9s-0.7-0.5-1.3-0.6c-0.3-0.1-0.6-0.1-0.9-0.2
	c-0.1,0-0.1,0-0.2,0l0.5,3.5l-1.8-4.3c-0.6-1.3-1.6-3.8,0-4.6c0.3-0.2,0.7-0.3,1.1-0.4c1.3-0.5,2.7-1,2.8-2.1c0-0.5,0-1,0-1.5
	L161,399.6z"
        />
        <path
          class={`st1 a8 region ${selectedRegion === 'O_HIGGINS_REGION' && 'selected-region'} `}
          onClick={() => {
            setSelectedRegion('O_HIGGINS_REGION');
            onMapClick('O_HIGGINS_REGION');
          }}
          d="M165.1,381.2L165.1,381.2c-0.1-0.2-0.2-0.3-0.3-0.4c-0.5-0.6-0.9-1.3-1.2-2c0-0.1-0.1-0.2-0.1-0.3
	c-0.3,0.1-0.7,0.3-1.2,0.2c-0.9-0.1-1.6-1-1.9-1.3c-0.6-0.8-0.6-1.6-0.6-2.2v-0.3c0-0.4,0.1-0.7,0.1-1l-0.1-0.1
	c-0.5,0.1-1.5,0.3-1.8,0.5c-0.4,0.2-0.9,0.5-1.3,0.9l-0.2,0.2c-0.4,0.4-1.1,1-2.1,1.1c-0.2,0-0.4,0-0.6,0h-0.1v0.1
	c0,0.3,0,0.6-0.1,1c-0.4,1.3-2,1.7-2.9,1.9c-0.3,0.1-0.4,0.1-0.5,0.1s-0.2,0-0.3,0.1c0,0-0.1,0-0.2,0.1c-0.2,0.1-0.5,0.3-0.9,0.4
	s-0.8,0-1,0s-0.3,0-0.4,0c-0.1,0-0.2,0-0.2,0.1c-0.4,0.1-1,0.3-1.8,0c-1.3-0.5-2.3-1.5-3.1-2.2c-0.1-0.1-0.3-0.2-0.6-0.3
	c-0.2-0.1-0.3-0.1-0.5-0.2c-0.4-0.2-0.7-0.4-0.9-0.5c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.3-0.1-0.7-0.2-1-0.5
	c-1,0.6-2.3,0.5-4,0c-0.1,0-0.1,0-0.2,0c-0.4,0-0.9,0-1.4-0.3c-0.3,0.5-0.6,1.1-1.1,1.6c-0.2,0.2-0.4,0.4-0.6,0.6
	c-0.8,0.8-1.8,1.7-1.9,2.7c0,0.6,0,0.6,0.4,0.9c0.1,0.1,0.2,0.2,0.3,0.3c0.6,0.5,1,1.5,1.1,2.2s-0.3,1.5-0.6,2.3
	c-0.1,0.2-0.2,0.4-0.2,0.6c-0.1,0.4-0.3,0.7-0.4,1.1c-0.3,0.8-0.5,1.5-0.7,2.2c-0.1,0.5,0,0.8,0,1.2v0.1c0.2,0.1,0.4,0.2,0.6,0.2
	c0.6,0.3,1.1,0.6,1.6,1l0.4,0.3c0.6,0.4,1,1,1.3,1.5c0.2,0.4,0.5,0.7,0.7,0.8c0.9,0.4,2.7,0.3,4,0.1c0.5-0.1,0.8-0.2,1.2-0.4
	c0.1,0,0.2-0.1,0.3-0.2c0.3-0.2,0.8-0.4,1.2-0.5c0.3-0.1,0.6-0.1,0.8-0.1c0-0.1,0.1-0.1,0.1-0.2c0.4-0.8,1-2.2,2.7-2.2
	c0.6,0,1.1,0.2,1.6,0.4c0.2,0.1,0.3,0.1,0.4,0.2c0.7,0.2,1.5,0.6,2.2,1.2c0.3,0.3,0.5,0.7,0.7,1c0.1,0.2,0.4,0.6,0.5,0.7
	c0,0,0.3-0.2,0.4-0.2l0.2-0.1c0.6-0.3,1.1-0.6,1.9-0.6c0.1,0,0.3,0,0.4,0c1.1,0,2.5,0.1,3.3,1.3c0.1,0.2,0.3,0.5,0.4,0.7
	c0.2,0.3,0.3,0.6,0.5,0.8c0.1,0.1,0.3,0.3,0.3,0.3c0.5,0,0.8,0,1.3-0.2l0.2-0.1c0.4-0.1,0.9-0.2,1.5-0.2c0.1,0,0.2,0,0.2,0
	c0.2-0.2,0.5-0.2,0.8-0.2c0-0.2,0.1-0.4,0.1-0.6c0.1-0.3,0.1-0.6,0.2-0.8c0-0.2,0.1-0.3,0.1-0.5c0.1-0.7,0.2-1.3,0.6-2
	c0.5-0.9,1-1.9,1.3-2.9c0.2-0.7,0.4-1.4,0.5-2.1s0.3-1.3,0.5-2c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.5,0.2-1,0.6-1.5
	c0.5-0.6,0.8-1,1.4-1.2c-0.3-0.2-0.5-0.3-0.7-0.5C165.6,381.9,165.3,381.6,165.1,381.2z"
        />
        <path
          class={`st1 a9 region ${selectedRegion === 'TARAPACA_REGION' && 'selected-region'}`}
          onClick={() => {
            setSelectedRegion('TARAPACA_REGION');
            onMapClick('TARAPACA_REGION');
          }}
          d="M202.7,78.4l0.1-0.4c0.3-0.8,0.5-1.6,0.4-2.3c-0.1-0.6-0.7-0.8-1.9-1c-0.7-0.1-1.4-0.2-1.9-0.6
	c-1.9-1.3-0.9-3.2-0.1-4.6c0.8-1.4,1.3-2.4,0.7-3.2c-0.2-0.3-0.5-0.5-0.8-0.7c-0.2-0.2-0.4-0.3-0.6-0.5c-0.6-0.6-1.1-1.2-1.5-1.9
	c-0.3-0.5-0.7-1.2-0.9-2c-0.5-1.8-0.1-3.1,1-3.9c0.5-0.4,1.3-0.5,2.1-0.7c0.9-0.2,2-0.5,2.2-1c0.1-0.3,0.1-0.7-0.1-1.2l-0.1-0.2
	c-0.2-0.4-0.4-0.8-0.6-1.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.2-0.3-0.3-0.4-0.5c-0.9-1.4,0.3-2.6,1.1-3.4l0.3-0.3
	c0.2-0.2,0.4-0.3,0.6-0.5c0.6-0.6,1.6-1.4,1.7-2.1c0-0.4-0.6-1.3-1.2-1.8l-0.3-0.2c-0.8-0.7-1.6-1.4-2.3-2.4
	c-0.1-0.2-0.3-0.5-0.4-0.7c-0.2-0.4-0.4-0.8-0.7-1.1c-0.4-0.5-1-0.8-1.6-1.2c-0.5-0.3-1.1-0.7-1.5-1.1c-0.2,0.2-0.4,0.3-0.7,0.3
	c-0.1,0-0.4,0.2-0.6,0.3c-0.1,0.1-0.3,0.2-0.4,0.2c-0.7,0.4-1.4,0.6-2,0.8c-0.2,0.1-0.4,0.1-0.6,0.2c-1.3,0.4-2.2,0.2-3.1,0
	c-0.2,0-0.4-0.1-0.6-0.1c-0.4-0.1-0.8-0.1-1.1-0.1c-0.5,0-1-0.1-1.5-0.2c-0.5-0.1-1-0.1-1.6-0.1c-1,0-2-0.1-2.8-0.1h-0.5
	c-0.8,0-1.5-0.1-2.3-0.1c-0.4,0-0.8,0-1.2,0h-0.2c-0.7,0-1.4,0-2.1,0c-0.3,0-0.7,0.1-1.1,0.3c-0.2,0.1-0.4,0.1-0.7,0.2
	c-0.5,0.1-0.9,0.1-1.3,0.1c-0.3,0-0.5,0-0.7,0.1c0,0-0.2,0.1-0.3,0.1c-0.2,0.1-0.3,0.2-0.5,0.2c-0.5,0.2-0.9,0.2-1.3,0.3h-0.3
	c-0.6,0.1-1.1,0.3-1.8,0.7c-0.1,0-0.2,0.1-0.2,0.2c-0.5,0.3-0.7,0.4-0.8,0.5c-0.1,0.3-0.3,0.5-0.6,0.6c0.2,1.3,0.5,2.4,0.9,3.5
	c0.6,1.7,1.1,3.8,1.2,5.4c0,0.5,0,1,0,1.4s0,0.7,0,1.1c0,0.8,0.2,1.5,0.4,2.3l0.2,0.6c0.5,2.1,0.6,4,0.6,5.6c0,0.3,0,0.7,0,1
	c0,0.9,0,1.9-0.1,2.8c-0.1,0.4-0.1,0.8-0.2,1.2c-0.1,0.6-0.2,1.1-0.3,1.7c0,0.3,0,0.5,0,0.8c0,0.6,0,1.1-0.2,1.8
	c-0.2,0.9-0.3,1.8-0.4,2.7v0.3c0,0.2-0.1,0.5-0.1,0.7c-0.1,0.7-0.1,1.3-0.1,1.9c0,1-0.1,2-0.3,2.9c-0.1,0.5-0.2,1-0.2,1.5
	c-0.1,1.1,0.2,1.8,0.6,2.8c0.1,0.3,0.2,0.6,0.3,0.9c0.3,0.8,0.6,1.3,1.1,2l0.2,0.3c0.3,0.5,0.4,0.8,0.6,1.2c1.5,0,2.7,0.5,4,1
	c0.3,0.1,0.5,0.2,0.7,0.3c0.7,0.2,1.4,0.4,2.2,1.3c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.3,0.1,0.4,0.1
	c0.2,0.1,0.5,0.1,0.8,0.3c0.4,0.2,0.7,0.5,0.9,0.7c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.1,0.2,0.1c0.5,0.3,0.6,0.5,0.9,1l0,0
	c0.7-0.6,1.3-1.4,1.7-1.9c0.4-0.6,0.9-1.1,1.7-1.5c0.7-0.3,1.5-0.4,2.2-0.5c0.4,0,0.7-0.1,1-0.2c0.8-0.2,1.8-0.5,2.9-0.8
	c0.3-0.1,0.6-0.3,0.9-0.4c0.3-0.2,0.6-0.3,0.9-0.5c0.3-0.1,0.6-0.2,0.9-0.3c0.3-0.1,0.6-0.2,0.8-0.3c0.4-0.2,0.8-0.4,1.2-0.6
	s0.9-0.4,1.3-0.6c0.6-0.3,1.2-0.7,1.8-1.1l0.6-0.4c0.2-0.1,0.4-0.3,0.6-0.5l0.1-0.1c0.1-0.2,0.3-0.4,0.5-0.5s0.4-0.2,0.6-0.3l0,0
	c0.2-0.3,0.5-0.7,0.8-1c0.1-0.2,0.3-0.3,0.5-0.4c0.1-0.1,0.1-0.1,0.2-0.1l0.1-0.1c0.2-0.2,0.3-0.4,0.6-0.6c0.1-0.1,0.3-0.2,0.4-0.2
	c0-0.7,0.3-1.4,0.5-1.9C202.6,78.7,202.6,78.5,202.7,78.4z"
        />
        <polygon class="st1" points="139.5,501.9 139.5,501.9 139.7,501.7 139.7,501.7 " />
        <path
          class={`st1 a10 region ${selectedRegion === 'LOS_RIOS_REGION' && 'selected-region'}`}
          onClick={() => {
            setSelectedRegion('LOS_RIOS_REGION');
            onMapClick('LOS_RIOS_REGION');
          }}
          d="M139.4,502.1L139.4,502.1L139.4,502.1C139.4,502.1,139.4,502,139.4,502.1L139.4,502.1c-0.1-0.1-0.2-0.1-0.3-0.2
	c-0.3-0.3-0.6-0.6-0.7-0.8c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.2-0.4-0.3-0.6-0.5c-0.1-0.1-0.2-0.1-0.5-0.2
	l-0.3-0.1c-0.3-0.1-0.6-0.3-1-0.5c-1.4-0.7-1.8-0.8-2.2-0.4c-0.2,0.2-0.3,0.3-0.4,0.5c-0.4,0.6-1,1.3-2.2,1.6
	c-1.2,0.2-2.2,0-3.1-0.2c-0.2-0.1-0.4-0.1-0.7-0.1c-0.2,0-0.5,0-0.7-0.1c-0.7,0-1.5,0-2.4-0.6c-0.2-0.1-0.3-0.2-0.4-0.4l-0.1-0.1
	c-0.1,0-0.5,0-0.7,0c-0.6,0.1-1.1,0.2-1.5,0.2c-0.1,0-0.2,0-0.2,0.1c-0.3,0.1-0.6,0.2-1,0.3c-0.5,0-0.8-0.1-1.1-0.1
	c-0.1,0-0.2-0.1-0.3-0.1c-0.2,0-0.4,0-0.7,0c-0.4,0-0.8,0.1-1.3,0s-1.7-0.5-1.9-2.4l-0.1-0.7c-0.1,0.1-0.1,0.2-0.2,0.3
	c-0.1,0.1-0.1,0.3-0.1,0.4c-0.2,0.8-0.6,1.8-1.4,2.4c-1.1,0.7-2.7,0.5-3.8,0c-0.2,0.5-0.3,1-0.5,1.6c-0.1,0.4-0.3,0.8-0.4,1.2
	c-0.2,0.8-0.6,1.5-1,2.2c-0.3,0.5-0.6,1.1-0.8,1.6c-0.1,0.2-0.1,0.4-0.1,0.7c0,0.3-0.1,0.5-0.2,0.8c-0.1,0.4-0.3,0.7-0.5,1.1
	c-0.1,0.1-0.2,0.3-0.2,0.4c-0.3,0.5-0.5,1.1-0.7,1.7c-0.1,0.4-0.3,0.7-0.4,1.1l-0.4,0.9c-0.6,1.3-1.1,2.6-1.9,3.8
	c-0.1,0.1-0.2,0.3-0.3,0.4c-0.2,0.4-0.3,0.5-0.4,1c-0.1,0.7,0,1.5,0.1,2.2c0,0.2,0.1,0.4,0.1,0.6v0.1c0.1,0.4,0.1,0.9,0,1.4
	c-0.1,0.4-0.4,0.8-0.6,1.1s-0.4,0.6-0.5,1c-0.1,0.5,0,1,0.1,1.5s0.2,1,0.1,1.6c-0.1,1.2-0.7,2-1.2,2.9c-0.2,0.3-0.4,0.6-0.5,0.9
	c-0.4,0.7-0.8,1.5-1.1,2.2h0.1c0.6-0.2,1.3-0.2,1.9-0.3c0.2,0,0.4,0,0.6,0c0.6-0.1,1.1,0,1.7,0s1.1,0,1.6-0.1s1-0.1,1.5-0.1
	c0.7,0,1.4-0.1,1.9-0.3c0.2-0.1,0.3-0.2,0.5-0.2c0.3-0.2,0.5-0.3,0.8-0.4c0.8-0.3,1.7-0.5,2.6-0.5c2.3-0.1,4.7,1,5.9,1.7
	c0.4,0.2,0.8,0.5,1.2,0.8c0.4,0.3,0.4,0.3,0.5,0.3c0.3,0,0.6,0,0.9-0.1c0.4-0.1,0.9-0.1,1.3-0.1c0.2,0,0.5,0,0.7,0.1l0.5,0.1
	c0.7,0.1,0.9,0.2,1.5,0c0.9-0.3,1.3-0.9,2-1.8c0.1-0.1,0.1-0.2,0.2-0.2c0.3-0.4,0.7-1.1,1.8-1.2c0.4,0,0.8,0,1.1,0h0.5
	c0.6,0,1.1-0.1,1.5-0.4c0.1-0.1,0.3-0.3,0.5-0.6c0.1-0.2,0.2-0.3,0.3-0.4c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.3,0.2-0.5,0.4-0.7
	c0.2-0.4,0.3-0.7,0.3-1.3c0-0.7,0.5-1.2,1.2-1.2l0,0h0.1c0.2-0.9,0.7-1.6,1.1-2.3l0.2-0.3c0.2-0.3,0.4-0.5,0.7-0.8
	c0.4-0.5,1-1.1,1-1.6c0.1-0.7-0.3-1.3-0.7-2c-0.2-0.4-0.4-0.8-0.6-1.1c-0.5-1.2,0-2.6,1.2-3.5c0.2-0.2,0.5-0.3,0.7-0.5
	c0.8-0.5,1-0.7,0.6-1.7c-0.2-0.4-0.4-0.8-0.6-1.3c-0.6-1.3-1.2-2.6-1.1-4c0-1.2,0.5-2.1,1.3-2.5c0.2-0.1,0.5-0.1,0.7-0.2
	c0.2,0,0.4-0.1,0.5-0.1c0.1-0.1,0.4-0.8,0.6-1.7c0-0.1,0-0.2,0-0.3C139.5,502.2,139.4,502.2,139.4,502.1L139.4,502.1z"
        />
        <path
          class={`st1 a11 region ${selectedRegion === 'ARICA_AND_PARINACOTA_REGION' &&
            'selected-region'}`}
          onClick={() => {
            setSelectedRegion('ARICA_AND_PARINACOTA_REGION');
            onMapClick('ARICA_AND_PARINACOTA_REGION');
          }}
          d="M194.2,33.7c0-0.3,0-0.5-0.1-0.8c-0.1-0.5-0.2-1-0.3-1.6s-0.3-1.3-0.4-2c-0.2-1.8-0.5-3.3-1.4-5
	c-0.1-0.2-0.2-0.4-0.3-0.6c-0.4-0.7-0.8-1.4-1-2.2c-0.1-0.4-0.2-0.8-0.4-1.3s-0.3-1-0.4-1.5c-0.2-1.3,0.3-2.5,0.7-3.6
	c0.1-0.4,0.3-0.6,0.5-0.9c0.3-0.5,0.6-1,0.5-1.5c-0.2-1-1.1-1.2-2.7-1.5c-0.9-0.2-1.8-0.3-2.4-0.8c-0.8-0.6-1.4-2.7-1.5-3
	c-0.2-0.8,0-1.5,0.1-2.2s0.2-1.3,0-1.9s-1-1.5-1.6-1.7c-0.2,0-0.4,0-0.6,0.2c0,0-0.1,0.2-0.1,0.4s0,0.5-0.2,0.8s-0.7,0.9-1.1,1.1
	c-1.1,0.4-1.9-0.3-2.7-0.8c-0.3-0.3-0.7-0.5-0.9-0.6c-1-0.3-2.2,0.1-2.6,1.2c-0.2,0.5-0.1,1,0,1.6c0.1,0.3,0.1,0.6,0.1,0.9
	c0,0.2,0,0.4,0,0.6c0,0.3,0,0.6,0.1,0.9c0.1,0.2,0.1,0.3,0.2,0.4c0.2,0.5,0.3,0.9,0.3,1.6c0,0.3,0,0.6,0,0.9c0,0.3,0,0.5,0,0.8
	c0,1.2-0.4,2-0.9,3c-0.2,0.3-0.3,0.6-0.4,1c-0.1,0.3-0.3,0.7-0.4,1c-0.6,1.2-2,2-3.1,2.6c-2.1,1-4.2,1.3-6.5,0.8
	c-0.2-0.1-0.5-0.1-0.8-0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c0,0.1,0,0.1,0.1,0.2c0.1,0.3,0,0.7,0,1c0,0.2,0,0.4,0,0.6
	c0,0.4,0.2,0.7,0.4,1c0.1,0.3,0.3,0.6,0.4,0.9c0.1,0.4,0.2,0.9,0.2,1.3v0.3c0.2,1.3,0.4,2.9,0.4,4.5c0,0.8,0.1,1.5,0.3,2.3
	c0.1,0.8,0.3,1.5,0.3,2.4c0,1.5,0,3,0.2,4.5c0.1-0.1,0.2-0.1,0.3-0.2l0.3-0.2c1-0.6,1.8-1,2.8-1.1h0.4c0.2,0,0.5,0,0.6-0.1
	c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.5-0.3,0.9-0.4c0.4-0.1,0.8-0.1,1.1-0.1s0.5,0,0.7-0.1c0.2,0,0.4-0.1,0.6-0.2
	c0.5-0.2,1.1-0.3,1.7-0.4c0.8,0,1.5,0,2.3,0c0.5,0,0.9,0,1.3,0c1.1,0,2.1,0.1,2.9,0.1c0.9,0.1,1.8,0.1,2.7,0.1c0.7,0,1.3,0,2.1,0.2
	c0.4,0.1,0.8,0.1,1.2,0.1c0.5,0,1,0.1,1.4,0.2c0.2,0,0.4,0.1,0.7,0.1c0.8,0.2,1.2,0.3,1.9,0.1c0.2-0.1,0.4-0.1,0.6-0.2
	c0.6-0.2,1.2-0.3,1.6-0.6c0.1,0,0.2-0.1,0.2-0.1c0.3-0.2,0.7-0.5,1.2-0.6c0-0.1-0.1-0.2-0.1-0.3C194.2,34.6,194.2,34.2,194.2,33.7z"
        />
        <path
          class={`st1 a12 region ${selectedRegion === 'COQUIMBO_REGION' && 'selected-region'} `}
          onClick={() => {
            setSelectedRegion('COQUIMBO_REGION');
            onMapClick('COQUIMBO_REGION');
          }}
          d="M169.7,280.7c-0.4,0-0.7-0.1-0.9-0.2l-0.2-0.1c0,0-0.1,0-0.2,0c-0.2,0-0.6,0-0.9-0.1c-0.3-0.1-0.6-0.2-0.7-0.3
	l-0.1-0.1c-0.5-0.2-1-0.4-1.6-0.5c-0.4-0.1-0.7-0.2-1.1-0.3c-0.2-0.1-0.5-0.1-0.9-0.1c-0.6-0.1-1.4-0.1-2.1-0.6
	c-0.9-0.5-1.4-1.3-2-2.1c-0.3-0.4-0.5-0.7-0.7-0.9c-1-1-0.9-2-0.9-2.9v-0.3c0-0.6,0.1-1.1,0.1-1.7c0.1-0.9,0.2-1.8,0.1-2.6
	c-0.1-0.8-0.8-1.9-1.9-2.9c-0.6-0.5-0.8-0.4-1-0.2l-0.3,0.2c-0.3,0.3-0.7,0.5-1.1,0.8c-0.4,0.3-0.9,0.4-1.2,0.5
	c-0.1,0-0.2,0.1-0.4,0.1c-0.8,0.3-1.4,2-1.4,4c0,0.1,0,0.2,0,0.3c0,0.5,0.1,1.9-1.6,2.2c-1.7,0.3-3.3-1.3-3.8-2.1
	c-0.3-0.5-0.5-0.9-0.6-1.3c-0.2-0.6-0.4-1-0.7-1.2c-0.2-0.1-0.5-0.2-0.9-0.3c-0.1,0-0.2,0-0.2-0.1c0,0.2,0.1,0.5,0.1,0.8
	s0,0.5,0,0.8c0,0.4-0.1,0.9,0,1.2c0.3,1,0.8,1.9,1.2,2.4c0.2,0.2,0.4,0.4,0.5,0.5c0.3,0.3,0.6,0.6,0.9,1c0.5,0.9,0.7,1.9,0.4,2.7
	c-0.2,0.6-0.5,0.9-0.8,1.1c-0.2,0.1-0.3,0.2-0.5,0.4c-0.2,0.4-0.3,0.9-0.4,1.4c-0.1,0.4-0.2,0.8-0.3,1.2c-0.2,0.7-0.6,1.1-0.9,1.5
	c-0.2,0.2-0.3,0.5-0.5,0.8c-0.4,0.6-0.7,1.3-0.9,2c0,0.5-0.1,1-0.3,1.5c-0.5,1.3-2,2.8-3.3,3.3c-0.3,0.1-0.8,0.1-1.2,0.2
	c-0.6,0-1.1,0.1-1.2,0.3c-0.2,0.5,0.1,1.3,0.4,2c0.3,0.6,0.5,1.2,0.5,1.8c0,0.6-0.1,1.2-0.3,1.8c-0.1,0.5-0.3,1-0.3,1.5
	c0,0.4,0.1,0.7,0.1,1.1c0.1,0.4,0.1,0.8,0.1,1.3c0,1.2,0,2.3,0.2,3.8c0,0.2,0,0.5,0,0.7c0,0.4,0,0.9,0.2,1.2
	c0.1,0.3,0.3,0.4,0.4,0.6c0.3,0.3,0.5,0.7,0.7,1.5c0.1,0.9,0.2,1.6,0.2,2.3c0,1.1-0.1,2-0.2,2.9c-0.1,0.4,0,0.6,0.2,1
	c0.1,0.2,0.2,0.5,0.3,0.8c0.2,0.8,0.2,1.6,0.3,2.4c0,0.6,0.1,1.1,0.1,1.6c0.1,0.4,0.2,1,0.2,1.6c0.2,1.2,0.4,2.5,0.5,3.4
	c0.3,1.8,0.6,3.4,0.6,5.2c0,0.3,0,0.6,0,0.8c0,0.8-0.1,1.6,0.1,2.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.3,0.3,0.4
	c0.2,0.5,0.3,1,0.4,1.5l0,0c0.4,0,0.7,0.2,0.9,0.5c0.3,0.1,2.2-0.1,2.5-0.4c0.2-0.2,0.3-0.6,0.5-0.9c0.2-0.4,0.4-0.8,0.6-1.1
	c0.2-0.3,0.4-0.5,0.7-0.8c0.1-0.1,0.2-0.2,0.2-0.2c0.2-0.2,0.4-0.5,0.7-0.8c0.6-0.8,1.3-1.7,2.2-2.2c0.2-0.1,0.5-0.2,0.7-0.3
	c0.2-0.1,0.3-0.1,0.5-0.2c0.6-0.4,1.4-0.9,2.7-0.4c0.7,0.2,1.4,0.6,1.9,1.1c0.4,0.4,0.8,0.7,1.1,1.2c0.1,0.1,0.1,0.1,0.1,0.2
	s0.1,0.1,0.1,0.2c0.1,0,0.2-0.1,0.5-0.1c0.6-0.2,1.4-0.4,2.1,0c1.3,0.5,1.8,1.6,2.1,2.5c0.1,0.2,0.2,0.4,0.3,0.5
	c0-0.1,0.1-0.2,0.2-0.2c0.3-0.3,0.7-0.6,1.3-1c0.7-0.4,1.7-1,1.8-1.6c0-0.1,0-0.2-0.2-0.5c-0.1-0.1-0.3-0.2-0.6-0.3
	c-0.3-0.1-0.6-0.3-0.8-0.5c-0.4-0.4-0.7-0.8-1-1.3c-0.1-0.2-0.2-0.3-0.3-0.5s-0.2-0.4-0.3-1.1c-0.1-0.4-0.2-1.1-0.4-1.4h-0.1
	l-0.1-0.2c-0.2-0.3-0.4-0.6-0.6-0.9c-0.5-0.8-1.1-1.7-1.2-2.8c0-0.6,0-1.1,0-1.7c0-0.3,0-0.6,0-0.9c0-0.8,0-1.4-0.3-2
	c-0.2-0.4-0.5-0.8-0.8-1.3s-0.7-1-0.9-1.6c-0.8-2,0.6-2.7,1.7-3.2c0.4-0.2,0.8-0.4,1.1-0.6c1-0.8,1.5-2.4,1.7-3.8l0.1-0.3
	c0.1-0.6,0.2-1.1,0.2-1.6c0-0.4-0.2-0.9-0.4-1.3c-0.2-0.3-0.3-0.7-0.4-1.1c-0.4-1.7-0.7-3.5,1-4.7c0.9-0.7,2.2-1.1,3.7-1.6
	c3.3-1.1,5.6-2,5.1-4.4c-0.2-0.7-0.5-1.1-1-1.6c-0.2-0.2-0.4-0.4-0.6-0.6c-0.6-0.8-0.7-2.1-0.5-2.9c0.2-0.7,0.6-1.3,1-1.9
	c0.5-0.7,0.9-1.4,0.9-2.2c0-0.5,0-0.9-0.1-1.2c0,0-0.1,0-0.1-0.1C170,280.8,169.8,280.8,169.7,280.7l0-0.4l0,0L169.7,280.7
	C169.9,280.7,169.8,280.7,169.7,280.7z"
        />
        <path
          class={`st1 a13 region ${selectedRegion === 'ATACAMA_REGION' && 'selected-region'} `}
          onClick={() => {
            setSelectedRegion('ATACAMA_REGION');
            onMapClick('ATACAMA_REGION');
          }}
          d="M198.8,182.2c-0.4,0-0.7-0.1-0.9-0.1s-0.4-0.1-0.6-0.1h-0.5c-0.5,0-1.1,0-1.6,0s-0.9-0.2-1.3-0.3
	c-0.2-0.1-0.4-0.1-0.5-0.1c-1-0.1-1.5,0.1-2,0.8c-0.2,0.3-0.2,0.7-0.2,1.4v0.2c0,0.9-0.2,2.3-0.6,3.3c-0.1,0.3-0.2,0.5-0.3,0.8
	c-0.4,0.9-0.7,1.8-1.4,2.6c-1.4,1.5-2.9,1.6-4.4,1.6h-0.3c-0.2,0-0.5,0-0.6,0c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.1-0.4,0.3-0.6,0.4
	c-0.2,0.1-0.4,0.2-0.5,0.3c-0.4,0.3-0.8,0.5-1.3,0.7c-0.2,0.1-0.5,0.1-0.6,0.2c-0.3,0.1-0.5,0.1-0.7,0.3c-1,0.5-2,1.1-3.3,1.2
	c-1.3,0.1-2.8-0.2-4-0.5c-1-0.2-1.9-0.6-2.7-0.9c-0.5-0.2-0.9-0.4-1.3-0.5c-0.2-0.1-0.5-0.2-0.8-0.3s-0.5-0.2-0.6-0.3
	c0,0,0,0-0.1,0.1l-0.2,0.1c-1.2,0.8-2.4,1-3.5,1.2c-0.4,0.1-0.9,0.2-1.3,0.4c-0.6,0.2-1.2,0.5-1.8,0.6c-0.2,0-0.4,0-0.7,0.1
	c-0.2,0-0.5,0-0.6,0.1s-0.2,0.1-0.3,0.2c-0.1,0.3-0.2,0.5-0.3,0.8c-0.2,0.4-0.4,0.8-0.5,1.2s-0.3,0.8-0.4,1.1
	c-0.2,0.4-0.4,0.8-0.4,1.2c-0.1,0.6-0.1,1.2,0,1.9c0,0.4,0,0.8,0,1.2c0,1.1-0.2,2.1-0.4,3.2c-0.1,0.4-0.1,0.8-0.2,1.1
	c-0.1,0.8-0.3,1.5-0.5,2.2c-0.1,0.4-0.2,0.8-0.3,1.2v0.1c-0.1,0.6-0.2,1.1-0.7,1.7c-0.3,0.4-0.6,0.6-0.9,0.9
	c-0.2,0.2-0.4,0.3-0.6,0.5c-0.6,0.7-0.7,1.3-0.9,2.2l-0.1,0.4c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.3-0.2,0.6-0.2,0.9
	c0.1,0.4,0.2,0.9,0.2,1.4c0.1,0.5,0.1,1,0.1,1.5c0.3,1.6,0.3,3.2,0.3,4.6c0,1.5-0.1,3.1-0.4,4.5c-0.2,0.8-0.7,2.2-1.7,2.6
	c-0.2,0.1-0.4,0.1-0.6,0.2c-0.2,0-0.3,0.1-0.4,0.3c-0.4,0.5-0.6,1-0.7,1.6c-0.1,0.6-0.1,1.2-0.2,1.9v0.1c-0.1,0.4-0.3,0.9-0.5,1.3
	c-0.1,0.2-0.1,0.6-0.1,0.9c0,0.4-0.1,0.8-0.2,1.2c-0.4,1.4-0.6,2.9-0.6,4.7c0,0.6,0,1.2,0,1.8v0.8c0,0.1,0,0.3,0,0.4
	c0,0.5,0.1,1.1-0.3,1.7c-0.4,0.6-1.2,1.1-1.9,1.4c-0.2,0.1-0.5,0.3-0.7,0.4c-0.3,0.2-0.6,0.3-0.9,0.4c-0.3,0.1-0.6,0.3-0.8,0.4
	c-0.1,0.2-0.4,0.3-0.6,0.3l0,0c0,1.4-0.1,2.8-0.8,4.2c-0.1,0.2-0.2,0.4-0.3,0.6c-0.3,0.5-0.5,0.9-0.6,1.4c-0.2,0.7,0.2,1.3,0.6,2
	c0.2,0.4,0.4,0.7,0.6,1.1l0.2,0.6c0.4,0.9,0.8,1.9,1,2.9c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.4,0.2,0.6,0.2c0.5,0.2,1.1,0.3,1.6,0.7
	c1,0.7,1.3,1.6,1.6,2.3c0.1,0.3,0.2,0.6,0.4,0.9c0.2,0.4,0.6,0.7,1,0.9l0,0c0-1.2,0.3-5.2,3-6.2c0.2-0.1,0.3-0.1,0.5-0.2
	c0.3-0.1,0.4-0.1,0.6-0.2c0.3-0.2,0.6-0.4,0.8-0.6l0.3-0.2c0.9-0.7,2.3-1.2,4.1,0.3c0.7,0.7,2.5,2.4,2.7,4.5c0.1,1.1,0,2.1-0.1,3.1
	c-0.1,0.5-0.1,1-0.1,1.5v0.3c0,0.8,0,0.9,0.2,1.2c0.3,0.3,0.6,0.7,0.9,1.2c0.4,0.6,0.8,1.1,1.2,1.4c0.3,0.2,0.6,0.2,1.1,0.3
	c0.4,0,0.9,0.1,1.3,0.2c0.3,0.1,0.6,0.2,0.9,0.2c0.7,0.2,1.4,0.3,2.1,0.7c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.1,0.1,0.1,0.1
	s0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.2,0,0.5,0,0.8,0.1l0.2,0.1c0.2,0.1,0.2,0.1,0.2,0.1h0.1c-0.3-0.8-0.6-1.6-0.9-2.4
	c-0.3-0.7-0.6-1.5-0.9-2.3c-0.4-1.1-0.6-2.9,0-4c0.7-1.4,2.2-2.1,3.4-2.4c0.9-0.3,1.6-1.2,2.1-2c0.6-1.1,0.5-2.1,0.5-3.4v-0.6
	c0-0.4,0-0.8,0-1.1c0-1.4,0-2.9,0.2-4.3c0.3-1.8,1-3.4,2.4-5.3c0.4-0.5,0.7-0.9,1.1-1.3c0.2-0.2,0.3-0.3,0.5-0.5
	c0.4-0.5,0.7-1,1-1.6c0.1-0.2,0.2-0.4,0.3-0.6c0.5-0.9,1-1.7,1.6-2.5c0.3-0.4,0.6-0.8,0.8-1.2c0.7-1,1.1-2.4,1.5-3.7
	c0.9-2.9,3.4-5,5.6-6.9c0.6-0.5,1.2-1,1.7-1.5c0.8-0.7,1.3-1.4,1.5-2c0.1-0.4,0.1-0.9,0.1-1.4v-0.4c0-0.4-0.1-0.8-0.1-1.1
	c-0.1-0.8-0.2-1.7,0.1-2.7c0.3-0.9,0.9-2.9,2.8-2.9l0,0c0.5,0,0.9,0.1,1.3,0.2c0.1,0,0.3,0.1,0.5,0.1c0.3,0.1,0.7,0,1.1,0
	c0.5,0,1.1-0.1,1.5,0s0.6,0.4,0.8,0.6c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0,0.4-0.2,1-0.5l0.2-0.1c0.2-0.1,0.5-0.3,0.7-0.4
	c0.3-0.2,0.6-0.4,0.9-0.5l0.4-0.2c0.6-0.3,0.8-0.4,1-1c0.3-1.1,0.3-2.6,0.1-3.9c-0.1-0.5-0.4-0.7-0.9-1.2l-0.2-0.1
	c-0.1-0.1-0.3-0.2-0.4-0.3c-0.4-0.3-0.9-0.7-1.2-1.2c-0.7-0.9-1.1-2.2-1.4-3.3l-0.1-0.5c-0.1-0.3-0.3-0.7-0.4-1
	c-0.3-0.7-0.6-1.3-0.7-2.1v-0.3c0-0.3,0-0.5-0.1-0.8v-0.1c-0.2-0.9-0.4-2.2,0.5-3c0.3-0.2,0.5-0.4,0.8-0.5c0.2-0.1,0.4-0.2,0.6-0.3
	c0.1-0.2,0.3-0.3,0.5-0.4c0.2-0.1,0.3,0,0.4,0c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.3-0.2,0.4-0.3c0.1,0,0.2-0.1,0.3-0.2
	c0.1,0,0.3-0.1,0.3-0.2c0.1-0.2,0-0.8-0.1-1.1c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.8-0.2-1.6-0.3-2.4c0-1.3-0.3-2.3-0.8-3.6
	c-0.3-0.8-0.7-1.5-1.1-2.2c-0.3-0.5-0.6-1-0.9-1.6c0-0.1-0.1-0.2-0.2-0.4C199.6,185.5,198.6,183.5,198.8,182.2z"
        />
        <path
          class={`st1 a14 region ${selectedRegion === 'VALPARAISO_REGION' && 'selected-region'}`}
          onClick={() => {
            setSelectedRegion('VALPARAISO_REGION');
            onMapClick('VALPARAISO_REGION');
          }}
          // VALPARASIO
          d="M165.1,345.2c-0.4-0.8-0.9-1.6-0.7-2.7c0.3-1.2,0.2-2.9-0.9-3.9l-0.2-0.1c-0.5-0.5-1.3-1.3-1.9-2.1l0,0
	c-1,0-1.8-0.5-2.3-1.5l0,0c-0.1-0.2-0.2-0.5-0.4-0.7c-0.3-0.6-0.5-1.1-0.8-1.2l0,0c-0.1,0-0.4,0.1-0.6,0.1c-0.7,0.2-2,0.6-3-0.6
	c-0.1-0.1-0.2-0.3-0.3-0.5c0-0.1,0-0.1-0.1-0.2c-0.2-0.3-0.5-0.5-0.7-0.8c-0.3-0.3-0.7-0.5-1.1-0.7c-0.1-0.1-0.2-0.1-0.4,0.1
	c-0.4,0.3-0.8,0.4-1.1,0.6c-0.1,0-0.3,0.1-0.4,0.2c-0.5,0.3-1,0.9-1.4,1.4c-0.3,0.4-0.6,0.7-0.8,1c-0.1,0.1-0.2,0.2-0.3,0.3
	c-0.2,0.2-0.3,0.3-0.4,0.5c-0.1,0.2-0.2,0.4-0.4,0.7c-0.3,0.6-0.6,1.2-1.1,1.7c-0.8,0.8-2.9,1.2-4.2,1c0,0,0,0,0,0.1
	c0.1,0.3,0.3,0.5,0.3,0.8c0.2,1-0.2,2.1-0.6,3.1c-0.1,0.3-0.2,0.5-0.3,0.7l-0.1,0.2c-0.2,0.6-0.4,1.2-0.8,1.7
	c-0.1,0.1-0.2,0.2-0.2,0.3c-0.2,0.2-0.2,0.3-0.3,0.6c-0.1,0.6,0,1.4,0,2.1c0,0.4,0,0.8,0,1.1c0,0.4,0,0.8,0.1,1.3
	c0.1,1,0.1,2.1-0.1,3l-0.1,0.3l-0.3,0.1c-1.2,0.4-2-0.6-2.6-1.5c-0.4-0.6-0.8-1.1-1.1-1.2c0,0.1,0.1,0.1,0.1,0.2
	c0.1,0.4,0.1,0.8,0.2,1.3c0,0.2,0,0.4,0.1,0.6c0.1,1.1,0,2.1-0.1,3.2c0,0.4-0.1,0.8-0.1,1.2v0.5c-0.2,1.9-0.3,3.6,0.1,5.4
	c0.3,1.2,0.6,2.5,0.6,4c0,1.3-0.6,2.5-1.1,3.7c-0.3,0.6-0.5,1.2-0.7,1.7c-0.1,0.2-0.2,0.5-0.3,0.7c0.1,0.1,0.2,0.2,0.3,0.3
	c0.1,0.1,0.1,0.2,0.1,0.2c0.2,0,0.3,0,0.5,0.1c1.6,0.5,2.2,0.3,2.3,0.2c0-0.1,0.1-0.2,0.1-0.4c0.1-0.3,0.1-0.5,0.2-0.9
	c0.6-1.2,1.1-2,1.7-2.4c0.8-0.5,1.7-0.7,2.5-0.9l0.5-0.1c0.1,0,0.4-0.1,0.5-0.1c0.1-0.3,0.3-0.9,0.4-1.2c0-0.3,0-0.7,0-1
	c0-0.4,0-0.8,0-1.3v-0.4c0.1-0.5,0.1-1.1,0.2-1.7c0.1-0.7,0.4-1.3,0.6-1.8c0.2-0.6,0.5-1.2,0.5-1.7c0.1-1,0.3-2.1,0.6-3.1
	c0.2-0.6,0.5-1,0.7-1.4l0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.3,0.3-0.7,0.7-1c0.7-0.7,1.4-0.7,2-0.7h0.2c0.1,0,0.2,0,0.2,0
	s0.2-0.2,0.3-0.3l0.1-0.1c1.3-1.3,2.4-1.6,4.2-1.1c0.7,0.2,1.4,0.4,2.1,0.9c0.4,0.3,0.8,0.7,1.1,1.1c0.3,0.3,0.5,0.6,0.9,0.9
	c0.7,0.5,1.5,1,2.1,1.1c0.4,0.1,1.1-0.2,1.7-0.4l0.4-0.1c0.8-0.3,1.4-0.5,1.9-0.8l0,0c0-0.5,0.3-1,0.8-1.1c0.2-0.1,0.4-0.1,0.6-0.1
	c-0.1-0.7-0.1-1.4-0.1-2v-0.6c0-0.4,0-0.8,0-1.3c0.1-1.1,0.1-2.1-0.1-3C165.6,346,165.4,345.6,165.1,345.2z"
        />
        <g className="a15 region">
          <path
            class={`st1 ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'}`}
            onClick={() => {
              setSelectedRegion('MAGALLANES_REGION');
              onMapClick('MAGALLANES_REGION');
            }}
            d="M201.8,855.3c-0.2-0.1-0.4-0.2-0.6-0.2c-0.3-0.1-0.5-0.2-0.8-0.4c-0.8-0.5-1.6-0.8-2.3-1
		c-0.2-0.1-0.5-0.1-0.7-0.2c-0.5-0.1-0.9-0.2-1.4-0.4l-0.4-0.1c-0.7-0.2-1.4-0.5-2-0.5c-0.5,0-1.1,0.1-1.7,0.3
		c-0.8,0.2-1.5,0.4-2.4,0.3c-0.3,0-0.5,0-0.8-0.1c-0.7,0-1.4-0.1-2-0.2c-0.5-0.1-1.1-0.7-1.9-1.6c-0.5-0.5-1.4-1.5-1.7-1.5h-0.5
		v-0.5V800c-0.7-0.2-1-0.7-1.3-1.2l-0.1-0.2c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.3,0.1-0.5,0.1h-0.2c-0.8,0.1-1.2,0.2-1.9,0.6
		c-0.5,0.3-2.1,1.2-3.6,0.9c-1.2-0.3-1.1-1.7-1-2.6c0-0.2,0-0.4,0-0.5v-0.2c0-1.1,0-1.5-0.7-1.7c-0.2-0.1-0.6,0-0.9,0
		c-0.9,0-2.1,0-2.6-1.1s0.5-2.8,1.1-3.3c0.5-0.4,1-0.6,1.6-0.9c0.2-0.1,0.5-0.2,0.7-0.3l0.9-0.4c0.3-0.1,0.6-0.3,0.9-0.4
		c-0.4-0.3-1-0.7-1.8-1.1c-0.5-0.2-1.1-0.4-1.6-0.6c-0.5-0.1-0.9-0.3-1.4-0.5c-1.1-0.4-1.6-0.8-2.4-1.4c-0.8-0.6-1.6-0.8-2.7-1
		c-1-0.2-1.8,0-2.9,0.3c-1.3,0.4-2.3,0.5-3.5,0.3c-2.6-0.3-5.1-1.4-7-3.3c-0.2,0-0.4,0-0.6,0c-0.1,0-0.3,0-0.4,0
		c-0.6,0-1.1-0.1-1.6-0.2c-0.4-0.1-0.9-0.1-1.3-0.1c-1.1,0-2.1,0.1-3.1,0.2c-0.6,0.1-1.2,0.1-1.9,0.2c-0.8,0-1.6-0.1-2.3-0.2
		c-0.7-0.1-1.4-0.2-2-0.2c-0.7,0-1.3,0.2-1.9,0.5c-0.4,0.1-0.8,0.3-1.2,0.4c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.2-0.9,0.3-1.3,0.1
		c-0.3-0.1-0.5-0.4-0.5-0.8c-0.1-0.4,0.1-0.7,0.2-1c0.1-0.1,0.1-0.3,0.1-0.4c0.1-0.5,0-1,0-1.4c-0.1-0.5-0.2-0.8-0.4-1.2
		s-0.5-0.8-0.8-1.2c-0.4-0.6-0.8-1.2-1.1-1.8c-0.1-0.3-0.3-0.6-0.5-0.8c-0.6-1.1-1.2-2.2-1.4-3.5l-0.1-0.4c-0.1-0.8-0.3-1.7,0.1-2.4
		l0,0c-0.1-0.3-0.2-0.7,0-1.1c0.1-0.2,0.3-0.4,0.6-0.4c0.3-1,0.3-2.1,0-3.1c-0.3-1.3-0.5-2.5-0.3-3.8c0-0.2,0.1-0.3,0.1-0.5
		c0.2-0.9,0.3-1.7,0-2.4c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.2-0.3-0.3-0.6c-0.1-0.2,0-0.4,0-0.5s0-0.2,0-0.2c-0.5-1.6-2.5-1.6-3.1-1.6
		c-1.1,0-1.7,0.4-2.6,1.1l-0.3,0.2c-1.2,0.8-2.3,1.6-3.4,2.5c-0.3,0.3-0.5,0.5-0.9,0.5s-0.6-0.3-0.8-0.6c-0.2-0.3-0.5-0.6-0.7-0.9
		c-0.4-0.8-0.6-2-0.6-2.3c-0.1-0.4,0-0.9,0-1.3c0-0.3,0-0.6,0-0.8c0-0.4-0.2-0.8-0.5-1.2c-0.1-0.2-0.3-0.4-0.4-0.7
		c-0.4-0.8-0.7-1.5-0.9-2.4c-0.1-0.2-0.1-0.5-0.1-0.8c-0.1-0.6-0.2-1.1-0.4-1.6c-0.3-0.7-0.6-1.4-1-2.1c-0.8-1.6-1.6-3.2-1.7-5
		c0-0.7,0-1.3,0-2c0-0.8,0.1-1.5,0-2.3c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.6-0.2-1.3-0.2-1.9c0-0.6-0.2-1.1-0.3-1.6
		c-0.3-1.3-0.7-2.8,1.3-3.8c0.8-0.4,1.6-0.4,2.4-0.5h0.4c0.4,0,0.4,0,0.6-0.3s0.2-0.7,0.2-1.1c0-0.4,0.1-0.8,0.2-1.3
		c0-0.1,0-0.1,0.1-0.2c-0.2,0-0.3-0.1-0.5-0.2c0,0-0.1,0-0.2,0c-0.2,0-0.3-0.1-0.5-0.1l-2.3-0.7c-0.4-0.1-0.9-0.3-1.3-0.4
		c-1.1-0.3-2-1-2.7-1.7l-0.3-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.4-0.2-0.5-0.4c-0.3-0.3-0.6-0.6-0.8-0.8
		c-0.2-0.2-0.3-0.4-0.5-0.5l-0.3-0.2c-0.2-0.2-0.5-0.4-0.7-0.6c-0.4-0.4-0.5-0.8-0.7-1.1c0-0.1-0.1-0.2-0.1-0.3
		c-0.1-0.2-0.4-0.4-0.6-0.6c-0.1-0.1-0.3-0.3-0.4-0.4c-0.2-0.2-0.4-0.5-0.5-0.6c-0.2-0.1-0.7-0.1-1.3,0c-0.2,0.2-0.5,0.4-0.8,0.4
		s-0.5,0-0.7-0.1c-0.2,0.6-0.3,1.3-0.4,1.9c-0.1,0.5-0.1,0.9-0.3,1.4c-0.4,1.9-0.6,3.7-0.6,5.5c0,0.4,0,0.7,0,1.1c0,0.7,0,1.5,0,2.2
		c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.1,0,0.3,0,0.4H99h0.2c0.2,0,0.5,0,0.8,0c0.4-0.1,0.9-0.1,1.5,0l0.3,0.1
		l0.1,0.3c0.1,0.3-0.1,0.8-0.5,1.7c-0.2,0.6-0.8,2.1-0.6,2.4h0.6l-0.1,0.5c0,0.3-0.3,0.6-0.5,0.8c-0.1,0.1-0.2,0.2-0.2,0.2
		c-0.2,0.4-0.1,0.5,0.1,0.9c0.2,0.3,0.4,0.7,0.3,1.3c0,0.2-0.1,0.5-0.1,0.7s-0.1,0.4-0.1,0.6c0,0.1,0,0.2,0,0.3c0,0.2,0,0.4-0.1,0.8
		c-0.3,1-0.7,2.1-1.5,3c-0.1,0.1-0.2,0.2-0.4,0.4c-0.7,0.7-1.3,1.3-1,1.8c0.2,0.3,0.7,0.7,1,1c0.2,0.2,0.4,0.3,0.6,0.4
		c0.4,0.4,0.8,0.7,1.2,1.1c0.2,0.2,0.5,0.5,0.7,0.7c0.1,0.1,0.2,0.1,0.3,0.2c0.7,0.5,1.3,1.1,1.4,1.7c0.1,0.5-0.1,0.8-0.2,0.9
		c-0.4,0.5-1,0.6-1.6,0.6c-0.8,0.1-1.7-0.1-2.5-0.2c-0.3,0-0.5-0.1-0.8-0.1c-0.1,0-0.2,0-0.4-0.1c-0.3-0.1-0.6-0.1-0.8-0.1
		c0,0.2,0.1,0.5,0.1,0.7c0.1,0.7,0.1,1.4,0.3,1.9c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.3,0.3,0.6,0.3,1l0.1,0.3c0.1,0.4,0.2,0.7,0.4,0.9
		c0.2,0.1,0.4,0.1,0.8,0l0.5-0.1l0.2,0.2c0.5,0.6,0.1,1.5-0.2,2.3c-0.1,0.2-0.2,0.4-0.2,0.6v0.2l-0.1,0.1c-0.4,0.4-0.8,0.4-1,0.4
		c-0.7-0.1-1-0.8-1.3-1.2c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.2-0.1-0.2-0.7,0.1l-0.2,0.1c-0.9,0.5-1.6,0.9-2.3,1.6
		c-0.3,0.3-0.6,0.5-0.9,0.7c-0.4,0.3-0.8,0.5-1,0.8c0.1,0.4,0.5,0.7,0.8,1c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.3,0.5,0.5,0.8,0.8
		c0.2,0.3,0.5,0.5,0.7,0.8c0.2,0.1,0.3,0.3,0.5,0.4c0.4,0.3,0.9,0.7,1.2,1.3l0.1,0.2c0.2,0.4,0.3,0.7,0.7,1c0.1,0.1,0.3,0.3,0.4,0.4
		c0.3,0.3,0.6,0.6,0.9,1c0.5,0.8,0.9,1.6,1.1,2.8c0,0.1,0,0.1,0,0.2c0.2-0.5,0.5-1.1,1.1-1.4c0.4-0.2,0.8-0.1,1.1-0.2
		c0.2,0,0.4-0.1,0.6-0.2c0.4-0.2,0.8-0.4,1.5-0.3c0.8,0.1,1.1,0.6,1.3,0.9c0.1,0.2,0.2,0.3,0.3,0.4c0.1,0.1,0.3,0.1,0.6,0.2
		c0.3,0,0.7,0.1,1,0.3c0.8,0.6,0.6,1.1,0.4,1.9l-0.1,0.2c-0.2,1-0.7,1.6-1.2,2.3c-0.1,0.2-0.3,0.4-0.4,0.6c-0.3,0.3-0.9,1.2-1.1,1.7
		c0.2,0,0.4,0,0.6,0c0.6,0,1.1-0.1,1.7,0.1c1,0.4,1.4,1.1,1.9,1.8l0.4,0.6c0.7,1.1,1.4,2.2,1.8,3.7c0,0.1,0.1,0.3,0.1,0.5
		c0.1,0.3,0.1,0.7,0.3,0.9c0.2,0.2,0.8,0.2,1.1,0.2c0.3,0,0.6,0,0.8,0.1c0.5,0.1,0.9,0.3,1.3,0.5c0.1,0.1,0.3,0.1,0.5,0.2
		c0.2,0.1,0.4,0.1,0.6,0.2c0.3,0.1,0.7,0.2,1,0.3c0.3,0.2,0.5,0.4,0.7,0.6c0.1,0.1,0.2,0.3,0.3,0.3c0.3,0.2,1-0.3,1.4-0.6
		c0.2-0.1,0.4-0.3,0.6-0.3c0.2-0.1,0.5-0.2,0.7-0.3c0.5-0.2,1-0.4,1.3-0.7c0.2-0.3,0.3-0.6,0.3-0.9c0-0.3,0.1-0.7,0.2-1.1
		c0.3-0.6,1.2-1.3,2.1-1.9l0.3-0.2c0.7-0.5,1.4-1,2.2-0.8c0.4,0.1,0.8,0.3,1,0.8c0.6,1,0.2,3.1-0.7,3.9c-0.5,0.4-1,0.4-1.6,0.1
		c-0.9,0.9-2.7,2.4-2.7,2.4c-0.4,0.3-0.8,0.5-1.2,0.7c-0.3,0.1-0.5,0.3-0.8,0.4c-0.4,0.3-0.9,0.5-1.4,0.7c-0.4,0.2-0.8,0.4-1.1,0.6
		c-0.1,0.1-0.3,0.2-0.4,0.2c-0.4,0.2-0.7,0.5-1.3,0.6c-1.5,0.2-2.5-0.6-3.5-1.5c-0.1-0.1-0.3-0.3-0.4-0.4c-0.3-0.4-0.5-0.6-0.9-0.6
		c-0.5-0.1-1.3,0.2-1.8,0.5c-0.8,0.5-1.4,1.4-1.4,2.3v0.1c-0.1,1.3,0,1.6,0.1,1.7c0.1,0,0.6-0.1,0.8-0.1c0.3,0,0.6-0.1,0.9-0.1
		c0.6,0,1.3,0.1,1.8,0.5c0.9,0.7,1.2,1.9,1.3,2.9c0,0.3,0.1,0.6,0.2,0.8c0.1,0.3,0.1,0.4,1.2,0.1c0.3-0.1,0.7-0.2,1-0.2
		c0.4,0,0.8,0.1,1.1,0.2c0.2,0.1,0.4,0.1,0.7,0.1c0.7,0.1,0.9-0.2,1.5-0.9c0.1-0.1,0.2-0.2,0.3-0.4c0,0,1.6-1.9,2.9-1.9l0,0
		c0.4,0,0.7,0.1,0.9,0.4c0.3,0.3,0.6,1.5,0.5,1.8c0,0.6-0.5,1.1-0.7,1.3c-0.4,0.4-0.5,0.5-0.9,0.5c-0.1,0-0.2,0-0.4,0.1
		c-0.1,0-0.4,0.2-0.5,0.2s-0.2,0.3-0.3,0.5c-0.3,0.5-0.7,1.2-1.4,1.2l0,0c-0.4,0-0.8-0.3-1-0.6c0,0.2,0,0.4,0,0.6
		c0,0.4,0,0.8-0.2,1.3l-0.1,0.3h-0.1v0.1v0.1c-0.1,0.5-0.2,1.1-0.2,1.7c0,0.7-0.1,1.4-0.3,2c-0.4,1.3-0.5,2.4-0.4,3.4
		c0.1,0.6,0.1,0.7,0.3,0.9c0.1,0,1.1,0,1.3-0.1c0.5-0.2,0.7-0.2,1.3-0.4c0.2,0,0.3-0.1,0.5-0.2c0.4-0.2,0.8-0.4,1.4-0.3
		c0.3,0.1,0.6,0.2,0.8,0.3c0.2,0.1,0.4,0.2,0.5,0.2c1.9,0.3,3.3-0.5,5.1-1.7s3.7-1.3,5.1-0.4c0.2,0.1,0.4,0.3,0.6,0.4
		c0.6,0.4,1.3,1,1.8,1l0,0c0.2-0.2,0.5-0.3,0.7-0.4c0.5-0.2,0.9-0.4,1.4-0.6c0.4-0.2,0.7-0.3,1.1-0.4c0.4-0.2,0.9-0.3,1.3-0.5
		c1.6-0.8,2.5-1.7,3.6-3c0.7-0.8,2-2.3,3.3-2.1c0.6,0.1,1.1,0.5,1.4,1.2c0.9,1.8-0.8,3.2-1.9,4.1l-0.2,0.1c-1.2,1-2.4,2.1-4,2.5
		c-0.5,0.1-0.9,0.1-1.4,0.1c-0.3,0-0.6,0-0.9,0c-0.9,0.1-1.3,0.6-1.9,1.3l-0.3,0.4c-0.7,0.9-1.8,2.3-3.1,2.5
		c-1.5,0.2-1.9-0.9-2.1-1.6c-0.1-0.4-0.2-0.7-0.4-0.9c-0.3-0.4-1.1-0.3-1.7-0.3h-0.2c-0.4,0-0.5,0.1-0.7,0.3
		c-0.1,0.2-0.3,0.3-0.5,0.5s-0.5,0.4-0.8,0.5c-0.1,0.1-0.2,0.1-0.3,0.2c-0.8,0.5-1.2,0.3-1.9,0c-0.3-0.2-0.6-0.4-0.8-0.5
		c-0.3-0.3-0.5-0.4-1-0.5c-0.8-0.1-1.6,0-2.4,0c-0.5,0-1.1,0.1-1.6,0c-1.9,0-3.4,0.1-4,1.6c-0.1,0.1-0.1,0.4-0.1,0.5
		c0.2,0.3,1.4,0.3,2.1,0.4c0.6,0,1.2,0,1.6,0.1c0.3,0.1,0.6,0.2,0.8,0.4c0.3,0.2,0.6,0.3,1,0.4c0.3,0,0.6,0,0.9,0c0.2,0,0.4,0,0.6,0
		c0.9,0,1.3,0,2.1-0.4l0.2-0.1c0.4-0.2,1-0.5,1.6,0c0.6,0.4,0.9,1.2,1.2,1.9c0.1,0.2,0.1,0.3,0.2,0.5c0.6,1.1,1.9,2.8,3.1,2.7
		c0.4,0,0.8-0.2,1.2-0.4c0.2-0.1,0.5-0.2,0.7-0.3c0.6-0.2,1.1-0.2,1.5-0.2c0.1,0,0.3,0,0.4,0c0.2,0,0.4,0,0.6,0c0.7,0,1.4,0,2.1,0.1
		c1.1,0.3,1.5,0.7,2.1,1.6l0.1,0.2c0.2,0.3,0.4,0.6,0.6,0.9c0.7,1,1.4,2,2.6,2.5c0.7,0.3,1.3,0.4,1.9,0.5c1.1,0.1,3.6-0.1,3.9-2.5
		c0.1-0.5,0.1-1.1,0.1-1.7c0-1.1,0-2.2,0.5-3.3c0.2-0.4,0.4-0.8,0.6-1.2c0.3-0.5,0.5-0.9,0.7-1.5c0.5-1.5,0.5-2.8,0.2-4.5
		c-0.2-0.9-0.5-1.8-0.8-2.6c-0.2-0.4-0.3-0.9-0.5-1.3c-0.3-0.9-0.2-1.4,0-2.2v-0.2c0.3-1.6,1.7-2.2,2.9-2.6c0.4-0.1,0.7-0.3,1-0.4
		c0.8-0.4,1.6-1.2,2.3-2c0.3-0.4,0.7-0.7,1-1s0.7-0.7,1-1c0.7-0.7,1.4-1.5,2.4-2c0.8-0.4,1.6-0.7,2.6-0.7c0.1,0,0.3,0,0.5,0
		c0.9-0.1,2-0.2,2.8,0.2c0.6,0.3,2,1.2,2,2.6c0,0.5-0.2,1-0.3,1.5c-0.2,0.9-0.7,1.5-1.4,1.8c-0.8,0.4-1.9,0.4-3-0.1
		c-0.3-0.1-0.6-0.4-0.9-0.6c-0.5-0.4-1-0.7-1.5-0.7c-0.2,0-0.6,0.2-0.6,0.3s0.4,0.8,0.6,1.2c0.6,1,1.4,2.4,0.1,3.2
		c-0.7,0.4-1.5-0.2-2.1-0.6c-0.2-0.1-0.4-0.3-0.5-0.4c0,0.1,0,0.1-0.1,0.3c-0.1,0.7,0.3,1.1,1.1,1.8c0.3,0.2,0.5,0.5,0.7,0.7
		c0.8,0.9,0.7,1.7,0.6,2.1c-0.2,0.5-0.6,1.1-1.8,1.5c-0.2,0.1-0.4,0.1-0.7,0.2c-0.9,0.2-1.5,0.4-1.9,1.1c-0.4,0.8-0.2,2-0.1,3
		c0,0.3,0.1,0.5,0.1,0.8l0.1,0.6c0.1,1,0.2,1.9,0.5,2.8c0.3,0.8,0.6,0.8,1.9,0.4l0.3-0.1c1.4-0.4,2.8-1.2,4.2-2
		c0.6-0.3,1.1-0.7,1.7-1c0.3-0.1,0.6-0.3,0.9-0.5c1.5-0.9,3.8-2.4,5.4-0.5c1,1.2,0.6,3.5,0.6,4c-0.1,0.8-0.5,1.4-1.2,2.1
		c-0.4,0.4-0.6,0.5-1,0.7l-0.2,0.1c-0.3,0.2-0.6,0.3-1,0.5c-0.2,0.1-0.5,0.3-0.7,0.4c-0.6,0.3-1.1,0.4-1.7,0.6
		c-0.7,0.2-1.3,0.3-1.9,0.8c-1.2,0.9-2.4,1.3-3.5,1.7c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.1-0.8,0.2-1,0.5c-0.8,0.9,0,3.1,0.3,4.2
		l0.1,0.2c0.4,1.2,0.7,1.8,1.5,2.5l0.3,0.2c1.1,1,2.2,2,3.4,2.6s2.7,0.8,4.1,0.9c0.6,0.1,1.3,0.2,1.9,0.3c0.2,0,0.5,0,0.9,0.1
		c1.5,0.1,2.6,0.2,3,0.7c0.4,0.6,0.1,1.7-0.1,2c-0.4,0.7-1.3,1.4-3.1,0.6c-0.9-0.4-1.9-0.6-3-0.8c-0.7-0.1-1.5-0.3-2.2-0.5
		c-0.4-0.1-0.8-0.3-1.2-0.6c-0.9-0.5-1.8-1-2.4-0.6c-0.2,0.1-0.3,0.4-0.4,0.7c-0.2,0.5-0.4,1.1-1.4,1.3c-0.2,0-0.4,0.1-0.6,0.1
		c-0.9,0.1-1.7,0.3-2.8-0.2c-0.4-0.2-0.8-0.5-1.1-0.7c-0.2-0.1-0.3-0.3-0.5-0.4c-0.4-0.3-0.7-0.4-1.3-0.5h-0.1c-1.2-0.4-2.4-1-3.7-2
		c-0.2-0.1-0.4-0.3-0.5-0.4c-0.2-0.2-0.4-0.3-0.6-0.5c0.1,0.2,0.2,0.3,0.2,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.5,0.8,0.9,1.4,1.1
		l0.3,0.1c0.6,0.2,1.3,0.4,1.5,1.3c0.2,0.8-0.1,1.5-0.3,2.1l-0.1,0.1c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.4-0.3,0.9-0.9,1.2
		c-0.7,0.3-1.6,0.3-2.2,0.1c-0.4-0.2-0.6-0.3-0.8-0.4c-0.4-0.2-0.5-0.3-1-0.3c-0.9,0.2-1.9,0.2-2.8,0.3c-0.7,0.1-1.5,0.1-2.2,0.2
		c-0.5,0.1-0.9,0.2-1.4,0.4c-0.1,0-0.3,0.1-0.4,0.2c-0.5,0.2-1.5,0.6-1.6,0.9c-0.1,0.2-0.2,1.2-0.2,1.6c0.1,0.7,1.7,0.7,2.6,0.8
		c0.2,0,0.5,0,0.6,0c0.5,0,1,0.2,1.4,0.4c0.2,0.1,0.5,0.2,0.7,0.2c0.8,0.2,1.5,0.3,2.5,0.3c0.9,0,1.7,0.2,2.4,0.4
		c0.5,0.2,1,0.3,1.5,0.4c0.3,0,0.7,0.1,1,0.1c1.2,0.1,2.5,0.2,3.5,0.8c0.4,0.3,0.8,0.6,1,0.9c0.5,0.5,0.8,0.9,1.6,0.8
		c0.2,0,0.3-0.1,0.4-0.1c0.3-0.1,0.7-0.2,1.1-0.1l0.3,0.1c0.4,0.1,0.6,0.1,0.9,0c0.3-0.1,0.7-0.3,0.9-0.4c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2-0.2,0.4-0.4,0.7-0.6c0.6-0.2,1.8-0.1,2.3,0.3l0.1,0.1c0.4,0.3,0.3,0.5,0.3,0.8c-0.1,0.4-0.3,0.6-0.5,0.9
		c-0.1,0.1-0.1,0.2-0.2,0.2c-0.3,0.5-0.5,1.1-0.8,1.7c-0.1,0.3-0.2,0.6-0.4,0.9c-0.1,0.2-0.2,0.4-0.3,0.6c-0.3,0.6-0.5,1.1-0.7,1.7
		c-0.1,0.5-0.1,1.1-0.1,1.6c0,0.2,0,0.4,0,0.5c0,1,0.2,1.3,0.6,2l0.2,0.4c0.3,0.5,0.5,1,0.6,1.6c0.2,0.7,0.4,1.3,0.8,1.8
		c0.5,0.7,1.3,1.4,2.1,1.9s2.3,1.1,3.1,0.7l0.1-0.1c0.1-0.3-0.5-1-0.8-1.5c-0.3-0.4-0.6-0.7-0.7-1c-0.3-0.8-0.1-1.2,0-1.8l0.1-0.2
		c0-0.1,0.1-0.2,0.1-0.4c0.1-0.5,0.3-1.3,0.9-1.6c0.6-0.3,1.2-0.1,1.7,0c0.1,0,0.2,0.1,0.4,0.1c0.3,0.1,0.7,0.2,1,0.4
		c0.3,0.1,0.5,0.3,0.8,0.3c0.5,0,1-0.2,1.5-0.4s1.1-0.5,1.7-0.5h0.1c1.6,0,2.5,1.3,3.1,2.4l0.2,0.3c0.4,0.6,0.7,1.2,1.1,1.9
		c0.4,0.8,0.8,1.6,1.4,2.3c0.3,0.4,0.7,0.8,1.1,1.2c0.4,0.4,0.7,0.7,1.1,1.2l0.1,0.1c0.4,0.5,0.6,0.7,1.1,0.8c0.6,0.1,0.9-0.4,1-0.8
		c0.1-0.3,0-0.8-0.2-1.4c-0.1-0.3-0.3-0.5-0.4-0.8c-0.2-0.4-0.5-0.8-0.6-1.3c-0.2-0.8-0.5-1.4-0.9-2.2c-0.5-1.1-1.5-2-2.4-2.9
		c-0.5-0.4-0.9-0.9-1.3-1.3l-0.1-0.1c-0.8-0.8-1.6-1.7-1.4-2.5c0.2-0.7,0.9-0.9,1.4-1c0.1,0,0.2-0.1,0.3-0.1c0.8-0.3,1.5-0.5,2.4,0
		c0.4,0.2,0.8,0.6,1.1,0.9c0.1,0.1,0.3,0.3,0.4,0.4c0.2,0.2,0.4,0.4,0.6,0.6c0.4,0.4,0.8,0.8,1.4,1.1c0.2,0.1,0.3,0.1,0.5,0.2
		c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0.2,0.8,0.6,1.1,0.9c0.1,0.1,0.3,0.3,0.4,0.4c0.8,0.7,1.5,0.7,2.5,0.2c0.2-0.1,0.4-0.2,0.6-0.4
		c0.7-0.4,1.4-0.8,2.2-0.8c0.7,0,1.7,0,2.5,0.5c0.2,0.1,0.5,0.3,0.9,0.5c0.7,0.5,1.8,1.2,2.4,1.1c0.7-0.1,0.8-1.4,0.8-2
		C202.9,856.8,202.5,855.7,201.8,855.3z"
          />
          <path
            class={`st1 ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'} `}
            d="M152.8,827l-0.2-0.7c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1H152c-0.5,0.2-0.5,0.5-0.3,1.4
		c0.1,0.9,0.6,1.7,1.3,2.2c0.2,0.1,0.3,0.3,0.5,0.4c0.2,0.2,0.4,0.4,0.7,0.5c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.5,0.3,0.7,0.6
		c0.1,0.2,0.3,0.5,0.4,0.8c0.2,0.6,0.5,1.1,0.9,1.4c0.4,0.3,0.9,0.2,1.7-0.1c0.2-0.1,0.3-0.2,0.3-0.4c0-0.1,0-0.2-0.1-0.4l-0.4-0.2
		c-0.4-0.2-0.7-0.5-1-0.7c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3-0.3-0.7-0.5-0.9-0.9c-0.7-1.1,0-2.3,0.5-3.1c0.2-0.3,0.3-0.5,0.4-0.7
		c0.1-0.2,0.1-0.4,0.1-0.7c0-0.2,0-0.3,0-0.5c0.1-0.6,0.1-1.2,0.1-1.9c0-0.6,0.1-1.2,0.1-1.8c0-0.3,0.1-0.6,0.1-0.9
		c0-0.1-0.1-0.3-0.3-0.5c-0.1-0.2-0.3-0.4-0.9-0.2c0,1,0.1,1.8,0,2.7c0,0.1,0,0.2,0,0.3c0,0.3,0,0.7-0.3,1.1l0,0
		c-0.4,0.5-0.8,0.8-1.2,1.1c-0.2,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.3-0.4,0.4L152.8,827z"
          />
          <path
            class={`st1 ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'} `}
            d="M140.8,834.5h0.4c0.2,0,0.4,0,0.5,0s0.2,0,0.3,0c0.1-0.1,0.1-0.1,0.1-0.2c0.3-0.4,0.6-1,1.3-1.1h0.2l0.2,0.2
		c0.2,0.2,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.3,0.3,0.4l0.1,0.1c0.3,0.3,0.6,0.5,0.9,1c0.1,0.3,0.2,0.5,0.3,0.8c0.1,0.4,0.2,0.7,0.4,1
		c0.1,0.1,0.2,0.1,0.3,0.1h0.2c0.3,0,0.7,0,1-0.1c0.1,0,0.2,0,0.3,0h0.1c0.1-0.1,0.1-0.1-0.1-0.7l-0.1-0.3c0-0.2-0.1-0.5-0.1-0.7
		c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.6-0.1-0.7c-0.1-0.1-0.4-0.1-0.7-0.2c-0.3,0-0.5,0-0.8-0.1c-0.9-0.3-1.1-1.3-1.2-2V832
		c-0.1-0.3-0.1-0.5-0.1-0.8c0-0.2,0-0.3,0-0.5s0-0.2-0.2-0.4c-0.1-0.1-0.1-0.2-0.2-0.3l-0.1-0.1c-0.1-0.2-0.2-0.2-0.3-0.3
		c-0.2-0.1-0.4-0.2-0.6-0.2l-0.3-0.1c-0.7-0.2-1.4-0.5-2.1-0.7l-0.3-0.1c-0.3-0.1-0.5-0.2-0.7-0.2c-0.4-0.1-0.6-0.1-0.9-0.4
		c-0.2-0.2-0.4-0.3-0.5-0.6c-0.1-0.1-0.1-0.2-0.1-0.2s0,0-0.2,0c-0.6-0.1-1.1,0.1-1.7,0.4l-0.4,0.1c-0.6,0.2-1.1,0.5-1.5,0.9
		c-0.3,0.3-0.4,0.5-0.3,1.1c0,0.1,0,0.2,0.1,0.2c0.1,0.3,0.2,0.6,0.1,0.9c-0.1,0.4-0.4,0.8-0.6,1.1c-0.1,0.1-0.1,0.2-0.2,0.2
		c-0.4,0.5-0.8,0.9-1.3,1.3c-0.1,0.1-0.2,0.2-0.3,0.3s-0.2,0.2-0.3,0.3s-0.3,0.3-0.5,0.4l-0.2,0.2c-0.6,0.6-1.1,1.3-1.2,2
		c-0.1,0.3,0,0.6,0,0.7c0-0.1,0.1-0.2,0.1-0.2c0.5-0.8,1-1.7,1.9-2.4l0.3-0.2c0.2-0.2,0.5-0.4,0.7-0.6c0.1-0.1,0.1-0.2,0.2-0.4
		c0.1-0.2,0.2-0.4,0.4-0.7c0.2-0.2,0.4-0.4,0.6-0.5c0.1-0.1,0.2-0.1,0.2-0.2c0.3-0.3,0.7-0.4,1-0.5c0.1,0,0.2-0.1,0.3-0.1
		c0.2,0,0.4,0.1,0.6,0.2c0.4,0.3,0.6,1,0.6,2c0,0.3,0,0.6-0.1,0.9c-0.1,0.5-0.1,1,0,1.4c0.2,0.7,0.5,1.3,0.7,1.3
		c0-0.1,0.1-0.6,0.2-0.8c0-0.1,0-0.2,0-0.2c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.1-0.4,0.2-0.6v-0.2c0.1-0.3,0.2-0.8,0.6-1.1l0.2-0.2
		l0.3,0.1c0.2,0.1,0.3,0.3,0.4,0.4c0.1,0.2,0.2,0.2,0.5,0.2C140.1,834.6,140.4,834.6,140.8,834.5z"
          />
          <path
            class={`st1 ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'}`}
            d="M130.1,828.8c0-0.2,0-0.4,0-0.5c0-0.6,0.1-0.8,0.3-1c0.3-0.3,0.6-0.3,0.8-0.3h0.1h0.1c0.1,0,0.2,0,0.3,0
		c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.2-0.2c0,0,0,0,0-0.1s0.1-0.4,0.3-0.6c0.1,0,0.1-0.1,0.2-0.1v-0.1
		c0-0.2-0.2-0.4-0.4-0.6l-0.1-0.1c-0.2-0.2-0.3-0.3-0.5-0.3c-0.1,0-0.3,0-0.4,0c-0.3,0-0.6,0-0.9-0.1c-0.6-0.2-1-1.1-1.1-1.3
		c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0.1-0.5c0-0.1,0.1-0.3,0-0.3c-0.1-0.1-0.7-0.1-1-0.1s-0.5,0-0.7,0
		c-0.6-0.1-1.3-0.7-1.6-1.2l-0.2-0.3c-0.2-0.4-0.4-0.8-0.7-1c-0.4-0.3-0.8-0.6-1.1-0.9l-0.1-0.1c-0.2-0.2-0.3-0.3-0.5-0.4
		c-0.2-0.1-0.4-0.1-0.6-0.1s-0.2,0-0.5,0.2s-0.5,0.2-0.7,0.3h-0.2c0,0-0.1,0.1-0.3,0.5c0,0,0,0.2,0,0.3c0,0.3,0,0.8-0.3,1.1
		c-0.1,0.1-0.3,0.2-0.6,0.3c-0.4,0-0.8-0.2-1.2-0.4c-0.2-0.1-0.4-0.2-0.6-0.3H118c-0.3,0-0.6-0.1-0.8-0.2c-0.2-0.1-0.4-0.2-0.5-0.3
		s-0.2-0.1-0.2-0.1c-0.4-0.2-0.8-0.3-1-0.8c-0.1-0.2-0.1-0.4-0.2-0.6c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.1-0.4-0.2-0.8-0.2
		s-0.8,0.1-1.2,0.3c-0.8,0.4-1.5,1.1-2.2,2.1c-0.2,0.3-0.3,0.4-0.2,0.5c0.1,0.1,0.4,0,0.5,0h0.2c0.6,0,1.2,0.1,1.8,0.1h0.2
		c0.4,0,0.9,0.1,1.2,0.7c0.1,0.2,0.1,0.3,0.2,0.5c0,0.1,0.1,0.2,0.1,0.4c0.3,0.7,0.2,1.3-0.3,1.6c-0.1,0-0.1,0.1-0.2,0.1
		c0.3-0.1,0.6-0.1,0.9,0c0.7,0.1,1.1,0.5,1.4,0.9c0.1,0.2,0.2,0.3,0.2,0.4v0.1c0,0.1,0,0.1,0.3,0.2c0.1,0,0.1,0,0.2,0.1
		c0.2,0.1,0.5,0.2,0.8,0.4c0.6,0.3,0.7,0.8,0.7,1.2v0.1c0,0.1,0,0.1,0.1,0.2c0.1,0.1,0.2,0.3,0.2,0.6c0,0.2,0,0.5,0,0.8v0.2
		c0,0.8-0.3,1.5-0.9,2.1c-0.2,0.2-0.3,0.3-0.5,0.5c-0.3,0.3-0.5,0.5-0.7,0.8s-0.4,0.6-0.5,0.9v0.1l-0.4-0.2l0.4,0.2
		c0,0-0.1,0.3-0.2,0.5c0.3,0.1,0.4,0.1,0.8-0.1c0.1,0,0.2-0.1,0.3-0.1c0.4-0.2,0.7-0.4,1-0.6l0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.2
		c0.1,0,0.2-0.1,0.3-0.1c0.3-0.2,0.2-1,0.2-1.5c0-0.2,0-0.4,0-0.6c0-0.5,0-0.9,0.5-1.3c0.3-0.3,0.6-0.6,0.9-0.8c0.9-0.8,1.9-1,3-0.6
		c0.7,0.2,1.3,0.7,1.7,1.3c0.2,0.3,0.3,0.5,0.2,0.9c-0.1,0.4-0.4,0.6-0.6,0.8c-0.1,0-0.1,0.1-0.1,0.1c-0.2,0.2-0.3,0.3-0.5,0.5
		s-0.4,0.5-0.6,0.7c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.4,0.3-0.5,0.5c-0.2,0.2-0.4,0.6-0.4,0.8c0,0,0,0,0.1,0
		c0.2,0,0.5-0.2,0.8-0.3c0.2-0.1,0.3-0.1,0.4-0.2c0.5-0.2,1-0.3,1.6-0.3c0.3,0,0.5-0.1,0.9-0.2c0.2-0.1,0.5-0.1,0.7-0.2
		c0.2,0,0.3,0,0.4,0c0.2,0,0.3,0,0.4-0.1c0.4-0.2,1-0.7,1.5-1.4l0.1-0.1c0.2-0.2,0.3-0.3,0.3-0.5
		C130.1,829.1,130.1,828.9,130.1,828.8z"
          />
          <path
            class={`st1  ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'}`}
            d="M111.9,811.6c0.3,0,0.6-0.2,1-0.5c0.1-0.1,0.2-0.1,0.3-0.2c-0.3-0.5-0.9-0.9-1.5-1.3c-0.2-0.1-0.4-0.2-0.6-0.3
		s-0.3-0.2-0.5-0.3l-0.7-0.1c-0.3-0.1-0.5-0.2-0.7-0.4c-0.8-0.5-1.4-0.9-2.2-1.1c-0.2-0.1-0.5-0.1-0.7-0.2c-0.2-0.1-0.5-0.1-0.7-0.2
		c-0.3-0.1-0.5-0.2-0.8-0.3c-0.1-0.1-0.3-0.1-0.4-0.2l-0.2-0.1c-0.4-0.1-0.8-0.3-1.2-0.4h-0.2c-0.5-0.1-1.1-0.2-1.5-1
		c-0.1-0.2-0.1-0.3-0.2-0.5s-0.1-0.3-0.2-0.5s-0.3-0.5-0.4-0.7s-0.2-0.4-0.3-0.6c-0.1-0.1-0.4-0.3-0.7-0.3c-0.1,0-0.2,0.3,0.1,0.9
		c0.2,0.4,0.4,0.7,0.6,1.1c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.5,0.7,1,1.1,1.4l0.3,0.4c0.4,0.5,0.6,0.8,0.8,1.3l0.1,0.2
		c0.1,0.2,0.2,0.3,0.4,0.4c0.1,0.1,0.3,0.1,0.4,0.2c0.3,0.1,0.6,0.2,1,0.5l0.1,0.1c0.1,0.1,0.1,0.1,0.1,0.1c0.2,0.1,0.4,0,0.7-0.2
		c0.2-0.1,0.5-0.2,0.8-0.2c0.4-0.1,1-0.1,1.4,0.1c0.4,0.2,0.7,0.5,1,0.8c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.1,0.3,0.2
		c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.2,0.2,0.4,0.3C111.1,811.6,111.5,811.6,111.9,811.6z"
          />
          <path
            class={`st1 ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'} `}
            d="M110.5,796.4c0-0.1,0-0.2,0.1-0.2v-0.1c0-0.1,0-0.2-0.1-0.3v-0.1c0-0.1-0.1-0.2-0.2-0.3
		c-0.1,0.3-0.2,0.7-0.4,1c-0.3,0.4-0.8,0.6-1.1,0.8l-0.3,0.2c-0.2,0.1-0.4,0.2-0.6,0.4c-0.1,0.1-0.1,0.1-0.2,0.4l-0.1,0.2
		c-0.1,0.2-0.2,0.6-0.1,0.7c0,0.1,0.1,0.2,0.4,0.3s0.7,0,1.2,0.1s0.9,0.4,1.3,0.6c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		c0.4,0.2,0.8,0.4,1.2,0.9l0.1,0.1c0.1,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2,0c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.4-0.2
		c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.3,0.2-0.5,0.2-0.9c0,0,0,0,0-0.1c0,0,0,0-0.1,0c-0.5,0-1.1,0-1.5-0.4c-0.2-0.2-0.3-0.5-0.5-0.7
		c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.2-0.4-0.5-0.5-0.8C110.4,797,110.5,796.5,110.5,796.4z"
          />
          <path
            class={`st1 ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'}`}
            d="M98.9,786.2c0-0.1,0-0.3-0.1-0.4c0-0.2-0.1-0.4-0.1-0.6c-0.1,0-0.1-0.1-0.2-0.1c-0.6-0.3-1.4-0.7-1.7-1.6
		c-0.2-0.5-0.2-0.9-0.2-1.4c0-0.3,0-0.6-0.1-0.9c-0.1-0.3-0.2-0.5-0.6-0.7c-0.1-0.1-0.3-0.1-0.4-0.2c-0.4-0.2-0.8-0.3-1.1-0.8
		c-0.2-0.3-0.2-0.6-0.3-0.9c-0.1-0.4-0.1-0.6-0.2-0.7l0,0c-0.1,0-0.4,0.2-0.5,0.6c-0.4,0.8-0.4,1.9,0,2.8c0.3,0.7,0.7,1.3,1.2,1.9
		l0.2,0.2c0.3,0.3,0.5,0.6,0.6,1.1l0.1,0.2c0.1,0.3,0.1,0.5,0.2,0.8l0.1,0.4c0,0.3,0.1,0.5,0.1,0.8c0,0.1,0.1,0.2,0.1,0.3
		c0.1,0.3,0.2,0.7,0.2,1.1c0,0.5-0.1,0.9-0.1,1.3c0,0.3-0.1,0.6-0.1,1c-0.1,0.9,0.1,1.2,0.3,1.2c0.4,0.1,0.9,0,1.2-0.3
		c0.5-0.5,0.6-1,0.8-1.8v-0.1c0.1-0.4,0.1-0.7,0.1-1.1c0-0.1,0-0.2,0-0.3c0-0.3,0-0.6,0-0.9c0.1-0.4,0.3-0.6,0.5-0.7
		C98.8,786.3,98.9,786.2,98.9,786.2z"
          />
          <path
            class="st1 ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'} "
            d="M106.3,783.4c-0.1-0.1-0.2-0.1-0.2-0.1l0,0c-0.3-0.2-0.7-0.4-0.9-0.8c-0.1-0.2-0.2-0.4-0.3-0.5
		c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.3-0.2-0.5-0.3c-0.3-0.1-0.7-0.3-0.9-0.6c0,0-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1c0,0.2,0.1,0.6,0.4,1c0.1,0.1,0.1,0.2,0.2,0.4s0.2,0.4,0.3,0.6
		c0.1,0.3,0.2,0.5,0.4,0.8c0.2,0.4,0.5,0.6,1,0.7c0.1,0,0.2,0,0.4,0c0.2,0,0.4,0,0.6,0s0.3,0.1,0.5,0.2l0.1,0.1
		c0.3,0.1,0.6,0.2,0.9,0.2c0-0.2,0-0.2,0-0.2C106.7,783.7,106.5,783.5,106.3,783.4z"
          />
          <path
            class={`st1 ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'}`}
            d="M105.4,788.3c-0.1,0-0.3,0-0.4-0.1c-0.2,0.6-0.5,1.2-0.8,1.7c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.1,0.2-0.2,0.4-0.3,0.5c0,0.3-0.1,0.6-0.1,0.9c0,0.3,0,0.3,0.1,0.3c0.1,0.1,0.2,0.1,0.4,0.1l0,0c0.2,0,0.4-0.3,0.4-0.6
		c0-0.1,0-0.2,0-0.2c0-0.3,0-0.7,0.4-1c0.1-0.1,0.3-0.2,0.4-0.3s0.1-0.1,0.2-0.1c0.1-0.1,0.1-0.3,0.1-0.7v-0.2c0-0.2,0-0.5,0-0.7
		C105.5,788.3,105.4,788.3,105.4,788.3z"
          />
          <path
            class={`st1  ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'}`}
            d="M87.3,736.3c0.1,0.1,0.2,0.2,0.4,0.3c0.4,0.3,0.8,0.6,1.3,0.7c0.5,0.2,0.8,0.2,0.8,0.1
		c0.1-0.1,0.2-0.3,0.2-1.1s0-1.7,0-2.5v-0.9c0-0.2,0-0.4,0-0.6c0-0.6-0.1-1.2,0.1-1.8c0.1-0.3,0.1-0.6,0.2-1
		c0.1-0.6,0.1-1.1,0.4-1.7l0.1-0.3l1.2,0.1c0.6,0.3,1.1,0.7,1.3,1.4c0.5,1,0.8,1.8,0.8,2.6s-0.2,1.5-0.3,2.2
		c-0.2,0.8-0.3,1.6-0.3,2.3c0,0.6,0,1.1,0.1,1.6v0.2c0.1,0.5,0.2,0.9,0.1,1.5c0,0.2-0.2,0.5-0.2,0.7c-0.1,0.1-0.1,0.3-0.2,0.4
		c0,0,0,0,0.1,0c0.3,0.1,0.7,0,1.3-0.4c0.1-0.1,0.3-0.2,0.4-0.3c0.3-0.2,0.5-0.4,0.8-0.6l0.2-0.2c0.2-0.2,0.5-0.5,0.6-0.7
		c0.3-0.6,0.4-1.4,0.5-2.2c0-0.3,0.1-0.5,0.1-0.7l0.1-0.4c0.1-0.8,0.2-1.5,0.2-2.2c0-0.5-0.3-1-0.6-1.5c-0.2-0.3-0.4-0.6-0.5-0.9
		l-0.1-0.3c-0.1-0.3-0.2-0.5-0.3-0.8c-0.1-0.3-0.1-0.7-0.2-1.1c0-0.1,0-0.2,0-0.3c0-0.3-0.1-0.7-0.1-1c0-0.2,0-0.5-0.1-0.7
		c0-0.4-0.1-0.8-0.2-1.3l-0.1-0.5c-0.3-1.7-0.1-3.4,0.2-5.1c0.1-0.5,0.1-1,0.2-1.5c0-0.2,0-0.3,0-0.5c0.1-0.6,0.1-1.2,0.4-1.8
		c0-0.2,0.1-0.3,0.2-0.6c0-0.2,0-0.5,0-0.7c0-0.6-0.1-1.3-0.2-1.8c-0.1,0-0.2,0.1-0.3,0.1c-1.2,0.2-1.7-0.5-2-0.8
		c-0.1,0-0.2,0-0.3-0.1c-0.3-0.1-0.5-0.3-0.6-0.4c-0.9-0.5-1.8-0.6-2.7-0.4c-0.3,0.1-0.5,0.2-0.7,0.3c-0.6,0.3-1.3,0.6-2.4,0.5
		c-0.3-0.1-0.6-0.2-0.9-0.3c-0.2-0.1-0.3-0.1-0.4-0.1c0,0-0.2,0-0.3,0.1c-0.3,0.1-0.5,0.1-0.8,0.1c-0.4,0-0.7,0-1,0
		c-0.5,0-0.9,0-1.1,0.1s-0.4,0.2-0.6,0.4c0,0.2-0.1,0.3-0.2,0.5c-0.2,0.2-0.3,0.4-0.6,0.5c0.2,0.5,0.4,1,0.6,1.5
		c0.4,1.2,0.4,2.5,0.4,3.7v0.7c0,1.2,0.1,2.4,0.1,3.5c0,0.5,0.1,1,0.2,1.4c0.1,0.7,0.3,1.4,0.3,2.2c0,0.2,0,0.5,0,0.7
		c0,1.2,0.1,2.4-0.7,3.4c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.2-0.2,0.5-0.2,0.7c-0.2,0.8-0.2,1.8,0.3,2.4
		c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.2,0.5,0.4,0.7,0.8c0,0.1,0.1,0.3,0.1,0.4c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.3,0L83,736
		c0.5-0.2,1.2-0.4,1.8-0.6c0.5-0.1,1-0.1,1.4,0.1C86.6,735.7,87,736.1,87.3,736.3z"
          />
          <path
            class={`st1 ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'}`}
            d="M87.1,748.6h0.3c0.4,0,0.9,0,1.3,0c0.3,0,0.6-0.6,0.8-0.9l0.2-0.4c0.4-0.6,0.8-1.4,1.5-1.8
		c0.2-0.2,0.5-0.2,0.7-0.3s0.4-0.1,0.5-0.2c0.3-0.2,0.5-0.8,0.6-1.3c0-0.2-0.1-0.3-0.1-0.4c-0.3-0.3-1.1-0.3-1.7-0.3
		c-0.2,0-0.5,0-0.7,0c-0.6-0.1-1.1-0.2-1.5-0.6c-0.6-0.5-0.7-1.2-0.8-1.7v-0.1c0-0.2-0.1-0.6-0.3-0.7c0,0-0.1,0-0.2,0s-0.2,0-0.3,0
		h-0.1h-0.1c-0.1,0.2-0.2,0.5-0.2,0.7c-0.3,1-0.7,2.1-0.9,3.1v0.1c-0.1,0.5-0.2,1.1-0.2,1.6c0,0.3,0,0.5,0.2,0.7l0.1,0.1
		c0.1,0.2,0.3,0.4,0.4,0.7c0.1,1-0.8,1.4-1.3,1.8c-0.2,0.1-0.4,0.2-0.5,0.3s-0.2,0.2-0.2,0.3c0.2,0,0.7-0.2,0.8-0.2l0.4-0.1
		C86.1,748.7,86.5,748.6,87.1,748.6z"
          />
          <path
            class={`st1 ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'}`}
            d="M86.6,752.1h-0.2l-0.2-0.1l0,0c-0.2,0.1-0.5,1.3-0.6,2c0,0.4-0.1,0.7-0.1,1.1c0,0.2,0,0.5,0,0.7s0,0.4-0.1,0.6
		c0,0.3-0.1,0.5-0.1,0.8s0.2,0.6,0.4,0.8c0.1,0.1,0.3,0.1,0.5,0s0.2-0.3,0.2-0.9c0-0.2,0-0.4,0-0.6c0.1-0.7,0.3-1.5,1.3-2
		c0.1-0.1,0.2-0.1,0.3-0.1c0.2-0.1,0.3-0.1,0.4-0.3c0.2-0.2,0.4-0.5,0.7-0.9l0.1-0.2c0.4-0.6,0.4-0.7,0.3-0.8
		C89.2,751.9,88.7,751.8,86.6,752.1z"
          />
        </g>
        <path
          class={`st0 ${selectedRegion === 'MAGALLANES_REGION' && 'selected-region'} `}
          d="M98.3,599.5L98.3,599.5C98.3,599.4,98.3,599.4,98.3,599.5C98.3,599.5,98.3,599.5,98.3,599.5z"
        />
        <g className="a16 region">
          <path
            class={`st1 ${selectedRegion === 'AYSEN_REGION' && 'selected-region'} `}
            onClick={() => {
              setSelectedRegion('AYSEN_REGION');
              onMapClick('AYSEN_REGION');
            }}
            d="M146.6,613.3l-0.1-0.1c-0.4-0.6-0.7-0.8-1.3-1.2c-0.2-0.1-0.3-0.3-0.5-0.4c-0.1-0.1-0.3-0.3-0.4-0.3
		c-0.6-0.3-2.7,0.7-3.4,1.1l-0.4,0.2c-0.7,0.3-1,0.4-1.8,0.2c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.2-0.6-0.2
		c-0.4,0.2-0.7,0-1-0.2c-0.5-0.4-0.8-1.4-1-2.5l-0.1-0.4c-0.2-0.9-0.1-1.5,0.2-2.1c0.3-0.5,0.7-1,1.1-1.3c0.2-0.2,0.4-0.4,0.6-0.6
		c-0.4-0.1-0.8-0.2-1.2-0.4c-0.3-0.2-0.5-0.4-0.7-0.6c-0.2-0.2-0.2-0.2-0.3-0.3l-0.3-0.1c-0.5-0.2-0.9-0.4-1.4-0.4
		c-0.8-0.1-1.3-0.5-1.7-0.9c-0.1-0.1-0.3-0.2-0.4-0.3l-0.1-0.1c-0.5-0.3-0.9-0.6-1.4-1.2l-0.4-0.5c-0.4-0.5-0.8-1.1-1.2-1.7
		c-0.1-0.2-0.2-0.5-0.4-0.8c-0.1-0.2-0.2-0.4-0.2-0.5c-0.1,0-0.5-0.1-0.6,0c-0.2,0.1-0.4,0.2-0.6,0.4c-0.3,0.2-0.6,0.4-0.8,0.6
		c-1.4,0.8-3-0.1-4-1.4c-0.2-0.3-0.4-0.6-0.5-0.9l0,0c-0.1,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-1.1-0.1l-0.4-0.1c-0.3-0.1-0.7,0-1.2,0.2
		c-0.5,0.1-1,0.2-1.6,0.2h-0.1c-0.1,0.2-0.2,0.4-0.3,0.7c-0.1,0.3-0.2,0.6-0.4,0.9c-0.1,0.2-0.2,0.3-0.3,0.5
		c-0.1,0.2-0.3,0.4-0.4,0.6l-0.1,0.3c-0.2,0.5-0.4,1-0.8,1.4c-0.4,0.3-0.8,0.4-1.1,0.5c-0.3,0-0.4,0.1-0.4,0.2c-0.2,0.2-0.1,0.5,0,1
		c0.1,0.2,0.1,0.4,0.1,0.5c0,0.2,0,0.4,0.1,0.6c0,0.5,0.1,0.9,0.3,1.3c0.2,0.4,0.4,0.8,0.7,1.2c0.6,1.1,1.3,2.3,1.6,3.6
		c0.2,1.1-0.1,1.7-1.2,2.1c-0.4,0.1-0.5,0.2-0.7,0.5c-0.1,0.1-0.2,0.2-0.4,0.4c-0.2,0.2-0.5,0.4-0.7,0.5c-0.3,0.2-0.4,0.2-0.5,0.6
		c-0.1,0.6-0.1,1.2,0,1.9c0,0.3,0,0.6,0,0.9c0,0.9-0.2,1.6-0.6,2.5c-0.1,0.2-0.3,0.5-0.4,0.7c-0.3,0.5-0.6,0.9-0.4,1.6
		c0,0.2,0.1,0.3,0.2,0.5l0.2,0.2c0.1,0.2,0.3,0.5,0.4,0.7c0.2,0.4,0.3,0.7,0.6,0.9c0.1,0.1,0.7,0.3,1.1,0.5c1.5,0.6,2.5,1.1,2.7,1.7
		c0.1,0.2,0.1,0.5-0.1,0.7l-0.1,0.2l-0.2,0.1c-1.3,0.4-2.6,1-3.9,1.6c0.7,0.3,1.3,0.9,1.7,1.7c0.4,0.8,0.3,1.4,0.1,2
		c0,0.1-0.1,0.3-0.1,0.5s-0.1,0.5-0.1,0.7c-0.1,1.2-0.3,2.5-2.1,3c-0.8,0.2-1.6,0.1-2.4,0.1c-0.5,0-1-0.1-1.4-0.1
		c-0.5,0-0.5,0.1-0.6,0.7c0,0.2-0.1,0.5-0.2,0.8c-0.2,0.5-0.5,0.7-0.7,0.9c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.5,0,0.8
		c0,0.2,0,0.5,0,0.7c0,0.4-0.1,0.8-0.3,1.2c0,0.5,0,1,0.2,1.4c0.1,0.5,0.1,1,0,1.4c0,0.5,0,1.1,0.1,1.5c0.1,0.2,0.3,0.5,0.4,0.8
		l0.1,0.2c0,0.2,0.1,0.5,0.1,0.7c0.1,0.2,0.2,0.3,0.5,0.4c0.2,0.1,0.4,0.3,0.6,0.5c0.7,0.8,0.5,1.6,0.4,2.3c0,0.2-0.1,0.4-0.1,0.6
		c-0.1,0.6-0.1,1.2-0.2,1.8l-0.1,1.2c0,0.1,0,0.2,0,0.3c-0.1,1-0.1,1.8-0.6,2.2l-0.3,0.2l-0.3-0.2c-0.4-0.3-0.7-0.6-1.1-0.8
		c-0.4-0.3-0.7-0.6-1.1-0.8c-0.1-0.1-0.2-0.1-0.3-0.2c-0.5-0.3-0.9-0.6-1.2-1.3c-0.4-1.2,0.3-1.9,0.8-2.6c0.1-0.1,0.2-0.2,0.3-0.3
		c0.7-0.9,0.8-1.9,0.3-2.7c-0.1-0.2-0.1-0.2-0.5-0.1c-0.2,0-0.4,0.1-0.6,0.1c-1.7,0.2-2.3-0.8-2.9-1.8c-0.1-0.1-0.1-0.2-0.2-0.3
		c-0.2-0.3-0.4-0.5-0.5-0.9c-0.2-0.6-0.2-1-0.1-1.5c0-0.2,0-0.5,0-0.7c-0.1-1.1-0.7-3.1-1.4-3.3c-0.3-0.1-1.4-0.1-1.9,0.1
		c0,0.2,0.1,0.4,0.1,0.6c0.1,0.6,0.3,1.3-0.1,2.1c-0.2,0.4-0.5,0.8-0.8,1.1c-0.6,0.7-1.5,1-2.3,1.2c-0.2,0.1-0.5,0.2-0.7,0.2
		l-0.2,0.1c-1.1,0.4-1.9,0.7-3.2,0.5c-0.2,0-0.5-0.1-0.8-0.2c-0.3-0.1-0.8-0.3-0.9-0.3c0,0-0.2,0.2-1.1,1.2l-0.1,0.1
		c-0.3,0.4-0.7,0.7-1,1.1c-0.1,0.1-0.3,0.3-0.4,0.4l0,0c0.3,0.1,0.6,0.2,0.9,0.3c0.4,0.1,0.8,0.2,1.2,0.3c0.1,0,0.3,0.1,0.4,0.1
		c0.9,0.2,2.2,0.5,2.6,1.7c0.4,1.3,0,3.7-0.8,4.7c-0.8,0.9-1.9,1.2-2.9,1.5c-0.6,0.2-1,0.5-1.5,0.9c-0.3,0.3-0.6,0.6-1,0.8
		c-0.2,0.1-0.3,0.2-0.5,0.3c-0.8,0.5-1.4,0.8-1.7,1.6c-0.3,0.8-0.6,1.4-1.1,2c0.9-0.9,2.2-1.6,3.2-2.1c0.2-0.1,0.4-0.2,0.6-0.3
		c1.3-0.7,2.7-1.1,4.1-1.1h0.4l0.1,0.4c0.2,0.6-0.4,1.3-0.8,1.7c-0.1,0.1-0.2,0.2-0.2,0.2l-0.2,0.3c-0.4,0.5-0.8,1.1-1,1.6
		c0.5,0.4,0.6,0.9,0.7,1.3c0.1,0.3,0.1,0.5,0.3,0.8c0.4,0.5,1.1,0.9,1.8,1.2c0.2,0.1,0.3,0.1,0.4,0.2l0.5,0.2
		c0.4,0.2,0.7,0.3,1.1,0.5c0.2,0.1,0.5,0.2,0.7,0.2c0.6,0.2,1.2,0.4,1.8,0.9c0.2,0.2,0.4,0.5,0.5,0.8c0.2,0.3,0.5,0.8,0.8,1
		c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.2-0.1-0.3-0.1-0.4l-0.1-0.4l0.4-0.2c1-0.5,2-0.4,3-0.3c-0.3-0.2-0.5-0.5-0.2-0.8l0.3-0.4l0.4,0.3
		c1.6,1,3.7,2.3,3.7,4.8c0,0.5-0.2,0.9-0.4,1.2c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.2-0.1,0.4-0.1,0.5c-0.1,0.4-0.2,0.9-0.8,1.4
		c-0.8,0.7-1.7,1.2-2.6,1.7s-1.7,0.9-2.3,1.5c-0.5,0.4-1,1.2-0.9,1.9c0.1,0.6,0.4,1,0.8,1.4c0.2,0.2,0.4,0.5,0.6,0.8s0.4,0.6,0.6,1
		c0.2,0.3,0.4,0.6,0.6,1c0.1,0.1,0.2,0.3,0.4,0.5c0.4,0.5,0.7,1,0.9,1.5c0.2,0.7,0.2,1.7-0.3,2.3c-0.2,0.3-0.5,0.4-0.7,0.5
		s-0.4,0.2-0.5,0.3s-0.1,0.3-0.1,0.5s0,0.5-0.1,0.8c-0.2,0.6-0.6,0.8-1,1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.9,0.6-1.5,1.5-1.7,2.5
		c-0.3,1.1-0.1,2.6,0.3,3.5c0.1,0.4,0.5,0.8,0.8,1.2c0.2,0.2,0.4,0.5,0.6,0.7c0.5,0.7,1.2,1.2,1.9,1.8c0.3,0.2,0.6,0.4,0.9,0.7
		c1.4,1.1,1.3,2.7,1.2,4c0,0.3,0,0.7,0,1c0,0.8,0.1,1.5,0.2,2.2c0.2,0.3,0.4,0.5,0.7,0.7c0.1-0.2,0.3-0.4,0.6-0.5
		c0.5-0.2,1.4-0.4,2.3-0.4c0.6,0,1.2,0.1,1.7,0.3c0.5,0.3,0.9,0.7,1.2,1c0.2,0.2,0.3,0.3,0.4,0.4c0.3,0.3,0.7,0.7,1,1.2
		c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.3,0.4,0.4c0.2,0.1,0.3,0.2,0.3,0.3c0.2,0.2,0.5,0.5,0.7,0.7
		s0.3,0.4,0.5,0.5c0.1,0.1,0.2,0.1,0.2,0.2c0.2,0.1,0.4,0.3,0.5,0.4l0.3,0.3c0.6,0.5,1.2,1,1.8,1.2c0.5,0.1,1,0.3,1.5,0.4l2.1,0.6
		h0.1c0.3,0,0.6,0.1,0.9,0.2c0.2,0.1,0.3,0.1,0.8,0.1c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.3,0.4-0.5c0.2-0.2,0.4-0.4,0.5-0.7
		c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.3,0.2-0.7,0.5-1c0.5-0.5,1.1-0.6,1.6-0.7c0.2,0,0.4-0.1,0.6-0.1c2-0.5,4.3-1.8,4.3-3.7
		c0-0.4-0.1-0.9-0.2-1.4c-0.1-0.7-0.3-1.5-0.1-2.2c0.1-0.4,0.2-0.7,0.4-0.9c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.4,0.3-0.9,0.4-1.4
		c0.1-0.6,0.2-1.1,0.5-1.7c0.3-0.8,0.9-1.7,1.9-2.8c0.4-0.5,0.9-1,1.4-1.5s1-1,1.5-1.5c0.1-0.1,0.1-0.2,0.2-0.2
		c0.3-0.3,0.4-0.4,0.3-0.8c0-0.5-0.3-0.8-0.6-1.1s-0.7-0.4-1.1-0.6c-0.6-0.3-1.3-0.6-1.7-1.4c-0.3-0.6-0.3-1.1-0.2-1.5
		c0-0.2,0-0.3,0-0.5c0-0.3-0.1-0.5-0.1-0.8c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.4-0.2-0.7-0.3-1c-0.3-0.8-0.5-1.5-0.3-2.6
		c0.2-0.7,0.5-1.1,0.8-1.6c0.1-0.2,0.2-0.4,0.4-0.6c0.2-0.3,0.3-0.5,0.4-0.9c0-0.1,0-0.3,0-0.5c0-0.4,0-0.8,0.2-1.1l0.2-0.8l0,0
		v-0.1c0.2-0.6,0.4-1.2,0.6-1.7c0.4-0.7,0.8-1.2,1.4-1.6l0.2-0.2c0.2-0.2,0.4-0.4,0.6-0.5c0.4-0.3,0.8-0.6,1.1-1.1
		c0.6-1,1.1-2.4,0.8-3.3c-0.1-0.3-0.3-0.5-0.5-0.8c-0.4-0.5-0.9-1.2-0.6-2.2c0.2-0.8,0.9-1.5,1.4-2.1c0.1-0.1,0.2-0.2,0.3-0.3
		l0.3-0.3c0.7-0.7,1.2-1.3,1.4-2.2c0.1-0.3,0.3-0.6,0.6-1.2c0.3-0.6,1.2-2.4,1.1-2.8c0,0-0.3,0-0.8,0l-1.3,0.1l0.9-1
		c0.1-0.1,0.2-0.2,0.2-0.2c0.2-0.2,0.4-0.4,0.5-0.6c0.3-0.6,0.3-1.2,0-1.8c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2-0.4-0.5-0.8-0.6-1.5
		c-0.1-0.4-0.1-0.8-0.1-1.2c0-0.1,0-0.3,0-0.4c0-0.7,0-1.2,0.6-1.9c0.2-0.2,0.5-0.4,0.7-0.6c0.4-0.3,0.7-0.6,0.9-0.9
		c0.6-1.4-0.2-3-0.8-4.3l-0.2-0.3c-0.5-1.1-0.7-2.3-0.6-3.4c0.1-0.6,0.4-1.1,0.6-1.5c0.2-0.4,0.4-0.7,0.5-1s0-0.6,0-0.9
		c0-0.2,0-0.4,0-0.6c0-1,0.5-2.1,1.3-3.3c0.5-0.7,1.1-1.4,1.8-1.9c0.4-0.3,0.8-0.4,1.2-0.6c0.2-0.1,0.4-0.2,0.6-0.3
		c0.8-0.4,1.2-1.8,1.3-3.9v-0.3c0-0.8,0-0.8-0.7-1.1c-0.5-0.2-1-0.4-1.4-0.6c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.6-0.3-0.9-0.4
		c-0.2-0.1-0.4-0.1-0.6-0.2c-0.6-0.2-1-0.3-1.7-0.4l-1.6-0.3c-0.7-0.1-1.3-0.2-2-0.4c-0.2,0-0.4-0.1-0.6-0.1c-1-0.2-2.3-0.4-3-1.1
		c-0.3-0.3-0.7-1-0.7-1.7c0-0.3,0.2-0.6,0.5-0.8s0.7-0.2,1.1-0.2c0.2,0,0.5,0,0.6,0c0.3-0.1,0.7-0.3,1-0.5s0.5-0.3,0.8-0.4
		c0.3-0.1,0.5-0.2,0.7-0.3c0.4-0.1,0.7-0.3,1-0.5c0.7-0.5,1.6-0.6,2.5-0.4c1,0.2,1.8,0.9,2.3,1.7c0.1,0.1,0.1,0.2,0.2,0.3
		c0.1,0.1,0.1,0.3,0.2,0.3c0,0,0.1,0,0.4-0.1c0.5-0.2,1-0.5,1.4-0.7c0.2-0.1,0.4-0.3,0.6-0.5c0.2-0.2,0.5-0.5,0.8-0.6
		c0.7-0.4,0.9-0.7,1.2-1.3c0.3-0.8,0.5-1.6,0.4-2.7C147.3,614.3,147.1,613.9,146.6,613.3z"
          />
          <path
            class={`st1 ${selectedRegion === 'AYSEN_REGION' && 'selected-region'}`}
            d="M78.5,663.5c-0.2,0.2-0.5,0.4-0.7,0.6c-0.5,0.5-1.1,0.9-1.5,1.4c-0.3,0.3-0.3,0.4-0.4,0.7
		c-0.1,0.7-0.2,1.4-0.1,2c0.3,0.9,1.2,1.8,2,2.3c0.5,0.4,1.5,0.6,1.9,0.2c0.3-0.4,0.3-1.3-0.1-2.9c-0.1-0.4-0.2-0.8-0.4-1.2
		c-0.4-1-0.9-2.2-0.2-3.5c0.1-0.1,0.2-0.3,0.3-0.4C79,662.9,78.8,663.2,78.5,663.5z"
          />
          <path
            class={`st1 ${selectedRegion === 'AYSEN_REGION' && 'selected-region'}`}
            d="M95.5,708c-0.4-0.4-0.6-0.8-0.9-1.2l-0.1-0.3c-0.1-0.2-0.3-0.4-0.4-0.6c-0.1-0.2-0.3-0.3-0.4-0.5
		c-0.2-0.3-0.3-0.7-0.3-1c0-0.2-0.1-0.3-0.1-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.3-0.5-0.3-0.9c-0.1-0.7-0.5-1.2-1.1-1.5l-0.5-0.2
		c-0.2-0.1-0.4-0.2-0.6-0.3s-0.4-0.2-0.7-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.6-0.3-0.8-0.8-0.9-1.3c-0.1-0.2-0.1-0.4-0.1-0.6
		c0-0.1,0-0.3,0-0.4c-0.1-0.2-0.1-0.2-0.5-0.2c-0.1,0-0.2,0-0.3,0h-0.3c-0.5,0-1-0.1-1.5-0.4l-0.3-0.2v-0.3c0-0.5,0.3-1,0.9-1.2
		c0.7-0.3,1.5-0.3,2.1,0.1c0.4,0.3,0.6,0.4,1,0.4c0.1,0,0.3-0.2,0.6-0.8c0.2-0.6,0.4-1.2,0.5-1.7c0-0.3,0.1-0.5,0.1-0.8
		s0-0.5,0.1-0.8c0-0.3,0.1-0.5,0-0.7c0-0.2-0.1-0.4-0.1-0.6c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.2-0.1-0.5-0.1-0.8c0-0.1,0-0.1,0-0.2
		c-0.4,0.4-0.7,0.8-1,1.3c-0.2,0.2-0.3,0.5-0.4,0.7s-0.2,0.4-0.3,0.5l-0.1,0.2c-0.3,0.4-0.6,1-1.1,1.3c-0.3,0.2-0.5,0.2-0.8,0.3
		c-0.1,0-0.2,0-0.3,0.1c-0.4,0.2-0.7,0.5-1.1,0.8c-0.1,0.1-0.3,0.3-0.4,0.4c-0.6,0.5-1.3,0.5-1.9,0.5c-0.1,0-0.2,0-0.3,0
		c-0.2,0-0.3,0-0.5,0c-0.8,0.2-1.4,0.5-2,0.9c-0.3,0.3-0.4,0.7-0.5,1.2c0,0.2-0.1,0.3-0.1,0.5l-0.1,0.5c-0.1,0.6-0.3,1.3-0.3,2
		s0.1,1.4,0.2,2c0.2,1,0.5,2.2-0.2,3.4c-0.1,0.2-0.2,0.3-0.3,0.5c-0.2,0.3-0.4,0.6-0.5,0.9c-0.2,0.7-0.1,1.6,0.3,2.4
		c0.2,0.4,0.5,0.8,0.7,1.1c0.4-0.4,0.9-0.7,1.6-1.1c0.9-0.5,1.7-0.4,2.4-0.4c0.3,0,0.5,0,0.7,0c0.1,0,0.2,0,0.3-0.1
		c0.4-0.1,0.8-0.2,1.3-0.1c0.3,0,0.6,0.2,0.9,0.3c0.2,0.1,0.3,0.1,0.4,0.1c0.3,0.1,0.5,0,1-0.3c0.3-0.2,0.7-0.3,1.2-0.5
		c1.6-0.4,3.1-0.2,4.5,0.6c0.1,0.1,0.2,0.1,0.2,0.2c0.2,0,0.6,0.1,0.9,0.4c0.1-0.2,0.1-0.3,0.2-0.5C95.7,708.6,95.8,708.3,95.5,708z
		"
          />
          <path
            class={`st1 ${selectedRegion === 'AYSEN_REGION' && 'selected-region'}`}
            d="M95.8,631.1c-0.8,0.4-1,0.8-0.9,2c0,0.1,0,0.2,0,0.3l0.5,0.3c0.3,0.2,1,0.3,1.3,0.1c0.1,0,0.2-0.3,0.3-0.5
		l0.2-0.4c0.2-0.4,0.4-0.8,0.5-1.3c0.3-1.6,0.1-1.9,0-2s-0.3,0-0.4,0.1l0,0l-0.2,0.2C96.7,630.4,96.4,630.8,95.8,631.1z"
          />
          <path
            class={`st1 ${selectedRegion === 'AYSEN_REGION' && 'selected-region'}`}
            d="M90.9,618.5c0.6,0,1.3,0,1.9,0.1l0.4,0.1v0.4c0,0.2,0,0.5,0,0.7c0,0.4,0,0.7,0.2,1.1l0.1,0.2
		c0.1,0.3,0.5,1.1,0.7,1.1c0.1,0,0.4-0.1,0.7-0.2c0.1,0,0.2-0.1,0.3-0.2c0.2-0.1,0.3-0.3,0.6-0.4c0.4-0.1,0.8-0.1,1.1-0.1H97
		c1.8,0,2,0.9,2,1.3c0,0.6-0.5,1.1-1,1.5c-0.1,0.1-0.2,0.2-0.3,0.2c-0.7,0.7-0.7,0.8-0.2,1.6c0.5,0.9,1.3,1.5,2.2,2.1l0.1,0.1
		c1,0.7,1.7,1.3,1.9,2.7c0.3,1.6,0.1,2.8-0.4,4c-0.2,0.5-0.4,1.5-0.2,2.2h0.1c0.4,0.3,0.9,0.3,1.2,0.3c0.6-0.1,1.3-0.4,1.7-0.9
		c0.5-0.6,0.5-1.6,0.5-2.5c0-0.2,0-0.4,0-0.7c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.2,0-0.3-0.1-0.5c0-0.1,0-0.2,0-0.4
		c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.2-0.2-0.5-0.1-1c0.1-0.4,0.3-0.6,0.5-0.9c0.2-0.2,0.3-0.3,0.3-0.5c0.1-0.3,0-0.5-0.3-0.8
		c-0.1-0.2-0.3-0.4-0.4-0.7s-0.2-0.8-0.3-1.2c-0.1-0.5-0.1-0.9-0.1-1.4s0-1-0.1-1.6c-0.2-0.8,0-1.4,0.4-2l0.1-0.1
		c0.2-0.3,0.3-0.5,0.2-0.8c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.2-0.3-0.5-0.3-0.9V619c0-0.1,0-0.2,0-0.3c0,0-0.1,0-0.3,0
		c-2-0.2-2-1.9-2-2.7c0-0.2,0-0.5,0-0.7c0-1,0-2,0.4-3.1c0.4-1,0.6-1.9,0.7-2.8c0.1-1.1-0.2-1.8-0.9-2.8c-0.1-0.1-0.3-0.4-0.4-0.6
		c0,0-0.1,0.1-0.2,0.2c-0.5,0.9-0.7,1.8-0.7,2.8c0,0.5-0.1,1-0.1,1.4c-0.1,0.6-0.1,1.2-0.1,1.9v0.3c0,1.1,0.1,2.9-1.7,3.2
		c-1.8,0.3-2.1-0.8-2.3-1.7c-0.1-0.2-0.1-0.4-0.2-0.6l-0.1-0.3c-0.2-0.5-0.2-0.6-0.5-0.6c-0.2,0-1.1,0.3-1.2,0.5
		c-0.2,0.2-0.2,0.5,0.1,1.1c0.3,0.6,0.7,1.6-0.2,2.4c-0.5,0.4-1.2,0.6-1.9,0.4c-0.8-0.1-1.6-0.6-2.1-1.2c-0.6,0-1,0.2-1.5,0.5
		c-0.2,0.1-0.4,0.2-0.7,0.4c-0.6,0.3-1.4,0.7-1.6,1.1c0.9,0.4,1.7,0.6,2.5,0.7C89.7,618.5,90.3,618.5,90.9,618.5z"
          />
          <path
            class={`st1 ${selectedRegion === 'AYSEN_REGION' && 'selected-region'}`}
            d="M99.1,599.3C99.1,599.3,99.2,599.3,99.1,599.3l0.2,0.2c0.2,0.1,0.5,0.3,0.7,0.4c0.3,0.2,0.7,0.4,1,0.5
		c0.1,0,0.3,0.1,0.5,0.1c0.4,0.1,0.8,0.1,1.1,0.3l0.1,0.1l0.1,0.1c0.1,0.2,0.2,0.4,0.4,0.5c0.1,0.1,0.2,0.1,0.3,0.2
		c0.3,0,0.5,0.1,0.8,0.3l0.1,0.1l0.1,0.2c0,0,0,0.1,0.1,0.1s0.2,0,0.4,0c0.3,0,0.4-0.3,0.4-0.4c0.1-0.4,0.1-0.8-0.1-1
		c-0.3-0.3-0.9-0.4-1.2-0.6c-0.6-0.2-1.2-0.5-1.9-1.1c-0.4-0.3-0.7-0.6-1-0.9c-0.8-0.9-1.4-1.4-2.4-1.3c-0.1,0.3-0.2,0.6-0.1,0.9
		c0,0.1,0.1,0.2,0.2,0.4C98.9,598.5,99.1,598.9,99.1,599.3z"
          />
        </g>
        <g>
          <line class="st2" x1="179.5" y1="27" x2="208.5" y2="27" />
          <circle class="st3" cx="208.2" cy="27" r="3.2" />
          <circle class="st4" cx="208.2" cy="27" r="1.7" />
        </g>
        <g>
          <line class="st2" x1="208.5" y1="137.8" x2="237.5" y2="137.8" />
          <circle class="st3" cx="237.2" cy="137.8" r="3.2" />
          <circle class="st4" cx="237.2" cy="137.8" r="1.7" />
        </g>
        <g>
          <line class="st2" x1="183.5" y1="65.5" x2="154.5" y2="65.5" />
          <circle class="st3" cx="154.8" cy="65.5" r="3.2" />
          <circle class="st4" cx="154.8" cy="65.5" r="1.7" />
        </g>
        <g>
          <path
            class="st5"
            d="M225.1,29.6h-4.3l-0.8,2.2h-1.3l3.5-9.7h1.5l3.5,9.7h-1.3L225.1,29.6z M224.7,28.6l-1.8-4.9l-1.8,4.9H224.7z"
          />
          <path
            class="st5"
            d="M231,24.3c0.4-0.2,0.9-0.4,1.5-0.4v1.3h-0.3c-1.4,0-2.1,0.8-2.1,2.3v4.2h-1.3V24h1.3v1.2
		C230.2,24.9,230.5,24.6,231,24.3z"
          />
          <path
            class="st5"
            d="M234,22.6c-0.2-0.2-0.3-0.4-0.3-0.6s0.1-0.4,0.3-0.6s0.4-0.3,0.6-0.3c0.2,0,0.4,0.1,0.6,0.3
		c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.3-0.6,0.3C234.4,22.8,234.2,22.8,234,22.6z M235.2,24.1v7.7h-1.3v-7.7
		C233.9,24.1,235.2,24.1,235.2,24.1z"
          />
          <path
            class="st5"
            d="M237.4,25.8c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.9,0,1.7,0.2,2.3,0.7s1,1.1,1.2,1.9h-1.4
		c-0.1-0.5-0.4-0.8-0.8-1.1s-0.8-0.4-1.4-0.4c-0.7,0-1.3,0.2-1.8,0.7c-0.4,0.5-0.7,1.2-0.7,2.1s0.2,1.6,0.7,2.1
		c0.4,0.5,1,0.8,1.8,0.8c0.6,0,1-0.1,1.4-0.4s0.6-0.6,0.8-1.1h1.4c-0.2,0.8-0.6,1.4-1.2,1.9c-0.6,0.5-1.4,0.7-2.3,0.7
		c-0.7,0-1.4-0.2-1.9-0.5c-0.6-0.3-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1C236.9,27.1,237.1,26.4,237.4,25.8z"
          />
          <path
            class="st5"
            d="M245.9,25.8c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5s1.3,0.1,1.8,0.4s0.9,0.7,1.1,1.1V24h1.3v7.7H252
		v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1
		C245.4,27.1,245.6,26.4,245.9,25.8z M251.6,26.4c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1s0.4-0.9,0.4-1.5
		S251.8,26.8,251.6,26.4z"
          />
          <path
            class="st5"
            d="M265.7,24.1l-4.6,11.3h-1.3l1.5-3.7l-3.1-7.6h1.4l2.4,6.2l2.4-6.2C264.4,24.1,265.7,24.1,265.7,24.1z"
          />
          <path
            class="st5"
            d="M276.4,26.9c-0.6,0.5-1.4,0.8-2.5,0.8H272v4.1h-1.3V22h3.1c1.1,0,1.9,0.3,2.5,0.8s0.9,1.2,0.9,2.1
		C277.2,25.7,277,26.3,276.4,26.9z M275.4,26.2c0.3-0.3,0.5-0.7,0.5-1.3c0-1.2-0.7-1.8-2.1-1.8H272v3.6h1.9
		C274.6,26.6,275.1,26.5,275.4,26.2z"
          />
          <path
            class="st5"
            d="M278.8,25.8c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4s0.9,0.7,1.1,1.1V24h1.3
		v7.7h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1
		C278.3,27.1,278.5,26.4,278.8,25.8z M284.5,26.4c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5S284.7,26.8,284.5,26.4z"
          />
          <path
            class="st5"
            d="M290.5,24.3c0.4-0.2,0.9-0.4,1.5-0.4v1.3h-0.3c-1.4,0-2.1,0.8-2.1,2.3v4.2h-1.3V24h1.3v1.2
		C289.8,24.9,290.1,24.6,290.5,24.3z"
          />
          <path
            class="st5"
            d="M293.5,22.6c-0.2-0.2-0.3-0.4-0.3-0.6s0.1-0.4,0.3-0.6s0.4-0.3,0.6-0.3s0.4,0.1,0.6,0.3
		c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.3-0.6,0.3C293.9,22.8,293.7,22.8,293.5,22.6z M294.8,24.1v7.7h-1.3v-7.7
		C293.5,24.1,294.8,24.1,294.8,24.1z"
          />
          <path
            class="st5"
            d="M303,24.8c0.6,0.6,0.9,1.4,0.9,2.4v4.5h-1.3v-4.3c0-0.8-0.2-1.4-0.6-1.8s-0.9-0.6-1.6-0.6s-1.2,0.2-1.6,0.6
		s-0.6,1-0.6,1.8v4.2h-1.3v-7.7h1.3V25c0.3-0.4,0.6-0.7,1-0.9c0.4-0.2,0.9-0.3,1.4-0.3C301.6,23.9,302.4,24.2,303,24.8z"
          />
          <path
            class="st5"
            d="M305.9,25.8c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4s0.9,0.7,1.1,1.1V24h1.3
		v7.7H312v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1
		C305.4,27.1,305.6,26.4,305.9,25.8z M311.6,26.4c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5S311.8,26.8,311.6,26.4z"
          />
          <path
            class="st5"
            d="M315.4,25.8c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.9,0,1.7,0.2,2.3,0.7c0.6,0.5,1,1.1,1.2,1.9
		h-1.4c-0.1-0.5-0.4-0.8-0.8-1.1s-0.8-0.4-1.4-0.4c-0.7,0-1.3,0.2-1.8,0.7c-0.4,0.5-0.7,1.2-0.7,2.1s0.2,1.6,0.7,2.1
		c0.4,0.5,1,0.8,1.8,0.8c0.6,0,1-0.1,1.4-0.4s0.6-0.6,0.8-1.1h1.4c-0.2,0.8-0.6,1.4-1.2,1.9s-1.4,0.7-2.3,0.7
		c-0.7,0-1.4-0.2-1.9-0.5c-0.6-0.3-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1C314.9,27.1,315.1,26.4,315.4,25.8z"
          />
          <path
            class="st5"
            d="M325.3,31.4c-0.6-0.3-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1c0-0.8,0.2-1.5,0.5-2.1s0.8-1.1,1.4-1.4
		s1.2-0.5,2-0.5s1.4,0.2,2,0.5s1.1,0.8,1.4,1.4s0.5,1.3,0.5,2.1s-0.2,1.5-0.5,2.1c-0.4,0.6-0.8,1.1-1.4,1.4s-1.3,0.5-2,0.5
		C326.5,31.9,325.8,31.7,325.3,31.4z M328.5,30.4c0.4-0.2,0.7-0.5,1-1c0.2-0.4,0.4-1,0.4-1.6s-0.1-1.1-0.4-1.6c-0.2-0.4-0.6-0.7-1-1
		c-0.4-0.2-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-0.9,1c-0.2,0.4-0.4,1-0.4,1.6s0.1,1.2,0.3,1.6c0.2,0.4,0.5,0.7,0.9,1
		c0.4,0.2,0.8,0.3,1.3,0.3C327.7,30.8,328.1,30.7,328.5,30.4z"
          />
          <path
            class="st5"
            d="M334.4,25.1v4.5c0,0.4,0.1,0.6,0.2,0.8s0.4,0.2,0.8,0.2h0.9v1.1h-1.1c-0.7,0-1.2-0.2-1.6-0.5s-0.5-0.9-0.5-1.6
		v-4.5h-1v-1h1v-1.9h1.3v1.9h2v1H334.4z"
          />
          <path
            class="st5"
            d="M337.9,25.8c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4s0.9,0.7,1.1,1.1V24h1.3
		v7.7H344v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1
		C337.4,27.1,337.6,26.4,337.9,25.8z M343.6,26.4c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5S343.8,26.8,343.6,26.4z"
          />
        </g>
        <g>
          <path
            class="st5"
            d="M254.1,140.4h-4.3l-0.8,2.2h-1.3l3.5-9.7h1.5l3.5,9.7h-1.3L254.1,140.4z M253.7,139.4l-1.8-4.9l-1.8,4.9H253.7
		z"
          />
          <path
            class="st5"
            d="M263.7,135.6c0.6,0.6,0.9,1.4,0.9,2.4v4.5h-1.3v-4.3c0-0.8-0.2-1.4-0.6-1.8c-0.4-0.4-0.9-0.6-1.6-0.6
		s-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.8v4.2h-1.3v-7.7h1.3v1.1c0.3-0.4,0.6-0.7,1-0.9s0.9-0.3,1.4-0.3
		C262.4,134.8,263.2,135,263.7,135.6z"
          />
          <path
            class="st5"
            d="M268.2,135.9v4.5c0,0.4,0.1,0.6,0.2,0.8s0.4,0.2,0.8,0.2h0.9v1.1H269c-0.7,0-1.2-0.2-1.6-0.5s-0.5-0.9-0.5-1.6
		v-4.5h-1v-1h1V133h1.3v1.9h2v1H268.2z"
          />
          <path
            class="st5"
            d="M273.2,142.2c-0.6-0.3-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1s0.2-1.5,0.5-2.1s0.8-1.1,1.4-1.4
		c0.6-0.3,1.2-0.5,2-0.5s1.4,0.2,2,0.5s1.1,0.8,1.4,1.4c0.3,0.6,0.5,1.3,0.5,2.1s-0.2,1.5-0.5,2.1c-0.4,0.6-0.8,1.1-1.4,1.4
		c-0.6,0.3-1.3,0.5-2,0.5C274.4,142.7,273.8,142.5,273.2,142.2z M276.4,141.3c0.4-0.2,0.7-0.5,1-1c0.2-0.4,0.4-1,0.4-1.6
		s-0.1-1.1-0.4-1.6c-0.2-0.4-0.6-0.7-1-1c-0.4-0.2-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3s-0.7,0.5-0.9,1c-0.2,0.4-0.4,1-0.4,1.6
		s0.1,1.2,0.3,1.6c0.2,0.4,0.5,0.7,0.9,1c0.4,0.2,0.8,0.3,1.3,0.3C275.6,141.6,276,141.5,276.4,141.3z"
          />
          <path
            class="st5"
            d="M283.9,135.9h-1.6v6.6H281v-6.6h-1v-1h1v-0.5c0-0.9,0.2-1.5,0.7-1.9s1.2-0.6,2.1-0.6v1.1c-0.6,0-1,0.1-1.2,0.3
		s-0.3,0.6-0.3,1.1v0.5h1.6L283.9,135.9L283.9,135.9z"
          />
          <path
            class="st5"
            d="M285.3,136.6c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.9,0.7,1.1,1.1
		v-1.4h1.3v7.7h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4
		c-0.3-0.6-0.5-1.3-0.5-2.1C284.9,137.9,285,137.2,285.3,136.6z M291,137.2c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3
		s-0.9,0.1-1.3,0.3s-0.7,0.6-0.9,1c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3
		s0.9-0.1,1.3-0.3s0.7-0.6,0.9-1c0.2-0.4,0.4-0.9,0.4-1.5S291.3,137.6,291,137.2z"
          />
          <path
            class="st5"
            d="M299.7,135.2c0.5,0.3,0.9,0.7,1.1,1.1v-1.4h1.3v7.8c0,0.7-0.1,1.3-0.4,1.9s-0.7,1-1.3,1.3
		c-0.6,0.3-1.2,0.5-1.9,0.5c-1,0-1.8-0.2-2.5-0.7s-1.1-1.1-1.2-1.9h1.3c0.1,0.5,0.4,0.8,0.9,1.1c0.4,0.3,1,0.4,1.6,0.4
		c0.7,0,1.3-0.2,1.7-0.7c0.4-0.4,0.7-1.1,0.7-1.8v-1.6c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.9-0.5
		s-1-0.8-1.3-1.4c-0.3-0.6-0.5-1.3-0.5-2.1s0.2-1.5,0.5-2.1s0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5
		C298.6,134.8,299.2,134.9,299.7,135.2z M300.5,137.2c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3s-0.7,0.6-0.9,1
		c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3s0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5S300.7,137.6,300.5,137.2z"
          />
          <path
            class="st5"
            d="M304.3,136.6c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.9,0.7,1.1,1.1
		v-1.4h1.3v7.7h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4
		c-0.3-0.6-0.5-1.3-0.5-2.1C303.8,137.9,304,137.2,304.3,136.6z M309.9,137.2c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3
		s-0.9,0.1-1.3,0.3s-0.7,0.6-0.9,1c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3
		s0.9-0.1,1.3-0.3s0.7-0.6,0.9-1c0.2-0.4,0.4-0.9,0.4-1.5S310.2,137.6,309.9,137.2z"
          />
          <path
            class="st5"
            d="M314.9,142.4c-0.5-0.2-0.8-0.5-1.1-0.8c-0.3-0.4-0.4-0.8-0.4-1.2h1.3c0,0.4,0.2,0.7,0.5,0.9s0.7,0.4,1.3,0.4
		c0.5,0,0.9-0.1,1.1-0.3c0.3-0.2,0.4-0.5,0.4-0.8s-0.1-0.6-0.4-0.7c-0.3-0.2-0.8-0.3-1.4-0.5c-0.6-0.1-1-0.3-1.4-0.5
		s-0.7-0.4-0.9-0.7c-0.3-0.3-0.4-0.7-0.4-1.2c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.6-0.6,1-0.8s0.9-0.3,1.5-0.3c0.8,0,1.5,0.2,2.1,0.6
		c0.5,0.4,0.8,1,0.8,1.8H318c0-0.4-0.2-0.7-0.5-1c-0.3-0.2-0.7-0.4-1.2-0.4s-0.8,0.1-1.1,0.3c-0.3,0.2-0.4,0.5-0.4,0.8
		s0.1,0.5,0.2,0.6c0.2,0.2,0.4,0.3,0.6,0.4c0.2,0.1,0.6,0.2,1,0.3c0.6,0.1,1,0.3,1.3,0.4c0.3,0.1,0.6,0.4,0.9,0.7
		c0.2,0.3,0.4,0.7,0.4,1.1c0,0.4-0.1,0.8-0.4,1.1c-0.2,0.3-0.6,0.6-1,0.8s-0.9,0.3-1.5,0.3C315.9,142.7,315.3,142.6,314.9,142.4z"
          />
          <path
            class="st5"
            d="M322.6,135.9v4.5c0,0.4,0.1,0.6,0.2,0.8s0.4,0.2,0.8,0.2h0.9v1.1h-1.1c-0.7,0-1.2-0.2-1.6-0.5
		s-0.5-0.9-0.5-1.6v-4.5h-1v-1h1V133h1.3v1.9h2v1H322.6z"
          />
          <path
            class="st5"
            d="M326.1,136.6c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.9,0.7,1.1,1.1
		v-1.4h1.3v7.7h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4
		c-0.3-0.6-0.5-1.3-0.5-2.1C325.7,137.9,325.8,137.2,326.1,136.6z M331.8,137.2c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3
		s-0.9,0.1-1.3,0.3s-0.7,0.6-0.9,1c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3
		s0.9-0.1,1.3-0.3s0.7-0.6,0.9-1c0.2-0.4,0.4-0.9,0.4-1.5S332,137.6,331.8,137.2z"
          />
        </g>
        <g>
          <line class="st2" x1="149.5" y1="300.1" x2="178.5" y2="300.1" />
          <circle class="st3" cx="178.2" cy="300.1" r="3.2" />
          <circle class="st4" cx="178.2" cy="300.1" r="1.7" />
        </g>
        <g>
          <path
            class="st5"
            d="M189.5,297.4c0.4-0.8,1-1.4,1.8-1.8c0.7-0.4,1.6-0.6,2.5-0.6c1.1,0,2,0.3,2.8,0.8s1.4,1.2,1.7,2.2h-1.5
		c-0.3-0.6-0.7-1-1.2-1.4c-0.5-0.3-1.1-0.5-1.8-0.5s-1.3,0.2-1.8,0.5s-1,0.8-1.3,1.4s-0.5,1.3-0.5,2.1c0,0.8,0.2,1.5,0.5,2
		c0.3,0.6,0.7,1,1.3,1.4c0.5,0.3,1.2,0.5,1.8,0.5c0.7,0,1.3-0.2,1.8-0.5s0.9-0.8,1.2-1.4h1.5c-0.4,0.9-0.9,1.7-1.7,2.2
		s-1.7,0.8-2.8,0.8c-0.9,0-1.7-0.2-2.5-0.6c-0.7-0.4-1.3-1-1.8-1.8c-0.4-0.8-0.6-1.6-0.6-2.6S189,298.2,189.5,297.4z"
          />
          <path
            class="st5"
            d="M201.5,304.5c-0.6-0.3-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1c0-0.8,0.2-1.5,0.5-2.1s0.8-1.1,1.4-1.4
		c0.6-0.3,1.2-0.5,2-0.5s1.4,0.2,2,0.5s1.1,0.8,1.4,1.4c0.3,0.6,0.5,1.3,0.5,2.1s-0.2,1.5-0.5,2.1c-0.4,0.6-0.8,1.1-1.4,1.4
		c-0.6,0.3-1.3,0.5-2,0.5C202.7,305,202.1,304.8,201.5,304.5z M204.7,303.6c0.4-0.2,0.7-0.5,1-1c0.2-0.4,0.4-1,0.4-1.6
		s-0.1-1.1-0.4-1.6c-0.2-0.4-0.6-0.7-1-1c-0.4-0.2-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-0.9,1c-0.2,0.4-0.4,1-0.4,1.6
		s0.1,1.2,0.3,1.6s0.5,0.7,0.9,1c0.4,0.2,0.8,0.3,1.3,0.3C203.9,303.9,204.3,303.8,204.7,303.6z"
          />
          <path
            class="st5"
            d="M209.1,298.9c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5s1.2,0.1,1.7,0.4s0.9,0.7,1.1,1.1v-1.4h1.3v11.3
		h-1.3v-5.1c-0.2,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.8,0.4s-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1
		C208.6,300.2,208.7,299.5,209.1,298.9z M214.7,299.5c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3
		c-0.4,0.2-0.7,0.6-0.9,1s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3
		c0.4-0.2,0.7-0.6,0.9-1s0.4-0.9,0.4-1.5S215,299.9,214.7,299.5z"
          />
          <path
            class="st5"
            d="M225.3,297.2v7.7H224v-1.1c-0.2,0.4-0.6,0.7-1,0.9c-0.4,0.2-0.9,0.3-1.4,0.3c-0.6,0-1.1-0.1-1.6-0.4
		s-0.9-0.6-1.1-1.1c-0.3-0.5-0.4-1.1-0.4-1.8v-4.5h1.3v4.3c0,0.8,0.2,1.3,0.6,1.7s0.9,0.6,1.6,0.6c0.7,0,1.2-0.2,1.6-0.6
		s0.6-1,0.6-1.8v-4.2H225.3z"
          />
          <path
            class="st5"
            d="M227.5,295.7c-0.2-0.2-0.3-0.4-0.3-0.6s0.1-0.4,0.3-0.6s0.4-0.3,0.6-0.3c0.2,0,0.4,0.1,0.6,0.3
		c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.3-0.6,0.3S227.7,295.9,227.5,295.7z M228.8,297.2v7.7h-1.3v-7.7H228.8z"
          />
          <path
            class="st5"
            d="M241.7,297.4c0.5,0.2,0.8,0.6,1.1,1.1s0.4,1.1,0.4,1.8v4.5H242v-4.3c0-0.8-0.2-1.4-0.6-1.8s-0.9-0.6-1.5-0.6
		c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.8v4.2h-1.3v-4.3c0-0.8-0.2-1.4-0.6-1.8c-0.4-0.4-0.9-0.6-1.5-0.6
		c-0.7,0-1.2,0.2-1.6,0.6s-0.6,1-0.6,1.8v4.2h-1.3v-7.7h1.3v1.1c0.3-0.4,0.6-0.7,1-0.9c0.4-0.2,0.9-0.3,1.4-0.3
		c0.6,0,1.2,0.1,1.7,0.4s0.9,0.7,1.1,1.3c0.2-0.5,0.6-1,1.1-1.3s1-0.4,1.7-0.4C240.7,297.1,241.3,297.2,241.7,297.4z"
          />
          <path
            class="st5"
            d="M247.8,297.5c0.5-0.3,1.1-0.4,1.7-0.4c0.7,0,1.3,0.2,1.9,0.5s1,0.8,1.3,1.4s0.5,1.3,0.5,2.1
		c0,0.8-0.2,1.5-0.5,2.1s-0.8,1.1-1.3,1.4c-0.6,0.3-1.2,0.5-1.9,0.5s-1.2-0.1-1.7-0.4s-0.9-0.7-1.1-1.1v1.4h-1.3v-10.4h1.3v4.1
		C246.9,298.2,247.3,297.8,247.8,297.5z M251.5,299.5c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3
		c-0.4,0.2-0.7,0.6-1,1c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.6,0.8,1,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3
		c0.4-0.2,0.7-0.6,0.9-1s0.4-0.9,0.4-1.5C251.8,300.4,251.7,299.9,251.5,299.5z"
          />
          <path
            class="st5"
            d="M256.2,304.5c-0.6-0.3-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1c0-0.8,0.2-1.5,0.5-2.1s0.8-1.1,1.4-1.4
		c0.6-0.3,1.2-0.5,2-0.5s1.4,0.2,2,0.5s1.1,0.8,1.4,1.4s0.5,1.3,0.5,2.1s-0.2,1.5-0.5,2.1c-0.4,0.6-0.8,1.1-1.4,1.4s-1.3,0.5-2,0.5
		C257.4,305,256.8,304.8,256.2,304.5z M259.4,303.6c0.4-0.2,0.7-0.5,1-1c0.2-0.4,0.4-1,0.4-1.6s-0.1-1.1-0.4-1.6
		c-0.2-0.4-0.6-0.7-1-1c-0.4-0.2-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-0.9,1c-0.2,0.4-0.4,1-0.4,1.6s0.1,1.2,0.3,1.6
		s0.5,0.7,0.9,1c0.4,0.2,0.8,0.3,1.3,0.3C258.6,303.9,259,303.8,259.4,303.6z"
          />
        </g>
        <g>
          <line class="st2" x1="156.5" y1="365.5" x2="185.5" y2="365.5" />
          <circle class="st3" cx="185.2" cy="365.5" r="3.2" />
          <circle class="st4" cx="185.2" cy="365.5" r="1.7" />
        </g>
        <g>
          <path
            class="st5"
            d="M201.4,370.3l-2.3-4h-1.5v4h-1.3v-9.8h3.1c0.7,0,1.4,0.1,1.9,0.4s0.9,0.6,1.1,1c0.3,0.4,0.4,0.9,0.4,1.5
		c0,0.7-0.2,1.3-0.6,1.8c-0.4,0.5-1,0.9-1.7,1l2.5,4.1H201.4z M197.6,365.3h1.9c0.7,0,1.2-0.2,1.6-0.5c0.3-0.3,0.5-0.8,0.5-1.4
		s-0.2-1-0.5-1.3s-0.9-0.5-1.6-0.5h-1.9V365.3z"
          />
          <path
            class="st5"
            d="M204.6,370.1c-0.2-0.2-0.3-0.4-0.3-0.6s0.1-0.4,0.3-0.6s0.4-0.3,0.6-0.3c0.2,0,0.4,0.1,0.6,0.3
		c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.3-0.6,0.3S204.8,370.3,204.6,370.1z"
          />
          <path
            class="st5"
            d="M221.4,360.6v9.7h-1.3v-7.2l-3.2,7.2H216l-3.2-7.2v7.2h-1.3v-9.7h1.4l3.6,8l3.6-8H221.4z"
          />
          <path
            class="st5"
            d="M223.3,370.1c-0.2-0.2-0.3-0.4-0.3-0.6s0.1-0.4,0.3-0.6s0.4-0.3,0.6-0.3c0.2,0,0.4,0.1,0.6,0.3
		c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.3-0.6,0.3S223.5,370.3,223.3,370.1z"
          />
        </g>
        <g>
          <line class="st2" x1="144.5" y1="412.2" x2="173.5" y2="412.2" />
          <circle class="st3" cx="173.2" cy="412.2" r="3.2" />
          <circle class="st4" cx="173.2" cy="412.2" r="1.7" />
        </g>
        <g>
          <path
            class="st5"
            d="M194.2,407.3v9.7h-1.3v-7.2l-3.2,7.2h-0.9l-3.2-7.2v7.2h-1.3v-9.7h1.4l3.6,8l3.6-8H194.2z"
          />
          <path
            class="st5"
            d="M196.3,411.1c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5s1.3,0.1,1.8,0.4s0.9,0.7,1.1,1.1v-1.4h1.3v7.7
		h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1
		C195.9,412.3,196,411.7,196.3,411.1z M202,411.6c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1s0.4-0.9,0.4-1.5
		S202.2,412.1,202,411.6z"
          />
          <path
            class="st5"
            d="M212.6,409.3v7.7h-1.3v-1.1c-0.2,0.4-0.6,0.7-1,0.9c-0.4,0.2-0.9,0.3-1.4,0.3c-0.6,0-1.1-0.1-1.6-0.4
		s-0.9-0.6-1.1-1.1c-0.3-0.5-0.4-1.1-0.4-1.8v-4.5h1.3v4.3c0,0.8,0.2,1.3,0.6,1.7s0.9,0.6,1.6,0.6c0.7,0,1.2-0.2,1.6-0.6
		s0.6-1,0.6-1.8v-4.2H212.6z"
          />
          <path class="st5" d="M216,406.6V417h-1.3v-10.4H216z" />
          <path
            class="st5"
            d="M225.2,413.6H219c0,0.8,0.3,1.3,0.8,1.8c0.5,0.4,1,0.6,1.7,0.6c0.6,0,1-0.1,1.4-0.4s0.6-0.6,0.8-1h1.4
		c-0.2,0.7-0.6,1.3-1.2,1.8c-0.6,0.5-1.4,0.7-2.3,0.7c-0.7,0-1.4-0.2-2-0.5s-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1
		s0.2-1.5,0.5-2.1s0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,2-0.5c0.7,0,1.4,0.2,1.9,0.5s1,0.8,1.3,1.3s0.5,1.2,0.5,1.9
		C225.2,413.1,225.2,413.4,225.2,413.6z M223.6,411.3c-0.2-0.4-0.5-0.6-0.9-0.8c-0.4-0.2-0.8-0.3-1.2-0.3c-0.6,0-1.2,0.2-1.6,0.6
		c-0.5,0.4-0.7,1-0.8,1.7h4.8C223.9,412.1,223.8,411.7,223.6,411.3z"
          />
        </g>
        <g>
          <line class="st2" x1="131.5" y1="453.8" x2="160.5" y2="453.8" />
          <circle class="st3" cx="160.2" cy="453.8" r="3.2" />
          <circle class="st4" cx="160.2" cy="453.8" r="1.7" />
        </g>
        <g>
          <path
            class="st5"
            d="M177.1,454c0.3,0.2,0.5,0.5,0.7,0.9c0.2,0.3,0.3,0.7,0.3,1.1c0,0.5-0.1,0.9-0.4,1.3c-0.3,0.4-0.6,0.7-1.1,0.9
		c-0.5,0.2-1,0.3-1.7,0.3h-3.6v-9.8h3.5c0.7,0,1.2,0.1,1.7,0.3s0.8,0.5,1,0.9s0.4,0.8,0.4,1.3c0,0.6-0.2,1.1-0.5,1.4
		c-0.3,0.4-0.7,0.7-1.2,0.8C176.5,453.6,176.9,453.7,177.1,454z M172.6,453h2.1c0.6,0,1.1-0.1,1.4-0.4c0.3-0.3,0.5-0.7,0.5-1.2
		s-0.2-0.9-0.5-1.2c-0.3-0.3-0.8-0.4-1.4-0.4h-2.1V453z M176.3,457.1c0.4-0.3,0.5-0.7,0.5-1.2s-0.2-1-0.6-1.3
		c-0.4-0.3-0.9-0.5-1.5-0.5h-2.2v3.4h2.3C175.5,457.5,175.9,457.4,176.3,457.1z"
          />
          <path
            class="st5"
            d="M179.9,449.4c-0.2-0.2-0.3-0.4-0.3-0.6s0.1-0.4,0.3-0.6s0.4-0.3,0.6-0.3c0.2,0,0.4,0.1,0.6,0.3
		c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.3-0.6,0.3C180.3,449.6,180.1,449.6,179.9,449.4z M181.1,450.9v7.7h-1.3
		v-7.7H181.1z"
          />
          <path
            class="st5"
            d="M184.7,458.2c-0.6-0.3-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1c0-0.8,0.2-1.5,0.5-2.1s0.8-1.1,1.4-1.4
		c0.6-0.3,1.2-0.5,2-0.5s1.4,0.2,2,0.5s1.1,0.8,1.4,1.4c0.3,0.6,0.5,1.3,0.5,2.1c0,0.8-0.2,1.5-0.5,2.1s-0.8,1.1-1.4,1.4
		c-0.6,0.3-1.3,0.5-2,0.5C185.9,458.7,185.3,458.5,184.7,458.2z M188,457.2c0.4-0.2,0.7-0.5,1-1c0.2-0.4,0.4-1,0.4-1.6
		s-0.1-1.1-0.4-1.6s-0.6-0.7-1-1c-0.4-0.2-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-0.9,1s-0.4,1-0.4,1.6s0.1,1.2,0.3,1.6
		s0.5,0.8,0.9,1s0.8,0.3,1.3,0.3C187.1,457.6,187.5,457.5,188,457.2z"
          />
          <path
            class="st5"
            d="M194.7,451.2c0.5-0.3,1.1-0.4,1.7-0.4c0.7,0,1.3,0.2,1.9,0.5c0.6,0.3,1,0.8,1.3,1.4s0.5,1.3,0.5,2.1
		c0,0.8-0.2,1.5-0.5,2.1s-0.8,1.1-1.3,1.4c-0.6,0.3-1.2,0.5-1.9,0.5s-1.2-0.1-1.7-0.4s-0.9-0.7-1.1-1.1v1.4h-1.3v-10.4h1.3v4.1
		C193.8,451.9,194.2,451.5,194.7,451.2z M198.4,453.2c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3
		c-0.4,0.2-0.7,0.6-1,1c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5s0.6,0.8,1,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3
		c0.4-0.2,0.7-0.6,0.9-1s0.4-0.9,0.4-1.5C198.8,454.1,198.6,453.6,198.4,453.2z"
          />
          <path class="st5" d="M203.7,448.7l-3,1.6v-1l3-1.8V448.7z M203,450.9v7.7h-1.3v-7.7H203z" />
          <path
            class="st5"
            d="M206.6,458.2c-0.6-0.3-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1c0-0.8,0.2-1.5,0.5-2.1s0.8-1.1,1.4-1.4
		c0.6-0.3,1.2-0.5,2-0.5s1.4,0.2,2,0.5s1.1,0.8,1.4,1.4c0.3,0.6,0.5,1.3,0.5,2.1c0,0.8-0.2,1.5-0.5,2.1s-0.8,1.1-1.4,1.4
		c-0.6,0.3-1.3,0.5-2,0.5C207.8,458.7,207.2,458.5,206.6,458.2z M209.8,457.2c0.4-0.2,0.7-0.5,1-1c0.2-0.4,0.4-1,0.4-1.6
		s-0.1-1.1-0.4-1.6s-0.6-0.7-1-1c-0.4-0.2-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-0.9,1s-0.4,1-0.4,1.6s0.1,1.2,0.3,1.6
		s0.5,0.8,0.9,1s0.8,0.3,1.3,0.3C209,457.6,209.4,457.5,209.8,457.2z"
          />
        </g>
        <g>
          <line class="st2" x1="120.5" y1="515.4" x2="149.5" y2="515.4" />
          <circle class="st3" cx="149.2" cy="515.4" r="3.2" />
          <circle class="st4" cx="149.2" cy="515.4" r="1.7" />
        </g>
        <g>
          <path class="st5" d="M161.6,519.1h3.4v1h-4.7v-9.8h1.3V519.1z" />
          <path
            class="st5"
            d="M167.7,519.8c-0.6-0.3-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1s0.2-1.5,0.5-2.1s0.8-1.1,1.4-1.4
		c0.6-0.3,1.2-0.5,2-0.5s1.4,0.2,2,0.5s1.1,0.8,1.4,1.4c0.3,0.6,0.5,1.3,0.5,2.1s-0.2,1.5-0.5,2.1c-0.4,0.6-0.8,1.1-1.4,1.4
		c-0.6,0.3-1.3,0.5-2,0.5S168.3,520.1,167.7,519.8z M171,518.8c0.4-0.2,0.7-0.5,1-1c0.2-0.4,0.4-1,0.4-1.6s-0.1-1.1-0.4-1.6
		c-0.2-0.4-0.6-0.8-1-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-0.9,1c-0.2,0.4-0.4,1-0.4,1.6s0.1,1.2,0.3,1.6
		c0.2,0.4,0.5,0.7,0.9,1c0.4,0.2,0.8,0.3,1.3,0.3C170.1,519.2,170.6,519,171,518.8z"
          />
          <path
            class="st5"
            d="M176.4,520c-0.5-0.2-0.8-0.5-1.1-0.8c-0.3-0.4-0.4-0.8-0.4-1.2h1.3c0,0.4,0.2,0.7,0.5,0.9s0.7,0.4,1.3,0.4
		c0.5,0,0.9-0.1,1.1-0.3c0.3-0.2,0.4-0.5,0.4-0.8s-0.1-0.6-0.4-0.8c-0.3-0.2-0.8-0.3-1.4-0.5c-0.6-0.1-1-0.3-1.4-0.5
		s-0.7-0.4-0.9-0.7c-0.3-0.3-0.4-0.7-0.4-1.2c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.6-0.6,1-0.8s0.9-0.3,1.5-0.3c0.8,0,1.5,0.2,2.1,0.6
		c0.5,0.4,0.8,1,0.8,1.8h-1.3c0-0.4-0.2-0.7-0.5-1s-0.7-0.4-1.2-0.4s-0.8,0.1-1.1,0.3s-0.4,0.5-0.4,0.8s0.1,0.5,0.2,0.6
		c0.2,0.2,0.4,0.3,0.6,0.4c0.2,0.1,0.6,0.2,1,0.3c0.6,0.1,1,0.3,1.3,0.4s0.6,0.4,0.9,0.7c0.2,0.3,0.4,0.7,0.4,1.1
		c0,0.4-0.1,0.8-0.4,1.1c-0.2,0.3-0.6,0.6-1,0.8s-0.9,0.3-1.5,0.3C177.4,520.3,176.9,520.2,176.4,520z"
          />
          <path
            class="st5"
            d="M191.5,520.1l-2.3-4h-1.5v4h-1.3v-9.8h3.1c0.7,0,1.4,0.1,1.9,0.4s0.9,0.6,1.1,1c0.3,0.4,0.4,0.9,0.4,1.5
		c0,0.7-0.2,1.3-0.6,1.8c-0.4,0.5-1,0.9-1.7,1l2.5,4.1L191.5,520.1L191.5,520.1z M187.6,515.1h1.9c0.7,0,1.2-0.2,1.6-0.5
		c0.3-0.3,0.5-0.8,0.5-1.4c0-0.6-0.2-1-0.5-1.3s-0.9-0.5-1.6-0.5h-1.9V515.1z"
          />
          <path
            class="st5"
            d="M196.9,510.3l-3,1.6v-1l3-1.8V510.3z M196.1,512.5v7.7h-1.3v-7.7H196.1z"
          />
          <path
            class="st5"
            d="M199.7,519.8c-0.6-0.3-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1s0.2-1.5,0.5-2.1s0.8-1.1,1.4-1.4
		c0.6-0.3,1.2-0.5,2-0.5s1.4,0.2,2,0.5s1.1,0.8,1.4,1.4c0.3,0.6,0.5,1.3,0.5,2.1s-0.2,1.5-0.5,2.1c-0.4,0.6-0.8,1.1-1.4,1.4
		c-0.6,0.3-1.3,0.5-2,0.5C200.9,520.3,200.3,520.1,199.7,519.8z M202.9,518.8c0.4-0.2,0.7-0.5,1-1c0.2-0.4,0.4-1,0.4-1.6
		s-0.1-1.1-0.4-1.6c-0.2-0.4-0.6-0.8-1-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-0.9,1c-0.2,0.4-0.4,1-0.4,1.6
		s0.1,1.2,0.3,1.6c0.2,0.4,0.5,0.7,0.9,1c0.4,0.2,0.8,0.3,1.3,0.3C202.1,519.2,202.5,519,202.9,518.8z"
          />
          <path
            class="st5"
            d="M208.4,520c-0.5-0.2-0.8-0.5-1.1-0.8c-0.3-0.4-0.4-0.8-0.4-1.2h1.3c0,0.4,0.2,0.7,0.5,0.9s0.7,0.4,1.3,0.4
		c0.5,0,0.9-0.1,1.1-0.3c0.3-0.2,0.4-0.5,0.4-0.8s-0.1-0.6-0.4-0.8c-0.3-0.2-0.8-0.3-1.4-0.5c-0.6-0.1-1-0.3-1.4-0.5
		s-0.7-0.4-0.9-0.7c-0.3-0.3-0.4-0.7-0.4-1.2c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.6-0.6,1-0.8s0.9-0.3,1.5-0.3c0.8,0,1.5,0.2,2.1,0.6
		c0.5,0.4,0.8,1,0.8,1.8h-1.3c0-0.4-0.2-0.7-0.5-1s-0.7-0.4-1.2-0.4s-0.8,0.1-1.1,0.3s-0.4,0.5-0.4,0.8s0.1,0.5,0.2,0.6
		c0.2,0.2,0.4,0.3,0.6,0.4c0.2,0.1,0.6,0.2,1,0.3c0.6,0.1,1,0.3,1.3,0.4s0.6,0.4,0.9,0.7c0.2,0.3,0.4,0.7,0.4,1.1
		c0,0.4-0.1,0.8-0.4,1.1c-0.2,0.3-0.6,0.6-1,0.8s-0.9,0.3-1.5,0.3C209.4,520.3,208.9,520.2,208.4,520z"
          />
        </g>
        <g>
          <line class="st2" x1="114.5" y1="683.4" x2="143.5" y2="683.4" />
          <circle class="st3" cx="143.2" cy="683.4" r="3.2" />
          <circle class="st4" cx="143.2" cy="683.4" r="1.7" />
        </g>
        <g>
          <path
            class="st5"
            d="M160.1,686h-4.3l-0.8,2.2h-1.3l3.5-9.7h1.5l3.5,9.7h-1.3L160.1,686z M159.7,684.9l-1.8-4.9l-1.8,4.9H159.7z"
          />
          <path
            class="st5"
            d="M170.3,680.5l-4.6,11.3h-1.3l1.5-3.7l-3.1-7.6h1.4l2.4,6.2l2.4-6.2H170.3z"
          />
          <path
            class="st5"
            d="M172.7,688c-0.5-0.2-0.8-0.5-1.1-0.8c-0.3-0.4-0.4-0.8-0.4-1.2h1.3c0,0.4,0.2,0.7,0.5,0.9s0.7,0.4,1.3,0.4
		c0.5,0,0.9-0.1,1.1-0.3c0.3-0.2,0.4-0.5,0.4-0.8s-0.1-0.6-0.4-0.8c-0.3-0.2-0.8-0.3-1.4-0.5c-0.6-0.1-1-0.3-1.4-0.5
		s-0.7-0.4-0.9-0.7c-0.3-0.3-0.4-0.7-0.4-1.2c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.6-0.6,1-0.8s0.9-0.3,1.5-0.3c0.8,0,1.5,0.2,2.1,0.6
		c0.5,0.4,0.8,1,0.8,1.8h-1.3c0-0.4-0.2-0.7-0.5-1s-0.7-0.4-1.2-0.4s-0.8,0.1-1.1,0.3s-0.4,0.5-0.4,0.8s0.1,0.5,0.2,0.6
		c0.2,0.2,0.4,0.3,0.6,0.4c0.2,0.1,0.6,0.2,1,0.3c0.6,0.1,1,0.3,1.3,0.4s0.6,0.4,0.9,0.7c0.2,0.3,0.4,0.7,0.4,1.1
		c0,0.4-0.1,0.8-0.4,1.1c-0.2,0.3-0.6,0.6-1,0.8s-0.9,0.3-1.5,0.3C173.7,688.3,173.2,688.2,172.7,688z"
          />
          <path
            class="st5"
            d="M185.9,684.8h-6.1c0,0.8,0.3,1.3,0.8,1.8c0.5,0.4,1,0.6,1.7,0.6c0.6,0,1-0.1,1.4-0.4c0.4-0.3,0.6-0.6,0.8-1
		h1.4c-0.2,0.7-0.6,1.3-1.2,1.8c-0.6,0.5-1.4,0.7-2.3,0.7c-0.7,0-1.4-0.2-2-0.5s-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1
		s0.2-1.5,0.5-2.1s0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,2-0.5c0.7,0,1.4,0.2,1.9,0.5s1,0.8,1.3,1.3c0.3,0.6,0.5,1.2,0.5,1.9
		C185.9,684.3,185.9,684.5,185.9,684.8z M184.3,682.5c-0.2-0.4-0.5-0.6-0.9-0.8s-0.8-0.3-1.2-0.3c-0.6,0-1.2,0.2-1.6,0.6
		s-0.7,1-0.8,1.7h4.8C184.6,683.3,184.5,682.8,184.3,682.5z M183.5,678.3l-3,1.6v-1l3-1.8V678.3z"
          />
          <path
            class="st5"
            d="M193.6,681.2c0.6,0.6,0.9,1.4,0.9,2.4v4.5h-1.3v-4.3c0-0.8-0.2-1.4-0.6-1.8c-0.4-0.4-0.9-0.6-1.6-0.6
		c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.8v4.2h-1.3v-7.7h1.3v1.1c0.3-0.4,0.6-0.7,1-0.9s0.9-0.3,1.4-0.3
		C192.3,680.3,193,680.6,193.6,681.2z"
          />
        </g>
        <g>
          <path
            class="st5"
            d="M90.6,60.5v0.9h-2.4v7.8h-1.1v-7.8h-2.4v-0.9C84.7,60.5,90.6,60.5,90.6,60.5z"
          />
          <path
            class="st5"
            d="M92,63.9c0.3-0.5,0.7-0.9,1.2-1.2s1-0.4,1.7-0.4c0.6,0,1.1,0.1,1.6,0.4c0.4,0.3,0.8,0.6,1,1v-1.2h1.1v6.8h-1.1
		V68c-0.2,0.4-0.6,0.7-1,1s-1,0.4-1.6,0.4s-1.2-0.2-1.6-0.5s-0.9-0.7-1.2-1.3c-0.3-0.5-0.4-1.2-0.4-1.8C91.6,65,91.7,64.4,92,63.9z
		 M97.1,64.4c-0.2-0.4-0.5-0.7-0.8-0.9s-0.7-0.3-1.2-0.3c-0.4,0-0.8,0.1-1.2,0.3c-0.3,0.2-0.6,0.5-0.8,0.9s-0.3,0.8-0.3,1.3
		s0.1,1,0.3,1.4c0.2,0.4,0.5,0.7,0.8,0.9c0.3,0.2,0.7,0.3,1.2,0.3c0.4,0,0.8-0.1,1.2-0.3c0.4-0.2,0.6-0.5,0.8-0.9
		c0.2-0.4,0.3-0.8,0.3-1.4C97.4,65.2,97.3,64.8,97.1,64.4z"
          />
          <path
            class="st5"
            d="M102.4,62.5c0.4-0.2,0.8-0.3,1.4-0.3v1.2h-0.3c-1.3,0-1.9,0.7-1.9,2.1v3.7h-1.1v-6.8h1.1v1.1
		C101.8,63.1,102.1,62.8,102.4,62.5z"
          />
          <path
            class="st5"
            d="M105.1,63.9c0.3-0.5,0.7-0.9,1.2-1.2s1-0.4,1.7-0.4c0.6,0,1.1,0.1,1.6,0.4c0.4,0.3,0.8,0.6,1,1v-1.2h1.1v6.8
		h-1.1V68c-0.2,0.4-0.6,0.7-1,1s-1,0.4-1.6,0.4s-1.2-0.2-1.6-0.5s-0.9-0.7-1.2-1.3c-0.3-0.5-0.4-1.2-0.4-1.8
		C104.7,65,104.8,64.4,105.1,63.9z M110.2,64.4c-0.2-0.4-0.5-0.7-0.8-0.9s-0.7-0.3-1.2-0.3c-0.4,0-0.8,0.1-1.2,0.3
		c-0.3,0.2-0.6,0.5-0.8,0.9s-0.3,0.8-0.3,1.3s0.1,1,0.3,1.4c0.2,0.4,0.5,0.7,0.8,0.9c0.3,0.2,0.7,0.3,1.2,0.3c0.4,0,0.8-0.1,1.2-0.3
		c0.4-0.2,0.6-0.5,0.8-0.9c0.2-0.4,0.3-0.8,0.3-1.4C110.5,65.2,110.4,64.8,110.2,64.4z"
          />
          <path
            class="st5"
            d="M115.7,62.6c0.4-0.3,1-0.4,1.6-0.4s1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.7,1.2,1.2c0.3,0.5,0.4,1.1,0.4,1.8
		s-0.1,1.3-0.4,1.8s-0.7,1-1.2,1.3s-1,0.5-1.7,0.5c-0.6,0-1.1-0.1-1.5-0.4s-0.8-0.6-1-1v4.5h-1.1v-10h1.1v1.3
		C114.9,63.2,115.2,62.9,115.7,62.6z M119,64.4c-0.2-0.4-0.5-0.7-0.8-0.9c-0.4-0.2-0.7-0.3-1.2-0.3c-0.4,0-0.8,0.1-1.2,0.3
		c-0.4,0.2-0.6,0.5-0.8,0.9c-0.2,0.4-0.3,0.8-0.3,1.3s0.1,1,0.3,1.4c0.2,0.4,0.5,0.7,0.8,0.9c0.4,0.2,0.7,0.3,1.2,0.3
		c0.4,0,0.8-0.1,1.2-0.3c0.4-0.2,0.6-0.5,0.8-0.9c0.2-0.4,0.3-0.8,0.3-1.4C119.3,65.2,119.2,64.8,119,64.4z"
          />
          <path
            class="st5"
            d="M122,63.9c0.3-0.5,0.7-0.9,1.2-1.2s1-0.4,1.7-0.4c0.6,0,1.1,0.1,1.6,0.4c0.4,0.3,0.8,0.6,1,1v-1.2h1.1v6.8
		h-1.1V68c-0.2,0.4-0.6,0.7-1,1s-1,0.4-1.6,0.4s-1.2-0.2-1.6-0.5s-0.9-0.7-1.2-1.3c-0.3-0.5-0.4-1.2-0.4-1.8
		C121.6,65,121.7,64.4,122,63.9z M127.1,64.4c-0.2-0.4-0.5-0.7-0.8-0.9s-0.7-0.3-1.2-0.3c-0.4,0-0.8,0.1-1.2,0.3
		c-0.3,0.2-0.6,0.5-0.8,0.9s-0.3,0.8-0.3,1.3s0.1,1,0.3,1.4c0.2,0.4,0.5,0.7,0.8,0.9c0.3,0.2,0.7,0.3,1.2,0.3c0.4,0,0.8-0.1,1.2-0.3
		c0.4-0.2,0.6-0.5,0.8-0.9c0.2-0.4,0.3-0.8,0.3-1.4C127.4,65.2,127.3,64.8,127.1,64.4z"
          />
          <path
            class="st5"
            d="M130.4,63.9c0.3-0.5,0.7-0.9,1.2-1.2s1.1-0.4,1.7-0.4c0.8,0,1.5,0.2,2.1,0.6s0.9,1,1.1,1.7h-1.2
		c-0.1-0.4-0.3-0.7-0.7-1s-0.8-0.4-1.3-0.4c-0.6,0-1.2,0.2-1.6,0.7c-0.4,0.4-0.6,1.1-0.6,1.9c0,0.8,0.2,1.5,0.6,1.9
		c0.4,0.5,0.9,0.7,1.6,0.7c0.5,0,0.9-0.1,1.2-0.3s0.6-0.6,0.7-1h1.2c-0.2,0.7-0.5,1.3-1.1,1.7c-0.5,0.4-1.2,0.6-2.1,0.6
		c-0.6,0-1.2-0.1-1.7-0.4s-0.9-0.7-1.2-1.2s-0.4-1.2-0.4-1.9C130,65,130.2,64.4,130.4,63.9z"
          />
          <path
            class="st5"
            d="M138,63.9c0.3-0.5,0.7-0.9,1.2-1.2s1-0.4,1.7-0.4c0.6,0,1.1,0.1,1.6,0.4c0.4,0.3,0.8,0.6,1,1v-1.2h1.1v6.8
		h-1.1V68c-0.2,0.4-0.6,0.7-1,1s-1,0.4-1.6,0.4s-1.2-0.2-1.6-0.5s-0.9-0.7-1.2-1.3c-0.3-0.5-0.4-1.2-0.4-1.8
		C137.6,65,137.7,64.4,138,63.9z M143.1,64.4c-0.2-0.4-0.5-0.7-0.8-0.9s-0.7-0.3-1.2-0.3c-0.4,0-0.8,0.1-1.2,0.3
		c-0.3,0.2-0.6,0.5-0.8,0.9s-0.3,0.8-0.3,1.3s0.1,1,0.3,1.4s0.5,0.7,0.8,0.9c0.3,0.2,0.7,0.3,1.2,0.3c0.4,0,0.8-0.1,1.2-0.3
		c0.4-0.2,0.6-0.5,0.8-0.9s0.3-0.8,0.3-1.4C143.4,65.2,143.3,64.8,143.1,64.4z M142.5,60.4l-2.7,1.4V61l2.7-1.6V60.4z"
          />
        </g>
        <g>
          <line class="st2" x1="163.5" y1="229.9" x2="134.5" y2="229.9" />
          <circle class="st3" cx="134.8" cy="229.9" r="3.2" />
          <circle class="st4" cx="134.8" cy="229.9" r="1.7" />
        </g>
        <g>
          <path
            class="st5"
            d="M66.5,232.5h-4.3l-0.8,2.2h-1.3l3.5-9.7h1.5l3.5,9.7h-1.3L66.5,232.5z M66.1,231.5l-1.8-4.9l-1.8,4.9H66.1z"
          />
          <path
            class="st5"
            d="M71.7,228.1v4.5c0,0.4,0.1,0.6,0.2,0.8c0.2,0.2,0.4,0.2,0.8,0.2h0.9v1.1h-1.1c-0.7,0-1.2-0.2-1.6-0.5
		s-0.5-0.9-0.5-1.6v-4.5h-1v-1h1v-1.9h1.3v1.9h2v1H71.7z"
          />
          <path
            class="st5"
            d="M75.3,228.8c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.9,0.7,1.1,1.1
		V227h1.3v7.7h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4
		c-0.3-0.6-0.5-1.3-0.5-2.1C74.8,230,75,229.3,75.3,228.8z M80.9,229.3c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3
		s-0.7,0.6-0.9,1s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5s0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3s0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5C81.3,230.3,81.2,229.8,80.9,229.3z"
          />
          <path
            class="st5"
            d="M84.7,228.8c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.9,0,1.7,0.2,2.3,0.7s1,1.1,1.2,1.9H90
		c-0.1-0.5-0.4-0.8-0.8-1.1s-0.8-0.4-1.4-0.4c-0.7,0-1.3,0.2-1.8,0.7c-0.4,0.5-0.7,1.2-0.7,2.1c0,0.9,0.2,1.6,0.7,2.1
		c0.4,0.5,1,0.8,1.8,0.8c0.6,0,1-0.1,1.4-0.4c0.4-0.3,0.6-0.6,0.8-1.1h1.4c-0.2,0.8-0.6,1.4-1.2,1.9s-1.4,0.7-2.3,0.7
		c-0.7,0-1.4-0.2-1.9-0.5c-0.6-0.3-1-0.8-1.3-1.4c-0.3-0.6-0.5-1.3-0.5-2.1C84.3,230,84.4,229.3,84.7,228.8z"
          />
          <path
            class="st5"
            d="M93.2,228.8c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.9,0.7,1.1,1.1
		V227h1.3v7.7h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4
		c-0.3-0.6-0.5-1.3-0.5-2.1C92.8,230,92.9,229.3,93.2,228.8z M98.9,229.3c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3
		s-0.7,0.6-0.9,1s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5s0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3s0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5C99.3,230.3,99.1,229.8,98.9,229.3z"
          />
          <path
            class="st5"
            d="M113.5,227.2c0.5,0.2,0.8,0.6,1.1,1.1s0.4,1.1,0.4,1.8v4.5h-1.3v-4.3c0-0.8-0.2-1.4-0.6-1.8s-0.9-0.6-1.5-0.6
		c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.8v4.2h-1.3v-4.3c0-0.8-0.2-1.4-0.6-1.8c-0.4-0.4-0.9-0.6-1.5-0.6
		c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.8v4.2h-1.3V227h1.3v1.1c0.3-0.4,0.6-0.7,1-0.9s0.9-0.3,1.4-0.3
		c0.6,0,1.2,0.1,1.7,0.4s0.9,0.7,1.1,1.3c0.2-0.5,0.6-1,1.1-1.3s1-0.4,1.7-0.4C112.5,226.9,113,227,113.5,227.2z"
          />
          <path
            class="st5"
            d="M117.1,228.8c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.9,0.7,1.1,1.1
		V227h1.3v7.7h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4
		c-0.3-0.6-0.5-1.3-0.5-2.1C116.6,230,116.8,229.3,117.1,228.8z M122.8,229.3c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3
		s-0.9,0.1-1.3,0.3s-0.7,0.6-0.9,1s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5s0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3s0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5C123.1,230.3,123,229.8,122.8,229.3z"
          />
        </g>
        <g>
          <line class="st2" x1="153.5" y1="344.2" x2="124.5" y2="344.2" />
          <circle class="st3" cx="124.8" cy="344.2" r="3.2" />
          <circle class="st4" cx="124.8" cy="344.2" r="1.7" />
        </g>
        <g>
          <path class="st5" d="M48.9,339.2l-3.7,9.8h-1.5l-3.7-9.8h1.4l3.1,8.4l3.1-8.4H48.9z" />
          <path
            class="st5"
            d="M50.3,343c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5s1.3,0.1,1.8,0.4s0.9,0.7,1.1,1.1v-1.4h1.3v7.7
		h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4S50,345.8,50,345
		C49.9,344.3,50,343.6,50.3,343z M56,343.6c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1s0.4-0.9,0.4-1.5
		S56.2,344,56,343.6z"
          />
          <path class="st5" d="M61.1,338.6V349h-1.3v-10.4H61.1z" />
          <path
            class="st5"
            d="M65.7,341.6c0.5-0.3,1.1-0.4,1.7-0.4c0.7,0,1.3,0.2,1.9,0.5s1,0.8,1.3,1.4s0.5,1.3,0.5,2.1
		c0,0.8-0.2,1.5-0.5,2.1s-0.8,1.1-1.3,1.4c-0.6,0.3-1.2,0.5-1.9,0.5c-0.7,0-1.2-0.1-1.7-0.4s-0.9-0.7-1.1-1.1v5.1h-1.3v-11.3h1.3
		v1.4C64.8,342.3,65.2,341.9,65.7,341.6z M69.4,343.6c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3
		c-0.4,0.2-0.7,0.6-1,1c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.6,0.8,1,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3
		c0.4-0.2,0.7-0.6,0.9-1c0.2-0.4,0.4-0.9,0.4-1.5C69.7,344.5,69.6,344,69.4,343.6z"
          />
          <path
            class="st5"
            d="M72.7,343c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4s0.9,0.7,1.1,1.1v-1.4H80
		v7.7h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1
		C72.2,344.3,72.4,343.6,72.7,343z M78.4,343.6c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5S78.6,344,78.4,343.6z"
          />
          <path
            class="st5"
            d="M84.4,341.5c0.4-0.2,0.9-0.4,1.5-0.4v1.3h-0.3c-1.4,0-2.1,0.8-2.1,2.3v4.2h-1.3v-7.7h1.3v1.2
		C83.7,342.1,84,341.8,84.4,341.5z"
          />
          <path
            class="st5"
            d="M87.4,343c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4s0.9,0.7,1.1,1.1v-1.4h1.3
		v7.7h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1
		C86.9,344.3,87.1,343.6,87.4,343z M93.1,343.6c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5S93.3,344,93.1,343.6z"
          />
          <path
            class="st5"
            d="M98.9,339.1l-3,1.6v-1l3-1.8V339.1z M98.1,341.3v7.7h-1.3v-7.7H98.1z"
          />
          <path
            class="st5"
            d="M101.4,348.8c-0.5-0.2-0.8-0.5-1.1-0.8c-0.3-0.4-0.4-0.8-0.4-1.2h1.3c0,0.4,0.2,0.7,0.5,0.9
		c0.3,0.2,0.7,0.4,1.3,0.4c0.5,0,0.9-0.1,1.1-0.3c0.3-0.2,0.4-0.5,0.4-0.8s-0.1-0.6-0.4-0.7c-0.3-0.2-0.8-0.3-1.4-0.5
		c-0.6-0.1-1-0.3-1.4-0.5s-0.7-0.4-0.9-0.7c-0.3-0.3-0.4-0.7-0.4-1.2c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.6-0.6,1-0.8s0.9-0.3,1.5-0.3
		c0.8,0,1.5,0.2,2.1,0.6c0.5,0.4,0.8,1,0.8,1.8h-1.3c0-0.4-0.2-0.7-0.5-1c-0.3-0.2-0.7-0.4-1.2-0.4s-0.8,0.1-1.1,0.3
		c-0.3,0.2-0.4,0.5-0.4,0.8s0.1,0.5,0.2,0.6c0.2,0.2,0.4,0.3,0.6,0.4s0.6,0.2,1,0.3c0.6,0.1,1,0.3,1.3,0.4s0.6,0.4,0.9,0.7
		c0.2,0.3,0.4,0.7,0.4,1.1s-0.1,0.8-0.4,1.1c-0.2,0.3-0.6,0.6-1,0.8c-0.4,0.2-0.9,0.3-1.5,0.3C102.4,349.1,101.9,349,101.4,348.8z"
          />
          <path
            class="st5"
            d="M109,348.6c-0.6-0.3-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1c0-0.8,0.2-1.5,0.5-2.1s0.8-1.1,1.4-1.4
		s1.2-0.5,2-0.5s1.4,0.2,2,0.5s1.1,0.8,1.4,1.4s0.5,1.3,0.5,2.1s-0.2,1.5-0.5,2.1c-0.4,0.6-0.8,1.1-1.4,1.4s-1.3,0.5-2,0.5
		C110.2,349.1,109.6,348.9,109,348.6z M112.3,347.6c0.4-0.2,0.7-0.5,1-1c0.2-0.4,0.4-1,0.4-1.6s-0.1-1.1-0.4-1.6
		c-0.2-0.4-0.6-0.7-1-1c-0.4-0.2-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-0.9,1c-0.2,0.4-0.4,1-0.4,1.6s0.1,1.2,0.3,1.6
		c0.2,0.4,0.5,0.7,0.9,1c0.4,0.2,0.8,0.3,1.3,0.3C111.4,348,111.9,347.9,112.3,347.6z"
          />
        </g>
        <g>
          <line class="st2" x1="148.5" y1="385.7" x2="119.5" y2="385.7" />
          <circle class="st3" cx="119.8" cy="385.7" r="3.2" />
          <circle class="st4" cx="119.8" cy="385.7" r="1.7" />
        </g>
        <g>
          <path
            class="st5"
            d="M48.5,389.9c-0.7-0.4-1.3-1-1.8-1.8s-0.7-1.6-0.7-2.6s0.2-1.8,0.7-2.6s1-1.4,1.8-1.8s1.6-0.6,2.5-0.6
		s1.7,0.2,2.5,0.6c0.7,0.4,1.3,1,1.8,1.8s0.6,1.6,0.6,2.6s-0.2,1.8-0.6,2.6s-1,1.3-1.8,1.8c-0.7,0.4-1.6,0.6-2.5,0.6
		C50.1,390.6,49.3,390.4,48.5,389.9z M52.8,389c0.5-0.3,1-0.8,1.3-1.4s0.5-1.3,0.5-2c0-0.8-0.2-1.5-0.5-2.1s-0.7-1-1.3-1.4
		c-0.5-0.3-1.2-0.5-1.8-0.5c-0.7,0-1.3,0.2-1.8,0.5s-1,0.8-1.3,1.4s-0.5,1.3-0.5,2.1c0,0.8,0.2,1.5,0.5,2c0.3,0.6,0.7,1,1.3,1.4
		s1.2,0.5,1.8,0.5S52.3,389.3,52.8,389z"
          />
          <path class="st5" d="M58.2,379.3l-0.2,2.8h-0.9l-0.2-2.8H58.2z" />
          <path class="st5" d="M67.3,380.7v9.8H66v-4.4h-5v4.4h-1.3v-9.8H61v4.3h5v-4.3H67.3z" />
          <path
            class="st5"
            d="M69.5,381.3c-0.2-0.2-0.3-0.4-0.3-0.6s0.1-0.4,0.3-0.6s0.4-0.3,0.6-0.3s0.4,0.1,0.6,0.3
		c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.3-0.6,0.3C69.9,381.6,69.7,381.5,69.5,381.3z M70.8,382.8v7.7h-1.3v-7.7
		H70.8z"
          />
          <path
            class="st5"
            d="M77.8,383.1c0.5,0.3,0.9,0.7,1.1,1.1v-1.4h1.3v7.8c0,0.7-0.1,1.3-0.4,1.9s-0.7,1-1.3,1.3
		c-0.6,0.3-1.2,0.5-1.9,0.5c-1,0-1.8-0.2-2.5-0.7s-1.1-1.1-1.2-1.9h1.3c0.1,0.5,0.4,0.8,0.9,1.1c0.4,0.3,1,0.4,1.6,0.4
		c0.7,0,1.3-0.2,1.7-0.7c0.4-0.4,0.7-1.1,0.7-1.8V389c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.9-0.5
		s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1c0-0.8,0.2-1.5,0.5-2.1s0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5
		C76.8,382.7,77.3,382.8,77.8,383.1z M78.6,385.1c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5S78.8,385.5,78.6,385.1z"
          />
          <path
            class="st5"
            d="M87.3,383.1c0.5,0.3,0.9,0.7,1.1,1.1v-1.4h1.3v7.8c0,0.7-0.1,1.3-0.4,1.9s-0.7,1-1.3,1.3
		c-0.6,0.3-1.2,0.5-1.9,0.5c-1,0-1.8-0.2-2.5-0.7s-1.1-1.1-1.2-1.9h1.3c0.1,0.5,0.4,0.8,0.9,1.1c0.4,0.3,1,0.4,1.6,0.4
		c0.7,0,1.3-0.2,1.7-0.7c0.4-0.4,0.7-1.1,0.7-1.8V389c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.9-0.5
		s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1c0-0.8,0.2-1.5,0.5-2.1s0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5
		C86.2,382.7,86.8,382.8,87.3,383.1z M88.1,385.1c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5S88.3,385.5,88.1,385.1z"
          />
          <path
            class="st5"
            d="M91.9,381.3c-0.2-0.2-0.3-0.4-0.3-0.6s0.1-0.4,0.3-0.6s0.4-0.3,0.6-0.3s0.4,0.1,0.6,0.3
		c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.3-0.6,0.3C92.3,381.6,92.1,381.5,91.9,381.3z M93.1,382.8v7.7h-1.3v-7.7
		H93.1z"
          />
          <path
            class="st5"
            d="M101.3,383.5c0.6,0.6,0.9,1.4,0.9,2.4v4.5h-1.3v-4.3c0-0.8-0.2-1.4-0.6-1.8s-0.9-0.6-1.6-0.6s-1.2,0.2-1.6,0.6
		s-0.6,1-0.6,1.8v4.2h-1.3v-7.7h1.3v1.1c0.3-0.4,0.6-0.7,1-0.9c0.4-0.2,0.9-0.3,1.4-0.3C100,382.7,100.7,382.9,101.3,383.5z"
          />
          <path
            class="st5"
            d="M105.4,390.3c-0.5-0.2-0.8-0.5-1.1-0.8c-0.3-0.4-0.4-0.8-0.4-1.2h1.3c0,0.4,0.2,0.7,0.5,0.9
		c0.3,0.2,0.7,0.4,1.3,0.4c0.5,0,0.9-0.1,1.1-0.3c0.3-0.2,0.4-0.5,0.4-0.8s-0.1-0.6-0.4-0.7c-0.3-0.2-0.8-0.3-1.4-0.5
		c-0.6-0.1-1-0.3-1.4-0.5s-0.7-0.4-0.9-0.7c-0.3-0.3-0.4-0.7-0.4-1.2c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.6-0.6,1-0.8s0.9-0.3,1.5-0.3
		c0.8,0,1.5,0.2,2.1,0.6c0.5,0.4,0.8,1,0.8,1.8h-1.3c0-0.4-0.2-0.7-0.5-1c-0.3-0.2-0.7-0.4-1.2-0.4s-0.8,0.1-1.1,0.3
		c-0.3,0.2-0.4,0.5-0.4,0.8s0.1,0.5,0.2,0.6c0.2,0.2,0.4,0.3,0.6,0.4s0.6,0.2,1,0.3c0.6,0.1,1,0.3,1.3,0.4s0.6,0.4,0.9,0.7
		c0.2,0.3,0.4,0.7,0.4,1.1s-0.1,0.8-0.4,1.1c-0.2,0.3-0.6,0.6-1,0.8c-0.4,0.2-0.9,0.3-1.5,0.3C106.4,390.6,105.9,390.5,105.4,390.3z
		"
          />
        </g>
        <g>
          <line class="st2" x1="129.5" y1="433.6" x2="100.5" y2="433.6" />
          <circle class="st3" cx="100.8" cy="433.6" r="3.2" />
          <circle class="st4" cx="100.8" cy="433.6" r="1.7" />
        </g>
        <g>
          <path
            class="st5"
            d="M59.9,438.4h-1.3l-5.1-7.8v7.8h-1.3v-9.8h1.3l5.1,7.8v-7.8h1.3V438.4z M54.4,426.7c0.2-0.3,0.6-0.4,0.9-0.4
		c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.3,0.1,0.5,0.3c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.3-0.1,0.4-0.2
		s0.2-0.3,0.2-0.4h0.7c-0.1,0.5-0.2,0.8-0.5,1.1s-0.6,0.4-0.9,0.4c-0.2,0-0.3,0-0.5-0.1s-0.3-0.2-0.5-0.3c-0.1-0.1-0.3-0.2-0.4-0.2
		c-0.1,0-0.2-0.1-0.3-0.1c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.3-0.2,0.5H54C54,427.3,54.2,427,54.4,426.7z"
          />
          <path
            class="st5"
            d="M68.8,430.7v7.7h-1.3v-1.1c-0.2,0.4-0.6,0.7-1,0.9c-0.4,0.2-0.9,0.3-1.4,0.3c-0.6,0-1.1-0.1-1.6-0.4
		s-0.9-0.6-1.1-1.1c-0.3-0.5-0.4-1.1-0.4-1.8v-4.5h1.3v4.3c0,0.8,0.2,1.3,0.6,1.7s0.9,0.6,1.6,0.6c0.7,0,1.2-0.2,1.6-0.6
		s0.6-1,0.6-1.8v-4.2H68.8z"
          />
          <path
            class="st5"
            d="M73.4,431c0.5-0.3,1.1-0.4,1.7-0.4c0.7,0,1.3,0.2,1.9,0.5s1,0.8,1.3,1.4s0.5,1.3,0.5,2.1
		c0,0.8-0.2,1.5-0.5,2.1s-0.8,1.1-1.3,1.4c-0.6,0.3-1.2,0.5-1.9,0.5c-0.7,0-1.2-0.1-1.7-0.4s-0.9-0.7-1.1-1.1v1.4H71V428h1.3v4.1
		C72.5,431.6,72.9,431.3,73.4,431z M77.1,433c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-1,1
		c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.6,0.8,1,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5S77.4,433.4,77.1,433z"
          />
          <path class="st5" d="M81.7,428v10.4h-1.3V428H81.7z" />
          <path
            class="st5"
            d="M90.9,435h-6.1c0,0.8,0.3,1.3,0.8,1.8c0.5,0.4,1,0.6,1.7,0.6c0.6,0,1-0.1,1.4-0.4s0.6-0.6,0.8-1h1.4
		c-0.2,0.7-0.6,1.3-1.2,1.8s-1.4,0.7-2.3,0.7c-0.7,0-1.4-0.2-2-0.5s-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1s0.2-1.5,0.5-2.1
		s0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,2-0.5c0.7,0,1.4,0.2,1.9,0.5s1,0.8,1.3,1.3s0.5,1.2,0.5,1.9C90.9,434.5,90.9,434.7,90.9,435z
		 M89.3,432.7c-0.2-0.4-0.5-0.6-0.9-0.8c-0.4-0.2-0.8-0.3-1.2-0.3c-0.6,0-1.2,0.2-1.6,0.6c-0.5,0.4-0.7,1-0.8,1.7h4.8
		C89.6,433.5,89.5,433.1,89.3,432.7z"
          />
        </g>
        <g>
          <line class="st2" x1="123.5" y1="483.6" x2="94.5" y2="483.6" />
          <circle class="st3" cx="94.8" cy="483.6" r="3.2" />
          <circle class="st4" cx="94.8" cy="483.6" r="1.7" />
        </g>
        <g>
          <path
            class="st5"
            d="M19.4,486.2h-4.3l-0.8,2.2H13l3.5-9.7H18l3.5,9.7h-1.3L19.4,486.2z M19.1,485.2l-1.8-4.9l-1.8,4.9H19.1z"
          />
          <path
            class="st5"
            d="M25.3,481c0.4-0.2,0.9-0.4,1.5-0.4v1.3h-0.3c-1.4,0-2.1,0.8-2.1,2.3v4.2h-1.3v-7.7h1.3v1.2
		C24.6,481.5,24.9,481.2,25.3,481z"
          />
          <path
            class="st5"
            d="M28.3,482.5c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5s1.3,0.1,1.8,0.4s0.9,0.7,1.1,1.1v-1.4h1.3v7.7
		h-1.3V487c-0.3,0.4-0.6,0.8-1.1,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1
		C27.8,483.8,28,483.1,28.3,482.5z M34,483c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3s-0.7,0.6-0.9,1
		c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1
		s0.4-0.9,0.4-1.5S34.2,483.5,34,483z"
          />
          <path
            class="st5"
            d="M44.6,480.7v7.7h-1.3v-1.1c-0.2,0.4-0.6,0.7-1,0.9c-0.4,0.2-0.9,0.3-1.4,0.3c-0.6,0-1.1-0.1-1.6-0.4
		c-0.5-0.2-0.9-0.6-1.1-1.1c-0.3-0.5-0.4-1.1-0.4-1.8v-4.5H39v4.3c0,0.8,0.2,1.3,0.6,1.7s0.9,0.6,1.6,0.6c0.7,0,1.2-0.2,1.6-0.6
		s0.6-1,0.6-1.8v-4.2H44.6z"
          />
          <path
            class="st5"
            d="M46.7,482.5c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.9,0,1.7,0.2,2.3,0.7s1,1.1,1.2,1.9H52
		c-0.1-0.5-0.4-0.8-0.8-1.1c-0.4-0.3-0.8-0.4-1.4-0.4c-0.7,0-1.3,0.2-1.8,0.7c-0.4,0.5-0.7,1.2-0.7,2.1s0.2,1.6,0.7,2.1
		c0.4,0.5,1,0.8,1.8,0.8c0.6,0,1-0.1,1.4-0.4s0.6-0.6,0.8-1.1h1.4c-0.2,0.8-0.6,1.4-1.2,1.9c-0.6,0.5-1.4,0.7-2.3,0.7
		c-0.7,0-1.4-0.2-1.9-0.5c-0.6-0.3-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1C46.3,483.8,46.4,483.1,46.7,482.5z"
          />
          <path
            class="st5"
            d="M55.2,482.5c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5s1.3,0.1,1.8,0.4s0.9,0.7,1.1,1.1v-1.4h1.3v7.7
		h-1.3V487c-0.3,0.4-0.6,0.8-1.1,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1
		C54.8,483.8,54.9,483.1,55.2,482.5z M60.9,483c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3s-0.7,0.6-0.9,1
		s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1s0.4-0.9,0.4-1.5
		S61.1,483.5,60.9,483z"
          />
          <path
            class="st5"
            d="M70.7,481.4c0.6,0.6,0.9,1.4,0.9,2.4v4.5h-1.3V484c0-0.8-0.2-1.4-0.6-1.8s-0.9-0.6-1.6-0.6s-1.2,0.2-1.6,0.6
		s-0.6,1-0.6,1.8v4.2h-1.3v-7.7H66v1.1c0.3-0.4,0.6-0.7,1-0.9s0.9-0.3,1.4-0.3C69.4,480.6,70.1,480.9,70.7,481.4z"
          />
          <path
            class="st5"
            d="M75.7,478.6l-3,1.6v-1l3-1.8V478.6z M74.9,480.7v7.7h-1.3v-7.7H74.9z"
          />
          <path
            class="st5"
            d="M77.1,482.5c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4s0.9,0.7,1.1,1.1v-1.4h1.3
		v7.7h-1.3V487c-0.3,0.4-0.6,0.8-1.1,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4s-0.5-1.3-0.5-2.1
		C76.6,483.8,76.8,483.1,77.1,482.5z M82.8,483c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3s-0.7,0.6-0.9,1
		c-0.2,0.4-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5c0.2,0.4,0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1
		c0.2-0.4,0.4-0.9,0.4-1.5S83,483.5,82.8,483z"
          />
        </g>
        <g>
          <line class="st2" x1="125.5" y1="570.2" x2="96.5" y2="570.2" />
          <circle class="st3" cx="96.8" cy="570.2" r="3.2" />
          <circle class="st4" cx="96.8" cy="570.2" r="1.7" />
        </g>
        <g>
          <path class="st5" d="M22.6,574H26v1h-4.7v-9.8h1.3C22.6,565.2,22.6,574,22.6,574z" />
          <path
            class="st5"
            d="M28.7,574.6c-0.6-0.3-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1s0.2-1.5,0.5-2.1s0.8-1.1,1.4-1.4
		c0.6-0.3,1.2-0.5,2-0.5s1.4,0.2,2,0.5s1.1,0.8,1.4,1.4c0.3,0.6,0.5,1.3,0.5,2.1s-0.2,1.5-0.5,2.1s-0.8,1.1-1.4,1.4
		c-0.6,0.3-1.3,0.5-2,0.5S29.3,575,28.7,574.6z M32,573.7c0.4-0.2,0.7-0.5,1-1c0.2-0.4,0.4-1,0.4-1.6s-0.1-1.1-0.4-1.6s-0.6-0.7-1-1
		c-0.4-0.2-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3s-0.7,0.5-0.9,1s-0.4,1-0.4,1.6s0.1,1.2,0.3,1.6c0.2,0.4,0.5,0.7,0.9,1
		c0.4,0.2,0.8,0.3,1.3,0.3S31.6,573.9,32,573.7z"
          />
          <path
            class="st5"
            d="M37.4,574.8c-0.5-0.2-0.8-0.5-1.1-0.8c-0.3-0.4-0.4-0.8-0.4-1.2h1.3c0,0.4,0.2,0.7,0.5,0.9s0.7,0.4,1.3,0.4
		c0.5,0,0.9-0.1,1.1-0.3c0.3-0.2,0.4-0.5,0.4-0.8s-0.1-0.6-0.4-0.7s-0.8-0.3-1.4-0.5c-0.6-0.1-1-0.3-1.4-0.5s-0.7-0.4-0.9-0.7
		c-0.3-0.3-0.4-0.7-0.4-1.2c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.6-0.6,1-0.8s0.9-0.3,1.5-0.3c0.8,0,1.5,0.2,2.1,0.6
		c0.5,0.4,0.8,1,0.8,1.8h-1.3c0-0.4-0.2-0.7-0.5-1c-0.3-0.2-0.7-0.4-1.2-0.4s-0.8,0.1-1.1,0.3s-0.4,0.5-0.4,0.8s0.1,0.5,0.2,0.6
		c0.2,0.2,0.4,0.3,0.6,0.4c0.2,0.1,0.6,0.2,1,0.3c0.6,0.2,1,0.3,1.3,0.4s0.6,0.4,0.9,0.7c0.2,0.3,0.4,0.7,0.4,1.1
		c0,0.4-0.1,0.8-0.4,1.1c-0.2,0.3-0.6,0.6-1,0.8s-0.9,0.3-1.5,0.3C38.4,575.1,37.9,575,37.4,574.8z"
          />
          <path class="st5" d="M48.6,574H52v1h-4.7v-9.8h1.3V574z" />
          <path
            class="st5"
            d="M53.4,569.1c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5s1.3,0.1,1.8,0.4c0.5,0.3,0.9,0.7,1.1,1.1v-1.4
		h1.3v7.7h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4c-0.3-0.6-0.5-1.3-0.5-2.1
		C52.9,570.4,53.1,569.7,53.4,569.1z M59.1,569.7c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5s0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1s0.4-0.9,0.4-1.5
		C59.4,570.6,59.3,570.1,59.1,569.7z"
          />
          <path
            class="st5"
            d="M67.8,567.6c0.5,0.3,0.9,0.7,1.1,1.1v-1.4h1.3v7.8c0,0.7-0.1,1.3-0.4,1.9s-0.7,1-1.3,1.3
		c-0.6,0.3-1.2,0.5-1.9,0.5c-1,0-1.8-0.2-2.5-0.7c-0.7-0.5-1.1-1.1-1.2-1.9H64c0.1,0.5,0.4,0.8,0.9,1.1c0.4,0.3,1,0.4,1.6,0.4
		c0.7,0,1.3-0.2,1.7-0.7c0.4-0.4,0.7-1.1,0.7-1.8v-1.6c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.9-0.5
		s-1-0.8-1.3-1.4c-0.3-0.6-0.5-1.3-0.5-2.1s0.2-1.5,0.5-2.1s0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5
		C66.7,567.2,67.3,567.4,67.8,567.6z M68.5,569.7c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3s-0.7,0.6-0.9,1
		s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5s0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3s0.7-0.6,0.9-1c0.2-0.4,0.4-0.9,0.4-1.5
		C68.9,570.6,68.7,570.1,68.5,569.7z"
          />
          <path
            class="st5"
            d="M73.7,574.6c-0.6-0.3-1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2.1s0.2-1.5,0.5-2.1s0.8-1.1,1.4-1.4
		c0.6-0.3,1.2-0.5,2-0.5s1.4,0.2,2,0.5s1.1,0.8,1.4,1.4c0.3,0.6,0.5,1.3,0.5,2.1s-0.2,1.5-0.5,2.1s-0.8,1.1-1.4,1.4
		c-0.6,0.3-1.3,0.5-2,0.5C74.9,575.1,74.3,575,73.7,574.6z M76.9,573.7c0.4-0.2,0.7-0.5,1-1c0.2-0.4,0.4-1,0.4-1.6s-0.1-1.1-0.4-1.6
		s-0.6-0.7-1-1c-0.4-0.2-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3s-0.7,0.5-0.9,1s-0.4,1-0.4,1.6s0.1,1.2,0.3,1.6c0.2,0.4,0.5,0.7,0.9,1
		c0.4,0.2,0.8,0.3,1.3,0.3C76.1,574,76.5,573.9,76.9,573.7z"
          />
          <path
            class="st5"
            d="M82.4,574.8c-0.5-0.2-0.8-0.5-1.1-0.8c-0.3-0.4-0.4-0.8-0.4-1.2h1.3c0,0.4,0.2,0.7,0.5,0.9s0.7,0.4,1.3,0.4
		c0.5,0,0.9-0.1,1.1-0.3c0.3-0.2,0.4-0.5,0.4-0.8s-0.1-0.6-0.4-0.7s-0.8-0.3-1.4-0.5c-0.6-0.1-1-0.3-1.4-0.5s-0.7-0.4-0.9-0.7
		c-0.3-0.3-0.4-0.7-0.4-1.2c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.6-0.6,1-0.8s0.9-0.3,1.5-0.3c0.8,0,1.5,0.2,2.1,0.6
		c0.5,0.4,0.8,1,0.8,1.8h-1.3c0-0.4-0.2-0.7-0.5-1c-0.3-0.2-0.7-0.4-1.2-0.4s-0.8,0.1-1.1,0.3c-0.3,0.2-0.4,0.5-0.4,0.8
		s0.1,0.5,0.2,0.6c0.2,0.2,0.4,0.3,0.6,0.4c0.2,0.1,0.6,0.2,1,0.3c0.6,0.2,1,0.3,1.3,0.4s0.6,0.4,0.9,0.7c0.2,0.3,0.4,0.7,0.4,1.1
		c0,0.4-0.1,0.8-0.4,1.1c-0.2,0.3-0.6,0.6-1,0.8s-0.9,0.3-1.5,0.3C83.4,575.1,82.9,575,82.4,574.8z"
          />
        </g>
        <g>
          <line class="st2" x1="123.5" y1="823.2" x2="94.5" y2="823.2" />
          <circle class="st3" cx="94.8" cy="823.2" r="3.2" />
          <circle class="st4" cx="94.8" cy="823.2" r="1.7" />
        </g>
        <g>
          <path
            class="st5"
            d="M14.7,818.3v9.7h-1.3v-7.2l-3.2,7.2H9.3l-3.2-7.2v7.2H4.8v-9.7h1.4l3.6,8l3.6-8H14.7z"
          />
          <path
            class="st5"
            d="M16.9,822.1c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.9,0.7,1.1,1.1
		v-1.4h1.3v7.7H23v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4c-0.3-0.6-0.5-1.3-0.5-2.1
		C16.4,823.4,16.6,822.7,16.9,822.1z M22.6,822.7c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3s-0.7,0.6-0.9,1
		s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5s0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3s0.7-0.6,0.9-1c0.2-0.4,0.4-0.9,0.4-1.5
		C22.9,823.6,22.8,823.1,22.6,822.7z"
          />
          <path
            class="st5"
            d="M31.3,820.6c0.5,0.3,0.9,0.7,1.1,1.1v-1.4h1.3v7.8c0,0.7-0.1,1.3-0.4,1.9s-0.7,1-1.3,1.3
		c-0.6,0.3-1.2,0.5-1.9,0.5c-1,0-1.8-0.2-2.5-0.7s-1.1-1.1-1.2-1.9h1.3c0.1,0.5,0.4,0.8,0.9,1.1c0.4,0.3,1,0.4,1.6,0.4
		c0.7,0,1.3-0.2,1.7-0.7c0.4-0.4,0.7-1.1,0.7-1.8v-1.6c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.9-0.5
		s-1-0.8-1.3-1.4c-0.3-0.6-0.5-1.3-0.5-2.1s0.2-1.5,0.5-2.1s0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5
		C30.2,820.2,30.8,820.4,31.3,820.6z M32,822.7c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3s-0.7,0.6-0.9,1
		s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5s0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3s0.7-0.6,0.9-1c0.2-0.4,0.4-0.9,0.4-1.5
		C32.4,823.6,32.3,823.1,32,822.7z"
          />
          <path
            class="st5"
            d="M35.8,822.1c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5s1.3,0.1,1.8,0.4c0.5,0.3,0.9,0.7,1.1,1.1v-1.4
		h1.3v7.7h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4c-0.3-0.6-0.5-1.3-0.5-2.1
		C35.3,823.4,35.5,822.7,35.8,822.1z M41.5,822.7c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5s0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1s0.4-0.9,0.4-1.5
		C41.8,823.6,41.7,823.1,41.5,822.7z"
          />
          <path class="st5" d="M46.6,817.7V828h-1.3v-10.4h1.3V817.7z" />
          <path class="st5" d="M50,817.7V828h-1.3v-10.4H50V817.7z" />
          <path
            class="st5"
            d="M52.2,822.1c0.3-0.6,0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,1.9-0.5s1.3,0.1,1.8,0.4c0.5,0.3,0.9,0.7,1.1,1.1v-1.4
		h1.3v7.7h-1.3v-1.4c-0.3,0.4-0.6,0.8-1.1,1.1s-1.1,0.4-1.7,0.4c-0.7,0-1.3-0.2-1.8-0.5s-1-0.8-1.3-1.4c-0.3-0.6-0.5-1.3-0.5-2.1
		C51.7,823.4,51.8,822.7,52.2,822.1z M57.8,822.7c-0.2-0.4-0.5-0.8-0.9-1s-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.9,1
		s-0.4,0.9-0.4,1.5s0.1,1.1,0.4,1.5s0.5,0.8,0.9,1s0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.6,0.9-1s0.4-0.9,0.4-1.5
		C58.2,823.6,58.1,823.1,57.8,822.7z"
          />
          <path
            class="st5"
            d="M67.6,821c0.6,0.6,0.9,1.4,0.9,2.4v4.5h-1.3v-4.3c0-0.8-0.2-1.4-0.6-1.8c-0.4-0.4-0.9-0.6-1.6-0.6
		s-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.8v4.2h-1.3v-7.7h1.3v1.1c0.3-0.4,0.6-0.7,1-0.9s0.9-0.3,1.4-0.3
		C66.3,820.2,67.1,820.5,67.6,821z"
          />
          <path
            class="st5"
            d="M77.5,824.7h-6.1c0,0.8,0.3,1.3,0.8,1.8c0.5,0.4,1,0.6,1.7,0.6c0.6,0,1-0.1,1.4-0.4s0.6-0.6,0.8-1h1.4
		c-0.2,0.7-0.6,1.3-1.2,1.8s-1.4,0.7-2.3,0.7c-0.7,0-1.4-0.2-2-0.5s-1-0.8-1.4-1.4s-0.5-1.3-0.5-2.1s0.2-1.5,0.5-2.1
		s0.8-1.1,1.3-1.4c0.6-0.3,1.2-0.5,2-0.5c0.7,0,1.4,0.2,1.9,0.5c0.6,0.3,1,0.8,1.3,1.3c0.3,0.6,0.5,1.2,0.5,1.9
		C77.6,824.1,77.6,824.4,77.5,824.7z M76,822.4c-0.2-0.4-0.5-0.6-0.9-0.8s-0.8-0.3-1.2-0.3c-0.6,0-1.2,0.2-1.6,0.6
		c-0.5,0.4-0.7,1-0.8,1.7h4.8C76.3,823.1,76.2,822.7,76,822.4z"
          />
          <path
            class="st5"
            d="M80.4,827.8c-0.5-0.2-0.8-0.5-1.1-0.8c-0.3-0.4-0.4-0.8-0.4-1.2h1.3c0,0.4,0.2,0.7,0.5,0.9s0.7,0.4,1.3,0.4
		c0.5,0,0.9-0.1,1.1-0.3c0.3-0.2,0.4-0.5,0.4-0.8s-0.1-0.6-0.4-0.7s-0.8-0.3-1.4-0.5c-0.6-0.1-1-0.3-1.4-0.5s-0.7-0.4-0.9-0.7
		c-0.3-0.3-0.4-0.7-0.4-1.2c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.6-0.6,1-0.8s0.9-0.3,1.5-0.3c0.8,0,1.5,0.2,2.1,0.6
		c0.5,0.4,0.8,1,0.8,1.8h-1.3c0-0.4-0.2-0.7-0.5-1c-0.3-0.2-0.7-0.4-1.2-0.4s-0.8,0.1-1.1,0.3c-0.3,0.2-0.4,0.5-0.4,0.8
		s0.1,0.5,0.2,0.6c0.2,0.2,0.4,0.3,0.6,0.4c0.2,0.1,0.6,0.2,1,0.3c0.6,0.2,1,0.3,1.3,0.4s0.6,0.4,0.9,0.7c0.2,0.3,0.4,0.7,0.4,1.1
		c0,0.4-0.1,0.8-0.4,1.1c-0.2,0.3-0.6,0.6-1,0.8s-0.9,0.3-1.5,0.3C81.4,828.1,80.9,828,80.4,827.8z"
          />
        </g>
        <g id="Reticula" class="st6">
          <rect x="-80" y="-2365.8" class="st7" width="1366" height="3218.5" />
        </g>
      </svg>
    </div>
  );
};

export default SvgMap;



// WEBPACK FOOTER //
// ./src/features/common/SvgMap.js